export default function BtdData() {
  return (
    {
      "type" : "FeatureCollection", 
      "features" : [
        {
          "type" : "Feature", 
          "id" : 1, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0657093266009, 42.3085913539864], 
                [-71.0656988082272, 42.3085992674999], 
                [-71.0652515002163, 42.3089357536605]
              ], 
              [
                [-71.0643743034262, 42.3087458128067], 
                [-71.0645979246431, 42.3089524090161], 
                [-71.0648649443698, 42.3092026912259]
              ], 
              [
                [-71.0652515002163, 42.3089357536605], 
                [-71.0648649443698, 42.3092026912259]
              ], 
              [
                [-71.0652515002163, 42.3089357536605], 
                [-71.0655945120261, 42.309243151915], 
                [-71.0658473617274, 42.3094877496961]
              ], 
              [
                [-71.0662696444711, 42.3091922912203], 
                [-71.0658473617274, 42.3094877496961]
              ], 
              [
                [-71.0648649443698, 42.3092026912259], 
                [-71.0650766458412, 42.3094223803976], 
                [-71.0654396757088, 42.3097675560996]
              ], 
              [
                [-71.0658473617274, 42.3094877496961], 
                [-71.0654396757088, 42.3097675560996]
              ], 
              [
                [-71.0639586718088, 42.3095821265011], 
                [-71.0640755192711, 42.309652664044], 
                [-71.0645093462645, 42.3100099250548], 
                [-71.0648777956682, 42.3103112356132]
              ], 
              [
                [-71.0654396757088, 42.3097675560996], 
                [-71.0657416749342, 42.3100860503404]
              ], 
              [
                [-71.0673961210576, 42.3100814745352], 
                [-71.0673235461658, 42.3101257777222], 
                [-71.0672625685243, 42.3101463694928], 
                [-71.0671828026187, 42.3101426958316], 
                [-71.0670799006029, 42.3101141701441], 
                [-71.0669862530311, 42.3100890596894], 
                [-71.0669068734011, 42.3100853873535], 
                [-71.0668035572619, 42.3101165072048], 
                [-71.0665166668012, 42.3102757911776], 
                [-71.0663942767336, 42.3103242833855]
              ], 
              [
                [-71.0632748373837, 42.3100928675455], 
                [-71.0635695970863, 42.3103799860031], 
                [-71.0637231236599, 42.3105443094341]
              ], 
              [
                [-71.064226445222, 42.3102496829881], 
                [-71.0637231236599, 42.3105443094341]
              ], 
              [
                [-71.0663942767336, 42.3103242833855], 
                [-71.066295777361, 42.310344728278], 
                [-71.0662020561275, 42.3103584416846], 
                [-71.0661551245437, 42.3103757078312], 
                [-71.0661268572567, 42.3104071125288], 
                [-71.066126595847, 42.3104453742364], 
                [-71.0661497651948, 42.3104662834434], 
                [-71.0661776974102, 42.3104838312284], 
                [-71.0661964084193, 42.3104912177051], 
                [-71.0662291681811, 42.3104947153034], 
                [-71.0662621731829, 42.3104914654931], 
                [-71.0662856237034, 42.31047073433], 
                [-71.0663140535855, 42.3104427076893], 
                [-71.0663283215272, 42.3104078731662], 
                [-71.0663556348034, 42.3103770278199], 
                [-71.0663942767336, 42.3103242833855]
              ], 
              [
                [-71.0678315201028, 42.3103334582112], 
                [-71.0677958668675, 42.3103993327695], 
                [-71.0677237249636, 42.3106398956914], 
                [-71.0675460489802, 42.3112913794503]
              ], 
              [
                [-71.0637231236599, 42.3105443094341], 
                [-71.063054986396, 42.3109643496597], 
                [-71.0627375298594, 42.311173415113]
              ], 
              [
                [-71.0646718658725, 42.3106211382418], 
                [-71.0647537877348, 42.310626514501], 
                [-71.064825565821, 42.3106166501644], 
                [-71.0648803253241, 42.3105991150384], 
                [-71.0650003627039, 42.3105235311223], 
                [-71.0650516367437, 42.3105161194056], 
                [-71.0651027724429, 42.3105289891001], 
                [-71.0653641902754, 42.3107504885337], 
                [-71.0648332464167, 42.3110948445079], 
                [-71.0643754954906, 42.3113936295123], 
                [-71.0638346450108, 42.3117697061773], 
                [-71.0636498804215, 42.3118972844234]
              ], 
              [
                [-71.0687021349368, 42.3107709266447], 
                [-71.0685416527079, 42.3109546946325], 
                [-71.0683011234007, 42.3111805563807], 
                [-71.0678014409138, 42.3116378296576]
              ], 
              [
                [-71.0675460489802, 42.3112913794503], 
                [-71.0670831938267, 42.3111292707678], 
                [-71.0665129828102, 42.3109245557122], 
                [-71.0662737596534, 42.3108471260767]
              ], 
              [
                [-71.0675460489802, 42.3112913794503], 
                [-71.0675023288737, 42.3115320445867]
              ], 
              [
                [-71.0675023288737, 42.3115320445867], 
                [-71.06739318177, 42.3115845276037], 
                [-71.0672075673744, 42.3116766698856], 
                [-71.0670084405204, 42.311778330754], 
                [-71.0668272727854, 42.3118575495239]
              ], 
              [
                [-71.0678014409138, 42.3116378296576], 
                [-71.067660267972, 42.3115500816637], 
                [-71.0675872888383, 42.3115244861784], 
                [-71.0675023288737, 42.3115320445867]
              ], 
              [
                [-71.0678014409138, 42.3116378296576], 
                [-71.0679345505777, 42.3117114784632], 
                [-71.0680326052842, 42.3117855622974], 
                [-71.0680668149269, 42.3118273293273], 
                [-71.0681223433878, 42.3119108134817], 
                [-71.0681900278512, 42.3120742507332], 
                [-71.0682488091118, 42.312292229959], 
                [-71.068325080571, 42.3124753903296], 
                [-71.068362542115, 42.3126903768774]
              ], 
              [
                [-71.0668272727854, 42.3118575495239], 
                [-71.0666216511118, 42.311744798994], 
                [-71.0657682345239, 42.3113251904588], 
                [-71.0656694512837, 42.3112764246648], 
                [-71.0656034817042, 42.3112422316558], 
                [-71.0655619220459, 42.3112855834085], 
                [-71.0654232149795, 42.3114201039215], 
                [-71.0650308119988, 42.3117899918333], 
                [-71.0644722117073, 42.3122942972362], 
                [-71.0643668087818, 42.3123834033325]
              ], 
              [
                [-71.0668272727854, 42.3118575495239], 
                [-71.0665617173127, 42.3119718968183], 
                [-71.0661406841256, 42.3121785063538]
              ], 
              [
                [-71.0661406841256, 42.3121785063538], 
                [-71.0652317148222, 42.3126173423558], 
                [-71.0648583624137, 42.3127916036576]
              ], 
              [
                [-71.068362542115, 42.3126903768774], 
                [-71.0680432332523, 42.3127556743604], 
                [-71.067392751477, 42.3128398813557]
              ], 
              [
                [-71.0684385952836, 42.312715077093], 
                [-71.068362542115, 42.3126903768774]
              ], 
              [
                [-71.067392751477, 42.3128398813557], 
                [-71.0672814789594, 42.3127595617696], 
                [-71.0669941896467, 42.3126144314423], 
                [-71.0664150529695, 42.3123269637954], 
                [-71.0661406841256, 42.3121785063538]
              ], 
              [
                [-71.067392751477, 42.3128398813557], 
                [-71.0667444570994, 42.3129364725122], 
                [-71.066509429075, 42.3129935405804]
              ], 
              [
                [-71.066509429075, 42.3129935405804], 
                [-71.0662097295366, 42.3131105741666], 
                [-71.0658254401395, 42.3132919977164], 
                [-71.0655146500007, 42.313423614358], 
                [-71.0653044972248, 42.3135199262857]
              ], 
              [
                [-71.066509429075, 42.3129935405804], 
                [-71.0666281171852, 42.3132916483042], 
                [-71.0667507659676, 42.3135937130516], 
                [-71.0668479466134, 42.3138501027578], 
                [-71.0668604601453, 42.3139047294507], 
                [-71.0668515614341, 42.3139592777118], 
                [-71.066790562233, 42.3140648321859], 
                [-71.0667427431138, 42.3141287983688], 
                [-71.0666693211107, 42.3141667847981], 
                [-71.0664666297416, 42.3142335408187], 
                [-71.0659231184519, 42.3144154878973], 
                [-71.0658137494644, 42.314449355019]
              ], 
              [
                [-71.0662589473327, 42.3137561641321], 
                [-71.0657068104197, 42.3139527020571], 
                [-71.0655659887192, 42.3139971719092]
              ], 
              [
                [-71.0672942979185, 42.3146184233183], 
                [-71.0672187055856, 42.3146223777035], 
                [-71.0668715579323, 42.3146655238622], 
                [-71.0663935688612, 42.3147447482979], 
                [-71.0660602777211, 42.3148121400718], 
                [-71.0659536306289, 42.3148277875103]
              ], 
              [
                [-71.0668200826699, 42.3151483352862], 
                [-71.0667138658707, 42.3150802158402], 
                [-71.0666039992165, 42.3150664396932], 
                [-71.0660559819774, 42.3151737678822]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 1, 
            "OBJECTID" : 1, 
            "Name" : "Hancock Street Triangle Neighborhood Slow Streets", 
            "Shape_Leng" : 4263.58407854, 
            "Shape__Length" : 4263.58407854, 
            "Link" : "https://www.boston.gov/slow-streets/hancock", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 2, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.126040100234, 42.2852099332108], 
                [-71.1258760310321, 42.2852849999047], 
                [-71.1255652426899, 42.2854606713295], 
                [-71.1253991235326, 42.28555128345], 
                [-71.1251270903084, 42.285773221653], 
                [-71.1245133047124, 42.2862461240079]
              ], 
              [
                [-71.1266028210976, 42.2855720480723], 
                [-71.1258892721994, 42.2862179782589]
              ], 
              [
                [-71.1258892721994, 42.2862179782589], 
                [-71.1253172160434, 42.2867152208535]
              ], 
              [
                [-71.1245133047124, 42.2862461240079], 
                [-71.1239198991953, 42.2867320336073]
              ], 
              [
                [-71.1253172160434, 42.2867152208535], 
                [-71.1245133047124, 42.2862461240079]
              ], 
              [
                [-71.1239198991953, 42.2867320336073], 
                [-71.1233452100771, 42.2871915572136]
              ], 
              [
                [-71.1273031432015, 42.28706460941], 
                [-71.1265769334477, 42.2866118468082], 
                [-71.1258892721994, 42.2862179782589]
              ], 
              [
                [-71.1233452100771, 42.2871915572136], 
                [-71.1229775386145, 42.2874992683083], 
                [-71.122811512882, 42.2875735593992], 
                [-71.1226673988559, 42.2875944695566], 
                [-71.1225507930405, 42.2876028847882]
              ], 
              [
                [-71.1233452100771, 42.2871915572136], 
                [-71.1239767877056, 42.2875531835357], 
                [-71.1250535497277, 42.2881790360658], 
                [-71.125738823254, 42.2885794939186]
              ], 
              [
                [-71.1267547441784, 42.2875956817009], 
                [-71.1263150745424, 42.2872924096468], 
                [-71.1253172160434, 42.2867152208535]
              ], 
              [
                [-71.1262269363383, 42.2881068097732], 
                [-71.1255532924017, 42.2877057554708], 
                [-71.1244625184579, 42.2870477920931], 
                [-71.1239198991953, 42.2867320336073]
              ], 
              [
                [-71.1214443677494, 42.2888469284764], 
                [-71.1214029895508, 42.2888205588754]
              ], 
              [
                [-71.1214443677494, 42.2888469284764], 
                [-71.1209815395454, 42.2892224035231], 
                [-71.1209268905351, 42.2892868960083]
              ], 
              [
                [-71.1246497650923, 42.2897211727521], 
                [-71.1243133828493, 42.2895124414243], 
                [-71.1241641448329, 42.2894387998755], 
                [-71.1239284340888, 42.2893783851264], 
                [-71.1232442026083, 42.2892343452272], 
                [-71.1221055969688, 42.2890032811572], 
                [-71.1216340856492, 42.2888987572268], 
                [-71.1214443677494, 42.2888469284764]
              ], 
              [
                [-71.1241366689616, 42.2902062162515], 
                [-71.1237806782926, 42.290012612503], 
                [-71.1236429485932, 42.2899474522456], 
                [-71.1232061499728, 42.2898346073192], 
                [-71.1221825843853, 42.2895954806949], 
                [-71.121354618866, 42.2894081947848], 
                [-71.1209254262811, 42.2892913703219]
              ], 
              [
                [-71.1235959110083, 42.2907209959428], 
                [-71.1232882739561, 42.290520232224], 
                [-71.1208677840843, 42.2898732948665], 
                [-71.1225219732895, 42.2902688131699]
              ], 
              [
                [-71.1235126219101, 42.2924254515979], 
                [-71.1236866372588, 42.2922259997267], 
                [-71.1239194455461, 42.2919218595254], 
                [-71.1242316244804, 42.2912177949812], 
                [-71.1257799166866, 42.2898126751946], 
                [-71.1258910068462, 42.2888578455318]
              ], 
              [
                [-71.1235126219101, 42.2924254515979], 
                [-71.1230721123493, 42.2921721356787], 
                [-71.1224640633947, 42.2917572250058], 
                [-71.1224195303128, 42.2916957678714], 
                [-71.1223682212388, 42.291671472069]
              ], 
              [
                [-71.1235228402465, 42.2924313277873], 
                [-71.1235126219101, 42.2924254515979]
              ], 
              [
                [-71.1213148324821, 42.2927358722015], 
                [-71.1213931817445, 42.2927816342074], 
                [-71.1218567303974, 42.2930504383903], 
                [-71.1225029811078, 42.2934064932055], 
                [-71.1228104798194, 42.2935363586298]
              ], 
              [
                [-71.1230669146971, 42.2929363079064], 
                [-71.1235126219101, 42.2924254515979]
              ], 
              [
                [-71.1230669146971, 42.2929363079064], 
                [-71.1224574248448, 42.2925938208548], 
                [-71.1219144255949, 42.2922729947569]
              ], 
              [
                [-71.1230819192573, 42.2929447397012], 
                [-71.1230669146971, 42.2929363079064]
              ], 
              [
                [-71.1228318157057, 42.2935380876331], 
                [-71.1228079645366, 42.2932331072032], 
                [-71.1230669146971, 42.2929363079064]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 2, 
            "OBJECTID" : 2, 
            "Name" : "Lower South Street Neighborhood Slow Streets", 
            "Shape_Leng" : 4223.4003161, 
            "Shape__Length" : 4694.55242912, 
            "Link" : "https://www.boston.gov/departments/transportation/lower-south-street-neighborhood", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 3, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0801711893755, 42.321020102662], 
                [-71.0795732114336, 42.3214874294398]
              ], 
              [
                [-71.0795732114336, 42.3214874294398], 
                [-71.0794186482042, 42.3214131524537], 
                [-71.0788780205066, 42.3211579671988], 
                [-71.0784917485277, 42.3209804306435], 
                [-71.0779727208212, 42.3207286901837], 
                [-71.077801137212, 42.3206696657434]
              ], 
              [
                [-71.0795732114336, 42.3214874294398], 
                [-71.0790407224726, 42.3219181890653], 
                [-71.0785172184609, 42.3223371564383]
              ], 
              [
                [-71.0786667367518, 42.3217040709234], 
                [-71.0776112369542, 42.3213208005924]
              ], 
              [
                [-71.0817644153123, 42.3218128397149], 
                [-71.0812677188254, 42.3220529239675], 
                [-71.0808912672292, 42.3222366570206]
              ], 
              [
                [-71.0808912672292, 42.3222366570206], 
                [-71.0803794413163, 42.3218763344171]
              ], 
              [
                [-71.0808912672292, 42.3222366570206], 
                [-71.0806631167066, 42.3223540081675], 
                [-71.0805826060976, 42.3223750973975], 
                [-71.080513767299, 42.322379350843], 
                [-71.0804275685576, 42.3224004141613], 
                [-71.0802812725237, 42.3224792190574], 
                [-71.0800561996293, 42.322659583459]
              ], 
              [
                [-71.0785172184609, 42.3223371564383], 
                [-71.0783065410689, 42.3221771438241], 
                [-71.078183338026, 42.3220900375189], 
                [-71.0781138775933, 42.3220458948531], 
                [-71.0779745066719, 42.3219953055307], 
                [-71.0775879202827, 42.3218931623589], 
                [-71.0774073598089, 42.3218499507512]
              ], 
              [
                [-71.0785172184609, 42.3223371564383], 
                [-71.077817429058, 42.322895023189], 
                [-71.0775165554216, 42.3232697911087]
              ], 
              [
                [-71.0800561996293, 42.322659583459], 
                [-71.0794904918673, 42.3222692599706]
              ], 
              [
                [-71.0800561996293, 42.322659583459], 
                [-71.0796177777532, 42.3230120981378]
              ], 
              [
                [-71.0821711194724, 42.3226989057231], 
                [-71.0818484823515, 42.3227775302521], 
                [-71.081176061022, 42.3228988694569], 
                [-71.0810266541223, 42.3229326483264], 
                [-71.0808944661299, 42.3229709927476], 
                [-71.0808079314186, 42.3230134437646], 
                [-71.0806927422463, 42.3230895460158], 
                [-71.0803468028271, 42.3233167357378], 
                [-71.0800183446232, 42.3235079742498]
              ], 
              [
                [-71.0796177777532, 42.3230120981378], 
                [-71.0791980974289, 42.322727984948]
              ], 
              [
                [-71.0796177777532, 42.3230120981378], 
                [-71.079473455318, 42.3231216683234]
              ], 
              [
                [-71.079473455318, 42.3231216683234], 
                [-71.0792427176473, 42.3233162807774]
              ], 
              [
                [-71.0775165554216, 42.3232697911087], 
                [-71.0770372296573, 42.3230598346601], 
                [-71.0768137943916, 42.3229624467497]
              ], 
              [
                [-71.0823595060689, 42.323288263842], 
                [-71.0819822163445, 42.3233665827781], 
                [-71.081435964295, 42.3235272133696], 
                [-71.081039244011, 42.3236366139582], 
                [-71.0806308141873, 42.3237673568334], 
                [-71.0802511672836, 42.3239027034609]
              ], 
              [
                [-71.0792427176473, 42.3233162807774], 
                [-71.0786490785682, 42.3229639358403]
              ], 
              [
                [-71.0792427176473, 42.3233162807774], 
                [-71.0791964678849, 42.3233552924611], 
                [-71.0790577159028, 42.3234960204484], 
                [-71.0789766896608, 42.3235941925853], 
                [-71.0788088340601, 42.3238068371419]
              ], 
              [
                [-71.0800183446232, 42.3235079742498], 
                [-71.0798871232181, 42.3234005805742], 
                [-71.079624259098, 42.3232201259762], 
                [-71.079473455318, 42.3231216683234]
              ], 
              [
                [-71.0800183446232, 42.3235079742498], 
                [-71.0801150329922, 42.3236495593421], 
                [-71.0802511672836, 42.3239027034609]
              ], 
              [
                [-71.0768998494026, 42.3236088947148], 
                [-71.076757272394, 42.3238792815141]
              ], 
              [
                [-71.0763805818459, 42.3237255811233], 
                [-71.0763234624685, 42.3237022746765]
              ], 
              [
                [-71.0763805818459, 42.3237255811233], 
                [-71.076110589594, 42.324088668029]
              ], 
              [
                [-71.0788088340601, 42.3238068371419], 
                [-71.0783331842019, 42.3236126545966], 
                [-71.0778468336122, 42.3234026760461], 
                [-71.0775165554216, 42.3232697911087]
              ], 
              [
                [-71.076757272394, 42.3238792815141], 
                [-71.0763805818459, 42.3237255811233]
              ], 
              [
                [-71.0802511672836, 42.3239027034609], 
                [-71.0796008948157, 42.3241698545052]
              ], 
              [
                [-71.0825946688406, 42.3240239495046], 
                [-71.0821127469452, 42.3240957347727], 
                [-71.081707079441, 42.324181475431], 
                [-71.0808967119181, 42.3243495817753], 
                [-71.0801548633936, 42.3245606928837]
              ], 
              [
                [-71.0796008948157, 42.3241698545052], 
                [-71.0794079923883, 42.3240723680237], 
                [-71.0792006181016, 42.3239849541756], 
                [-71.0788088340601, 42.3238068371419]
              ], 
              [
                [-71.0796008948157, 42.3241698545052], 
                [-71.0794451790478, 42.3242671913984], 
                [-71.0786548098198, 42.3248753717175]
              ], 
              [
                [-71.0762412648234, 42.324400420923], 
                [-71.0759633440408, 42.3242969778988], 
                [-71.0759490590312, 42.3242893492937]
              ], 
              [
                [-71.0801548633936, 42.3245606928837], 
                [-71.0797112636282, 42.3242484685619], 
                [-71.0796008948157, 42.3241698545052]
              ], 
              [
                [-71.0801548633936, 42.3245606928837], 
                [-71.0800684921756, 42.3246070799817], 
                [-71.0797685932113, 42.3248366857504], 
                [-71.0792433401798, 42.3252579044361]
              ], 
              [
                [-71.0828167350738, 42.3247186564766], 
                [-71.0827802742531, 42.3247188032562], 
                [-71.0827242921429, 42.3247281646052], 
                [-71.0826636271151, 42.3247566431551]
              ], 
              [
                [-71.0826636271151, 42.3247566431551], 
                [-71.0825133937653, 42.3247144549938], 
                [-71.0824145889655, 42.3246628941562], 
                [-71.0823290513841, 42.3246113804319], 
                [-71.082260176653, 42.3245919961921], 
                [-71.082195772837, 42.3245850092036], 
                [-71.0820707444175, 42.3246008727214], 
                [-71.0817819549182, 42.3246701594197], 
                [-71.0815835862422, 42.3247110744139]
              ], 
              [
                [-71.0826636271151, 42.3247566431551], 
                [-71.0825729520686, 42.3248238342573], 
                [-71.0823867555647, 42.3249733969155], 
                [-71.0821054139975, 42.3252064496446]
              ], 
              [
                [-71.0786548098198, 42.3248753717175], 
                [-71.0783586191009, 42.3246610305187], 
                [-71.0781110955109, 42.3244828728926], 
                [-71.0779745390113, 42.3244069735685], 
                [-71.0774684982488, 42.3241935466596], 
                [-71.0769574610567, 42.3239609650591], 
                [-71.076757272394, 42.3238792815141]
              ], 
              [
                [-71.0786548098198, 42.3248753717175], 
                [-71.0780779306089, 42.3253346588289], 
                [-71.0777352412943, 42.325581545834]
              ], 
              [
                [-71.0754816098933, 42.3252181905912], 
                [-71.0753426800447, 42.3252493202278]
              ], 
              [
                [-71.0792433401798, 42.3252579044361], 
                [-71.0790477113655, 42.3251435268212], 
                [-71.0786548098198, 42.3248753717175]
              ], 
              [
                [-71.0812052814216, 42.3253022042455], 
                [-71.080539834612, 42.32482431046], 
                [-71.0801548633936, 42.3245606928837]
              ], 
              [
                [-71.0812052814216, 42.3253022042455], 
                [-71.0810666767632, 42.3254204263573], 
                [-71.0808091639072, 42.3256327459487], 
                [-71.0807685681412, 42.3256630166329]
              ], 
              [
                [-71.0805205989868, 42.3254686684652], 
                [-71.0807424011153, 42.3256362679434], 
                [-71.0807685681412, 42.3256630166329]
              ], 
              [
                [-71.0777352412943, 42.325581545834], 
                [-71.0775513094433, 42.3254475112002], 
                [-71.0772464796263, 42.3252201916924], 
                [-71.0768369035523, 42.3249525363628], 
                [-71.0767714370294, 42.3249342839546], 
                [-71.0766938791827, 42.3249385026909], 
                [-71.0759773317081, 42.3251046670099], 
                [-71.0754816098933, 42.3252181905912]
              ], 
              [
                [-71.0807685681412, 42.3256630166329], 
                [-71.0803187879666, 42.325998389442]
              ], 
              [
                [-71.0781803565176, 42.3258937814721], 
                [-71.0777352412943, 42.325581545834]
              ], 
              [
                [-71.0781803565176, 42.3258937814721], 
                [-71.0779308961598, 42.3260820912338]
              ], 
              [
                [-71.0781803565176, 42.3258937814721], 
                [-71.078844970589, 42.326353118929], 
                [-71.0793078167593, 42.3266806093632], 
                [-71.0794548862427, 42.3268009992911], 
                [-71.0794903014245, 42.3268635830745], 
                [-71.0794921771068, 42.3269009361985]
              ], 
              [
                [-71.0831711474028, 42.3259383697382], 
                [-71.0821931434682, 42.3257295007753], 
                [-71.0818740133702, 42.3256563166767], 
                [-71.0817625836474, 42.325622151405], 
                [-71.0816056650353, 42.325557433794], 
                [-71.0812052814216, 42.3253022042455]
              ], 
              [
                [-71.0803187879666, 42.325998389442], 
                [-71.0801980570874, 42.3259366157229], 
                [-71.0797750404201, 42.3256357233392], 
                [-71.0792433401798, 42.3252579044361]
              ], 
              [
                [-71.0803187879666, 42.325998389442], 
                [-71.0803189110358, 42.3261508781914], 
                [-71.0803582168211, 42.3263699051606], 
                [-71.0805263679675, 42.3270277339597], 
                [-71.080625186242, 42.3274208484974], 
                [-71.0808132701063, 42.3281614680983], 
                [-71.080871698329, 42.3284193206185]
              ], 
              [
                [-71.0766816216706, 42.3260453825104], 
                [-71.0761274006662, 42.3256532788493], 
                [-71.0754816098933, 42.3252181905912]
              ], 
              [
                [-71.0766816216706, 42.3260453825104], 
                [-71.0763044873548, 42.3263381218967]
              ], 
              [
                [-71.0779308961598, 42.3260820912338], 
                [-71.0774001840664, 42.3257025488839]
              ], 
              [
                [-71.0779308961598, 42.3260820912338], 
                [-71.0777004145091, 42.3262560748303], 
                [-71.0773636100579, 42.3265299927857]
              ], 
              [
                [-71.0820673514806, 42.3263733341339], 
                [-71.0818992820809, 42.3263366946514], 
                [-71.08124351911, 42.3261981381322], 
                [-71.0806303641313, 42.3260676101789], 
                [-71.0803694655251, 42.3260177055055], 
                [-71.0803187879666, 42.325998389442]
              ], 
              [
                [-71.0820673514806, 42.3263733341339], 
                [-71.0819901376887, 42.3265143349741], 
                [-71.0819539481592, 42.326601096442], 
                [-71.0819431414263, 42.3267030526528], 
                [-71.0819734263295, 42.3267703280143], 
                [-71.0820236906629, 42.326829267699], 
                [-71.0820953214253, 42.3268761771294], 
                [-71.0821939393755, 42.3269198548304], 
                [-71.0822342665453, 42.3269727752996], 
                [-71.082245463147, 42.3274682668759], 
                [-71.0822535884087, 42.3274681619431], 
                [-71.0829351150619, 42.3274593867663]
              ], 
              [
                [-71.0800575560854, 42.3264942187718], 
                [-71.0794921771068, 42.3269009361985]
              ], 
              [
                [-71.0773636100579, 42.3265299927857], 
                [-71.0766816216706, 42.3260453825104]
              ], 
              [
                [-71.0773636100579, 42.3265299927857], 
                [-71.0769096266662, 42.326891816255], 
                [-71.0767737187502, 42.3270036789256]
              ], 
              [
                [-71.0830219048948, 42.3265808222017], 
                [-71.0827628684961, 42.3265249599181], 
                [-71.0820673514806, 42.3263733341339]
              ], 
              [
                [-71.0794921771068, 42.3269009361985], 
                [-71.0794956571802, 42.3269699540446], 
                [-71.0794449382993, 42.3274137250118], 
                [-71.0793881791463, 42.3278811105602]
              ], 
              [
                [-71.0781925250964, 42.3271120387455], 
                [-71.0776406082707, 42.3267240109178], 
                [-71.0773636100579, 42.3265299927857]
              ], 
              [
                [-71.0781925250964, 42.3271120387455], 
                [-71.077701049618, 42.3274962347965], 
                [-71.0775480773049, 42.3276468424192]
              ], 
              [
                [-71.0783512106947, 42.327740758981], 
                [-71.0780947353929, 42.3279569983875]
              ], 
              [
                [-71.0793881791463, 42.3278811105602], 
                [-71.0787267379246, 42.327455549411], 
                [-71.0781925250964, 42.3271120387455]
              ], 
              [
                [-71.0793881791463, 42.3278811105602], 
                [-71.0793642022131, 42.3280380091914]
              ], 
              [
                [-71.0827525432602, 42.3279953676398], 
                [-71.0815099396603, 42.3278794236759]
              ], 
              [
                [-71.0793642022131, 42.3280380091914], 
                [-71.0792813317298, 42.3284415653796]
              ], 
              [
                [-71.0793642022131, 42.3280380091914], 
                [-71.0800071534114, 42.3280751437848], 
                [-71.0799995132399, 42.3284315198735]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 3, 
            "OBJECTID" : 3, 
            "Name" : "Moreland St and Mount Pleasant Ave Neighborhood Slow Streets", 
            "Shape_Leng" : 8433.54745068, 
            "Shape__Length" : 8433.54745068, 
            "Link" : "https://www.boston.gov/departments/transportation/moreland-and-mt-pleasant-street", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 7, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0501870385659, 42.3548054322502], 
              [-71.0485133397493, 42.3541394372106]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 7, 
            "OBJECTID" : null, 
            "Name" : "Northern Avenue Bridge", 
            "Shape_Leng" : null, 
            "Shape__Length" : 211.60859961, 
            "Link" : "https://www.northernavebridgebos.com/", 
            "GlobalID" : "13c4cdd0-b414-443c-bf75-fe95bb2a6979", 
            "CreationDa" : 1588896000000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bridge Reconstruction", 
            "Descriptio" : "We're redesigning a replacement for the bridge connecting the North End and the Seaport.", 
            "ProjectTyp" : "Bridge Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 8, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0585487000626, 42.3668311002361], 
              [-71.0584198996172, 42.3651664996735]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 8, 
            "OBJECTID" : null, 
            "Name" : "North Washington Street Bus Lane", 
            "Shape_Leng" : null, 
            "Shape__Length" : 251.20621604, 
            "Link" : "https://www.boston.gov/north-washington-street-bus-lane", 
            "GlobalID" : "5243eeaf-014b-4526-aef5-b6335bff26f5", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bus Lane", 
            "Descriptio" : "We recently completed a southbound bus lane along North Washington Street. The bus lane will improve travel for the 17,000 bus riders along this high-priority street.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 9, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.102803112074, 42.3461847173837], 
              [-71.1020769105268, 42.346594840715], 
              [-71.1014796822429, 42.3469193545467], 
              [-71.1013750584084, 42.347037422566]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 9, 
            "OBJECTID" : null, 
            "Name" : "Fenway-Yawkey Multi-Use Path", 
            "Shape_Leng" : null, 
            "Shape__Length" : 420.55557927, 
            "Link" : "https://www.boston.gov/departments/transportation/fenway-yawkey-multi-use-path", 
            "GlobalID" : "6aa9de98-b4d6-4082-b3d4-4048a4378e46", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "The path will help bridge a gap in our bike network and connect the Emerald Necklace to the Fenway neighborhood.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 10, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.056802340116, 42.358860404238], 
                [-71.0558997299865, 42.358982806272], 
                [-71.0558987121953, 42.358982945006], 
                [-71.0554385987, 42.3590724151155], 
                [-71.0554380246765, 42.3590725040644], 
                [-71.0546383102746, 42.3591955455855], 
                [-71.0546374056711, 42.3591957268021]
              ], 
              [
                [-71.0542945869991, 42.3592646501279], 
                [-71.0542934937495, 42.3592648705082], 
                [-71.0542320858149, 42.3592502258346], 
                [-71.0540239578417, 42.3592528219421], 
                [-71.0540223256028, 42.3592528425198], 
                [-71.0536646748472, 42.359305650815], 
                [-71.0535602591701, 42.3593230820897], 
                [-71.0535600031503, 42.3593231020035], 
                [-71.0533399913642, 42.3593400633062], 
                [-71.0531795558477, 42.3593637893412], 
                [-71.0531682262953, 42.3593654654239], 
                [-71.0525778786434, 42.3594921419702], 
                [-71.052531794171, 42.3595015671777], 
                [-71.0524486470067, 42.3595197657433], 
                [-71.0524364604615, 42.3595223498914], 
                [-71.0523692089861, 42.3595366075101], 
                [-71.0522948644132, 42.359552782824], 
                [-71.0522114908733, 42.3595702943491], 
                [-71.0520679257179, 42.3595971766315], 
                [-71.0517649078029, 42.3596412743562]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 10, 
            "OBJECTID" : null, 
            "Name" : "State Street Design Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 535.4211633, 
            "Link" : "https://www.boston.gov/state-street", 
            "GlobalID" : "ab01d479-f524-4b2b-8181-f0299161a0c5", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Streetscape", 
            "Descriptio" : "State Street is one of the oldest streets in Boston. We want to update State Street for all the locals and visitors from around the world who use it.", 
            "ProjectTyp" : "Street Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 11, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0622487259706, 42.3712327156581], 
              [-71.0612660283386, 42.3707177774854], 
              [-71.0586481920736, 42.3672141828262], 
              [-71.0585487000626, 42.3668311002361]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 11, 
            "OBJECTID" : null, 
            "Name" : "North Washington Street Bridge", 
            "Shape_Leng" : null, 
            "Shape__Length" : 795.87479671, 
            "Link" : "https://www.boston.gov/departments/public-works/north-washington-street-bridge", 
            "GlobalID" : "de5e9533-a663-40fd-a3b9-28101a16e5e1", 
            "CreationDa" : 1588896000000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bridge Reconstruction", 
            "Descriptio" : "We're redesigning a replacement for the bridge in Charlestown", 
            "ProjectTyp" : "Bridge Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 12, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0632385741923, 42.3463422629389], 
                [-71.0629605770529, 42.347058333518], 
                [-71.0627853292157, 42.3474619263397], 
                [-71.0625900588291, 42.3479482232641], 
                [-71.0625559677641, 42.3480517694696]
              ], 
              [
                [-71.0625559677641, 42.3480517694696], 
                [-71.0629729001419, 42.3470396002034]
              ], 
              [
                [-71.0625559677641, 42.3480517694696], 
                [-71.0625099479704, 42.3481915472485]
              ], 
              [
                [-71.0615031000303, 42.3506076999348], 
                [-71.0625559677641, 42.3480517694696]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 12, 
            "OBJECTID" : null, 
            "Name" : "Harrison Avenue Safety Improvements", 
            "Shape_Leng" : null, 
            "Shape__Length" : 851.96544735, 
            "Link" : "https://www.boston.gov/departments/transportation/harrison-avenue-safety-improvements", 
            "GlobalID" : "cd5ff3de-a3ed-4d3a-8676-5707961b5fe4", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We are working with Chinatown residents to make streets feel safer for people of all ages who walk, play, and live along Harrison Avenue between Essex Street to Herald Street", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 13, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0827315406489, 42.3310545584637], 
              [-71.0832922942021, 42.3314637088507], 
              [-71.0840208979661, 42.3320326964393], 
              [-71.0845404080679, 42.33242505386], 
              [-71.0850249575356, 42.3327100064788], 
              [-71.0864621308361, 42.3335360101486], 
              [-71.0866592903797, 42.3336509489142], 
              [-71.0870356485512, 42.3338682411313], 
              [-71.0874515954771, 42.3341227147538], 
              [-71.087650932537, 42.3342446675821], 
              [-71.0882407672509, 42.3345768662669], 
              [-71.0883819662439, 42.3347129108022], 
              [-71.0884667734949, 42.3349110978566]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 13, 
            "OBJECTID" : null, 
            "Name" : "Ruggles Street", 
            "Shape_Leng" : null, 
            "Shape__Length" : 869.6272809, 
            "Link" : "https://www.boston.gov/departments/public-works/ruggles-street-project", 
            "GlobalID" : "3d04f715-0af2-44be-95b4-6ea18ffb96d2", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "We will redesign Ruggles Street to improve access and safety for everyone.", 
            "ProjectTyp" : "Street Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 15, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1376612565183, 42.3485139745255], 
              [-71.1365302380497, 42.3481925331596], 
              [-71.1361080613072, 42.3481422012187], 
              [-71.1352068390748, 42.3483166456273], 
              [-71.1303788633432, 42.3504575170823], 
              [-71.1297565904645, 42.3505209490115], 
              [-71.1286837073678, 42.3504575170823], 
              [-71.1278254003515, 42.3504575170823], 
              [-71.1273318740193, 42.3505685232483], 
              [-71.1268598048459, 42.3506636716139], 
              [-71.1265379393779, 42.3508063932284]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 15, 
            "OBJECTID" : null, 
            "Name" : "Commonwealth Avenue (Packard's Corner to Warren/Kelton Streets)", 
            "Shape_Leng" : null, 
            "Shape__Length" : 1351.9396475, 
            "Link" : "https://www.boston.gov/commonwealth-avenue-phase-3-and-4", 
            "GlobalID" : "caedea68-9426-4834-8698-e5a9f06cd2ad", 
            "CreationDa" : 1589414400000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "Public Works is redesigning Commonwealth Avenue. Our focus will be between Brighton Avenue (Packard’s Corner) and Warren/Kelton Streets.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 16, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1373375000966, 42.3535836001582], 
              [-71.1246560002987, 42.3521247000999]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 16, 
            "OBJECTID" : null, 
            "Name" : "Brighton Avenue Bus-Bike Lane Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 1428.70063333, 
            "Link" : "https://www.boston.gov/departments/transportation/brighton-avenue-bus-lane", 
            "GlobalID" : "7f1cf9ea-fbf2-4fe9-8637-6d0f8089b6b5", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bus Lane", 
            "Descriptio" : "We aim to improve the commutes of bus passengers and the 1,300 daily bike riders along this key corridor, while improving pedestrian safety.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 17, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.098439099923, 42.3224138001544], 
              [-71.0983746997003, 42.3185902000042], 
              [-71.0982888998109, 42.3156549001516], 
              [-71.0950916995949, 42.3133541000481]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 17, 
            "OBJECTID" : null, 
            "Name" : "Columbus Avenue Bus Lanes (Franklin Park to Jackson Square)", 
            "Shape_Leng" : null, 
            "Shape__Length" : 1514.34608357, 
            "Link" : "https://www.boston.gov/departments/transportation/columbus-avenue-bus-lanes", 
            "GlobalID" : "9735c3b2-85a7-45a7-bebe-6db666f472f5", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1624910220000, 
            "Editor" : "163175_boston", 
            "Symbol" : "Bus Lane", 
            "Descriptio" : "We are constructing transit improvements along Columbus Avenue, between Jackson Square and Walnut Avenue.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 18, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1246560002987, 42.3521247000999], 
              [-71.1109815998038, 42.3505368000129]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 18, 
            "OBJECTID" : null, 
            "Name" : "Commonwealth Avenue (BU Bridge to Packard's Corner)", 
            "Shape_Leng" : null, 
            "Shape__Length" : 1540.90405977, 
            "Link" : "https://www.boston.gov/departments/transportation/commonwealth-ave-phase-2a", 
            "GlobalID" : "64e7d2e4-d8d9-408c-8956-ebad7399dbd9", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "We are transforming Commonwealth Avenue between the BU Bridge and Packard's Corner with a multi-modal vision aligned with our Vision Zero goals.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 20, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0686107996286, 42.3474494001432], 
              [-71.0698629999307, 42.3451541999118], 
              [-71.0705365998499, 42.344563099956], 
              [-71.0752250995572, 42.3420414001259], 
              [-71.0802783997114, 42.3393688997748]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 20, 
            "OBJECTID" : null, 
            "Name" : "Tremont Street Design Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 1826.31579886, 
            "Link" : "https://www.boston.gov/departments/transportation/tremont-street-design-project", 
            "GlobalID" : "ad3c8099-40ae-4e1c-9f1e-5f287ca602f6", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "We want to improve pedestrian safety on Tremont Street in the South End.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 21, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1328326465761, 42.3555262617146], 
              [-71.1237775090362, 42.3588402366486], 
              [-71.1211596727713, 42.3601562648272], 
              [-71.1177479036615, 42.3609648946487]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 21, 
            "OBJECTID" : null, 
            "Name" : "Cambridge Street (Allston) Safety Improvements", 
            "Shape_Leng" : null, 
            "Shape__Length" : 1876.18298302, 
            "Link" : "https://www.boston.gov/departments/transportation/cambridge-street-allston-safety-improvements", 
            "GlobalID" : "c2c43077-c707-492d-937a-d21d95d50ba2", 
            "CreationDa" : 1589328000000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "We are making safety improvements for Cambridge Street, between Harvard Avenue and Soldiers Field Road, in Allston.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 23, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0851646635285, 42.328886470239], 
                [-71.0851924996242, 42.3288910001811], 
                [-71.0861580996215, 42.329073400309], 
                [-71.0851603004112, 42.3288830002274], 
                [-71.0851646635285, 42.328886470239]
              ], 
              [
                [-71.0851646635285, 42.328886470239], 
                [-71.0858684001289, 42.3294462001893], 
                [-71.0851603004112, 42.3288910001811], 
                [-71.0839908996255, 42.3303901002149], 
                [-71.0831970997314, 42.3306430000506]
              ], 
              [
                [-71.0831970997314, 42.3306430000506], 
                [-71.0834758999647, 42.3286133999997], 
                [-71.0828000003584, 42.3285895999299], 
                [-71.0825209998008, 42.3293114000985], 
                [-71.0827785000804, 42.3285895999299], 
                [-71.0831325997957, 42.3274157001421], 
                [-71.0829716001372, 42.3280104997588], 
                [-71.083486599798, 42.3286133999997], 
                [-71.0851646635285, 42.328886470239]
              ], 
              [
                [-71.0827571004137, 42.3310959999164], 
                [-71.0831970997314, 42.3306430000506]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 23, 
            "OBJECTID" : null, 
            "Name" : "Nubian Square Design Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 2079.31714051, 
            "Link" : "https://www.boston.gov/departments/transportation/dudley-square-design-project", 
            "GlobalID" : "c4fabde5-fcb3-44dd-b015-b4b20b6f6e8d", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "The Transportation Department initiative and community planning process will develop roadway, intersection, and streetscape design plans for construction in Nubian Square.", 
            "ProjectTyp" : "Street Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 24, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1091901659894, 42.2743854469284], 
              [-71.1080186272133, 42.2730371716507], 
              [-71.106792271442, 42.2718758046247], 
              [-71.1048263803079, 42.2713046392563], 
              [-71.1012293696034, 42.2705589215028], 
              [-71.0981394650634, 42.2702096009536], 
              [-71.09742683604, 42.2698883750217], 
              [-71.0967581274476, 42.2694359024629], 
              [-71.0941268802337, 42.2674784792098], 
              [-71.0940625069605, 42.2674308427986]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 24, 
            "OBJECTID" : null, 
            "Name" : "Cummins Highway Design Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 2080.99941681, 
            "Link" : "https://www.boston.gov/departments/public-works/cummins-highway", 
            "GlobalID" : "6c8a7039-575d-4b01-852d-243911513f8f", 
            "CreationDa" : 1589414400000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Streetscape", 
            "Descriptio" : "Our goal is to improve safety and access for all modes of transportation.", 
            "ProjectTyp" : "Street Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 25, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0719179563303, 42.3324972326375], 
              [-71.0667251999146, 42.3266595368516], 
              [-71.0615753587151, 42.3206309127624]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 25, 
            "OBJECTID" : null, 
            "Name" : "Massachusetts Avenue Better Bike Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 2125.62965082, 
            "Link" : "https://www.boston.gov/departments/transportation/mass-ave-better-bike-project", 
            "GlobalID" : "b9576645-ed31-477e-bbfe-1707b85186e3", 
            "CreationDa" : 1589328000000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "We are designing a safe, comfortable biking facility to connect Dorchester, Roxbury, and the South End.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 26, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0831492707307, 42.3273135338917], 
              [-71.0834157344002, 42.325847164863], 
              [-71.0813766179941, 42.3196464541724], 
              [-71.0820234535076, 42.317873889596], 
              [-71.0829586122948, 42.3162384423109], 
              [-71.0836647752447, 42.3142781991253], 
              [-71.083724968657, 42.314080087889], 
              [-71.0835942673764, 42.3132870136111], 
              [-71.0829090809867, 42.3120649220449], 
              [-71.0829211381744, 42.3115135225653], 
              [-71.0832606726057, 42.3106381618432], 
              [-71.0826767065856, 42.3096451113889]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 26, 
            "OBJECTID" : null, 
            "Name" : "Warren Street Multimodal Corridor", 
            "Shape_Leng" : null, 
            "Shape__Length" : 2765.77833525, 
            "Link" : "https://www.boston.gov/departments/transportation/roxbury-transportation-corridors", 
            "GlobalID" : "3098a448-72f2-48d0-89c4-7fb2efec2c23", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1624909920000, 
            "Editor" : "163175_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "We want to make it safer, more convenient, and more enjoyable for you to get around Warren Street, no matter how you travel.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 27, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0553474601228, 42.3526631707107], 
              [-71.0446186246648, 42.3476202891953], 
              [-71.0398979365242, 42.3449876808947], 
              [-71.0357351479892, 42.3419425987756], 
              [-71.0355634871249, 42.3414033504309]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 27, 
            "OBJECTID" : null, 
            "Name" : "Summer Street Multimodal Corridor Improvements", 
            "Shape_Leng" : null, 
            "Shape__Length" : 2809.1413136, 
            "Link" : "https://www.boston.gov/departments/transportation/summer-street-multimodal-corridor-improvements", 
            "GlobalID" : "bee33634-59fe-47cd-9d84-bdd9f7a48759", 
            "CreationDa" : 1589414400000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "We're making transit, bike, and pedestrian improvements between the Reserve Channel and South Station. These updates will make this corridor more safe, reliable,and efficient.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 28, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1295297002782, 42.287228699961], 
              [-71.1286714004484, 42.2868794997205], 
              [-71.1276843998862, 42.2870700003074], 
              [-71.1273410997172, 42.2872127997763], 
              [-71.1288215996622, 42.2858318003261], 
              [-71.123414300404, 42.2908478998293], 
              [-71.1163332996342, 42.297561800146], 
              [-71.1148740996428, 42.299847299763], 
              [-71.1145737003169, 42.3005931997885]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 28, 
            "OBJECTID" : null, 
            "Name" : "Roslindale Bus Lane", 
            "Shape_Leng" : null, 
            "Shape__Length" : 3276.14169493, 
            "Link" : "https://www.boston.gov/departments/transportation/roslindale-bus-lanes", 
            "GlobalID" : "28ae9ef4-4d4a-44a5-9956-1dffb25ad5c5", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bus Lane", 
            "Descriptio" : "We are working toward prioritizing transit on Washington Street, between Roslindale Village and Forest Hills Station.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 29, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0766619054468, 42.2859157888034], 
                [-71.0767524520341, 42.2861727085811], 
                [-71.0772355875535, 42.2875024355716], 
                [-71.0774684416549, 42.2880969286171]
              ], 
              [
                [-71.0758561346032, 42.286063055463], 
                [-71.0760651896378, 42.2865589947417], 
                [-71.0762853972567, 42.2870594737025], 
                [-71.0765441443979, 42.2876619422312], 
                [-71.0768023489566, 42.2882317724711]
              ], 
              [
                [-71.0778130210249, 42.2879895987877], 
                [-71.0778639716712, 42.288049111748], 
                [-71.0779087302302, 42.2881182931512], 
                [-71.0780578370926, 42.2885526244696], 
                [-71.078216682591, 42.2890528736106], 
                [-71.0782655545358, 42.2892820694908], 
                [-71.0782758716868, 42.2894109625675]
              ], 
              [
                [-71.0762650423307, 42.2883462703339], 
                [-71.0765621367547, 42.2890507278192], 
                [-71.0768760745903, 42.2897597467345]
              ], 
              [
                [-71.0782758716868, 42.2894109625675], 
                [-71.0776543417148, 42.2895673583719]
              ], 
              [
                [-71.0782758716868, 42.2894109625675], 
                [-71.0782755078691, 42.2894655426853], 
                [-71.0782637264642, 42.2895566534252], 
                [-71.0781031624886, 42.2901390107835]
              ], 
              [
                [-71.0776543417148, 42.2895673583719], 
                [-71.0772691782569, 42.2886290661049], 
                [-71.0770765013066, 42.2881742632916]
              ], 
              [
                [-71.0776543417148, 42.2895673583719], 
                [-71.0768760745903, 42.2897597467345]
              ], 
              [
                [-71.0768760745903, 42.2897597467345], 
                [-71.0760866450001, 42.2899487121907]
              ], 
              [
                [-71.0760866450001, 42.2899487121907], 
                [-71.0759556185294, 42.2895965479328], 
                [-71.0755561008916, 42.2886266843867]
              ], 
              [
                [-71.0760866450001, 42.2899487121907], 
                [-71.0755263181467, 42.2900738121143]
              ], 
              [
                [-71.0755263181467, 42.2900738121143], 
                [-71.0749278039105, 42.2902150856693], 
                [-71.0739423143146, 42.2904528270698]
              ], 
              [
                [-71.0755263181467, 42.2900738121143], 
                [-71.0757726236211, 42.2906953700598]
              ], 
              [
                [-71.0781031624886, 42.2901390107835], 
                [-71.0780564285343, 42.290442691105], 
                [-71.0779986435053, 42.290726072874], 
                [-71.0779534330937, 42.2908007469094]
              ], 
              [
                [-71.0739423143146, 42.2904528270698], 
                [-71.0738534826111, 42.2903647179502], 
                [-71.0734359079378, 42.2901386552621], 
                [-71.0726199942164, 42.2896730913036]
              ], 
              [
                [-71.0739423143146, 42.2904528270698], 
                [-71.0733049030266, 42.2906007004631]
              ], 
              [
                [-71.0757726236211, 42.2906953700598], 
                [-71.0766482636309, 42.2904791488064], 
                [-71.0776376959326, 42.2902453375053], 
                [-71.0781031624886, 42.2901390107835]
              ], 
              [
                [-71.0757726236211, 42.2906953700598], 
                [-71.0760183901065, 42.2912572777669]
              ], 
              [
                [-71.0779534330937, 42.2908007469094], 
                [-71.0777622042276, 42.2908664398922], 
                [-71.0773326199772, 42.2909610798507], 
                [-71.0760183901065, 42.2912572777669]
              ], 
              [
                [-71.0741445187968, 42.2908401435692], 
                [-71.0740859154026, 42.2907363955231], 
                [-71.0739974816528, 42.2905610704064], 
                [-71.0739423143146, 42.2904528270698]
              ], 
              [
                [-71.074652137001, 42.2910040814142], 
                [-71.0748670265933, 42.2909148433855], 
                [-71.0752668676246, 42.2908195401678], 
                [-71.0757726236211, 42.2906953700598]
              ], 
              [
                [-71.0760183901065, 42.2912572777669], 
                [-71.0761053775687, 42.2914241563228]
              ], 
              [
                [-71.0771813499716, 42.2917387210886], 
                [-71.0773561208034, 42.2915272334085], 
                [-71.0779534330937, 42.2908007469094]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 29, 
            "OBJECTID" : null, 
            "Name" : "Talbot-Norfolk-Triangle Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 3611.39316821, 
            "Link" : "https://www.boston.gov/departments/transportation/talbot-norfolk-triangle", 
            "GlobalID" : "3de162e6-26ef-4ee0-bcdc-dffafc1043e3", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 30, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.1153416799347, 42.2780385720916], 
                [-71.115234891807, 42.2780927918505], 
                [-71.1149452165689, 42.2782561281271], 
                [-71.1146998525289, 42.2783897893634], 
                [-71.1146015948031, 42.2784732979152]
              ], 
              [
                [-71.1146015948031, 42.2784732979152], 
                [-71.1149316250587, 42.2787152356749], 
                [-71.1152334392312, 42.2789565151728]
              ], 
              [
                [-71.1146015948031, 42.2784732979152], 
                [-71.1144982032055, 42.2785922413971], 
                [-71.1138043013609, 42.2793107148861], 
                [-71.1136615491807, 42.2794525961312], 
                [-71.1135533731559, 42.2795892038251], 
                [-71.1135626338882, 42.2796441400575], 
                [-71.1135762667209, 42.2798006159385], 
                [-71.1135943102818, 42.2800409448438]
              ], 
              [
                [-71.1163774284742, 42.278859059024], 
                [-71.1160576920134, 42.2791674681475], 
                [-71.1157832998132, 42.2794028818024]
              ], 
              [
                [-71.1152334392312, 42.2789565151728], 
                [-71.1157832998132, 42.2794028818024]
              ], 
              [
                [-71.1152334392312, 42.2789565151728], 
                [-71.1149037126062, 42.2792868363537], 
                [-71.114450896126, 42.2797664164698], 
                [-71.1142441398802, 42.2799981119243], 
                [-71.1141999939722, 42.2800305998384], 
                [-71.114121483013, 42.2800449671995], 
                [-71.1135943102818, 42.2800409448438]
              ], 
              [
                [-71.1157832998132, 42.2794028818024], 
                [-71.1156643188522, 42.2795307768669], 
                [-71.1153149281056, 42.2798863537974], 
                [-71.1151829269628, 42.2800052208378], 
                [-71.1150690259747, 42.280107788891], 
                [-71.1144691166549, 42.2806318927333], 
                [-71.1141938468007, 42.2808532301657], 
                [-71.1140265760032, 42.2810090935856], 
                [-71.1139330164663, 42.2811291953677], 
                [-71.1138512293513, 42.2812144502339]
              ], 
              [
                [-71.1135943102818, 42.2800409448438], 
                [-71.1136368544936, 42.2803027357238], 
                [-71.1136983324967, 42.2806270535894], 
                [-71.1137651348145, 42.2809187494218], 
                [-71.1138512293513, 42.2812144502339]
              ], 
              [
                [-71.1138512293513, 42.2812144502339], 
                [-71.1137810601478, 42.2813509477691], 
                [-71.1136084057469, 42.2815816324976]
              ], 
              [
                [-71.1136084057469, 42.2815816324976], 
                [-71.1132451405207, 42.2813513943929], 
                [-71.1124641407211, 42.2807545633453]
              ], 
              [
                [-71.1136084057469, 42.2815816324976], 
                [-71.1134408169458, 42.2818196510588], 
                [-71.11323861965, 42.2820778051082], 
                [-71.1131203735109, 42.2822085160112], 
                [-71.1129826500997, 42.282331841516], 
                [-71.1127617337101, 42.2824914629518], 
                [-71.1125152135383, 42.2826566261238], 
                [-71.1121419626394, 42.2828815659001], 
                [-71.1117691815594, 42.2830913180936], 
                [-71.1114993734622, 42.2832215111653], 
                [-71.1112796769847, 42.2833046059151], 
                [-71.1108780033902, 42.2834056566394], 
                [-71.1106967332474, 42.2834629980416], 
                [-71.1105578546028, 42.2835208099255], 
                [-71.1103779301362, 42.2836115929785], 
                [-71.1102048211877, 42.2837589952846], 
                [-71.1097468322081, 42.2842672329578], 
                [-71.1096377399016, 42.2844025588594], 
                [-71.1095595568275, 42.2844995498641], 
                [-71.109427710195, 42.2846515908819], 
                [-71.1093734187141, 42.2846864237055], 
                [-71.1093116864878, 42.2847260361914], 
                [-71.1091502906723, 42.284785130225], 
                [-71.1090696165699, 42.2848107425624], 
                [-71.1089650230264, 42.2848447080187], 
                [-71.1087636935032, 42.284897476457], 
                [-71.1086911994598, 42.2849215582187], 
                [-71.1086027109128, 42.2849509466482], 
                [-71.107971676765, 42.2851930037496], 
                [-71.1074125006535, 42.2854246088044], 
                [-71.106843534702, 42.2857079480204], 
                [-71.1066155970801, 42.2858360323167], 
                [-71.1064115950689, 42.285950673429], 
                [-71.106281741798, 42.2860396074721], 
                [-71.1058712494424, 42.2863207601574], 
                [-71.1054013946162, 42.2867180904325]
              ], 
              [
                [-71.11485284191, 42.2823566945391], 
                [-71.1144533170857, 42.2821077710817], 
                [-71.1140294838498, 42.2818368226811], 
                [-71.1136737483023, 42.281615050722], 
                [-71.1136084057469, 42.2815816324976]
              ], 
              [
                [-71.1188593595182, 42.2849321376827], 
                [-71.1185319487499, 42.2847502722018], 
                [-71.1181928652729, 42.2845257564567], 
                [-71.1178695094998, 42.2843001699256], 
                [-71.1172070549784, 42.2838551306206], 
                [-71.1168418197468, 42.2836023883396], 
                [-71.1166468556858, 42.2834818832097], 
                [-71.1164267064574, 42.2833355894689], 
                [-71.116398358322, 42.283316752108], 
                [-71.1161001230375, 42.2831373808594], 
                [-71.1160065185849, 42.2830779636136], 
                [-71.1157249560322, 42.282899237014], 
                [-71.1149844810317, 42.2824229745364]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 30, 
            "OBJECTID" : null, 
            "Name" : "Mount Hope / Canterbury Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 3688.42739735, 
            "Link" : "https://www.boston.gov/departments/transportation/neighborhood-slow-streets/mount-hope-canterbury", 
            "GlobalID" : "80433200-91a6-4ac0-a114-193cee5192a5", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 31, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0736770813371, 42.383814543061], 
                [-71.0678303954121, 42.3742646861579], 
                [-71.0622487259706, 42.3712327156581]
              ], 
              [
                [-71.0736770813371, 42.383814543061], 
                [-71.0720538067541, 42.3881914136832]
              ], 
              [
                [-71.0787987414878, 42.3866918162383], 
                [-71.0736770813371, 42.383814543061]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 31, 
            "OBJECTID" : null, 
            "Name" : "Rutherford Avenue and Sullivan Square", 
            "Shape_Leng" : null, 
            "Shape__Length" : 3750.9523081, 
            "Link" : "https://www.boston.gov/departments/transportation/rutherford-avenue-sullivan-square-design-project", 
            "GlobalID" : "063a04ba-f046-43a7-93c5-333c3fea30d7", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Streetscape", 
            "Descriptio" : "We aim to complete preliminary design for the Rutherford Avenue corridor and Sullivan Square in Charlestown.", 
            "ProjectTyp" : "Street Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 32, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.1043353575803, 42.3027715039886], 
                [-71.1046534662938, 42.3029937316505], 
                [-71.1051471929504, 42.303376932222], 
                [-71.1056996011545, 42.3037721471415], 
                [-71.106278374014, 42.3041950236072]
              ], 
              [
                [-71.1083728473029, 42.3031042827819], 
                [-71.1082094347696, 42.3033798183159], 
                [-71.108038419794, 42.3035773028335], 
                [-71.1078335688749, 42.3037162479989], 
                [-71.1076149036634, 42.3039587651565]
              ], 
              [
                [-71.1073910991901, 42.3031663227467], 
                [-71.1069610585956, 42.3035705294365]
              ], 
              [
                [-71.1088836895606, 42.3032706143816], 
                [-71.1080056043367, 42.30417839689]
              ], 
              [
                [-71.1069610585956, 42.3035705294365], 
                [-71.1062438903852, 42.3031274859046], 
                [-71.1052538481274, 42.3025625282284], 
                [-71.1048503437664, 42.3023287511553]
              ], 
              [
                [-71.1069610585956, 42.3035705294365], 
                [-71.1067603578932, 42.3037251414251], 
                [-71.106278374014, 42.3041950236072]
              ], 
              [
                [-71.1076149036634, 42.3039587651565], 
                [-71.1075694246555, 42.3039270987978], 
                [-71.1069610585956, 42.3035705294365]
              ], 
              [
                [-71.1076149036634, 42.3039587651565], 
                [-71.1072476849517, 42.3043181931237], 
                [-71.1068995617279, 42.3046540510824]
              ], 
              [
                [-71.1080056043367, 42.30417839689], 
                [-71.1076149036634, 42.3039587651565]
              ], 
              [
                [-71.106278374014, 42.3041950236072], 
                [-71.1068995617279, 42.3046540510824]
              ], 
              [
                [-71.106278374014, 42.3041950236072], 
                [-71.1059678363017, 42.3044584215551], 
                [-71.1056345667213, 42.3047808205942]
              ], 
              [
                [-71.1083661099383, 42.3043952966095], 
                [-71.1080872144836, 42.3042242774771], 
                [-71.1080056043367, 42.30417839689]
              ], 
              [
                [-71.1083661099383, 42.3043952966095], 
                [-71.1078603350771, 42.3049151357664], 
                [-71.107558467904, 42.3050839433331]
              ], 
              [
                [-71.1068995617279, 42.3046540510824], 
                [-71.1071171777072, 42.3048281045583], 
                [-71.1072660797537, 42.3049276445244], 
                [-71.107388220988, 42.3050034603808], 
                [-71.107558467904, 42.3050839433331]
              ], 
              [
                [-71.1068995617279, 42.3046540510824], 
                [-71.1065873630307, 42.3049112545164], 
                [-71.1061681255758, 42.3052840062254]
              ], 
              [
                [-71.1056345667213, 42.3047808205942], 
                [-71.1049608392413, 42.3041786825724], 
                [-71.1047752329306, 42.3039794207318], 
                [-71.1046268204659, 42.3038320444824], 
                [-71.1044834960589, 42.3037201386239], 
                [-71.1043135940959, 42.3036160191446], 
                [-71.1040424412207, 42.3034603478577], 
                [-71.1037612847064, 42.3032978888075]
              ], 
              [
                [-71.1091107297655, 42.3048382787344], 
                [-71.1089412374343, 42.3047279751367], 
                [-71.1086334440753, 42.3045491212826], 
                [-71.1083661099383, 42.3043952966095]
              ], 
              [
                [-71.107558467904, 42.3050839433331], 
                [-71.1079147675934, 42.3052635344432], 
                [-71.1081805395601, 42.3054034232716], 
                [-71.1084386965082, 42.3055196518101]
              ], 
              [
                [-71.107558467904, 42.3050839433331], 
                [-71.1075087138137, 42.3051923734563], 
                [-71.1074111244345, 42.3054660675354], 
                [-71.1073955754952, 42.3055120594616], 
                [-71.1073132502893, 42.305755515752], 
                [-71.1072799641148, 42.3059579721889], 
                [-71.1072894431376, 42.3061408786052], 
                [-71.1073329162075, 42.3063734164533]
              ], 
              [
                [-71.1061681255758, 42.3052840062254], 
                [-71.1056345667213, 42.3047808205942]
              ], 
              [
                [-71.1063165542102, 42.3054296869393], 
                [-71.1061681255758, 42.3052840062254]
              ], 
              [
                [-71.1063165542102, 42.3054296869393], 
                [-71.1060710724908, 42.3054406648993], 
                [-71.1058843316079, 42.3054524015616], 
                [-71.1057722586914, 42.3054638352715], 
                [-71.1057133678363, 42.3054872660659], 
                [-71.1056116345287, 42.3055426235086], 
                [-71.1054456132877, 42.3056652801585]
              ], 
              [
                [-71.1054456132877, 42.3056652801585], 
                [-71.1059606434913, 42.3060401101659], 
                [-71.1061198896383, 42.3061841375396]
              ], 
              [
                [-71.1054456132877, 42.3056652801585], 
                [-71.1051348761495, 42.3058684656884], 
                [-71.1049421165542, 42.3059949703333], 
                [-71.1048830208832, 42.3060499114414], 
                [-71.1048549359541, 42.3061173397638], 
                [-71.1049185968634, 42.3061496321739], 
                [-71.1050088514983, 42.3062332181973], 
                [-71.105332653734, 42.3064886659371], 
                [-71.1055196434503, 42.3066198496961]
              ], 
              [
                [-71.1061198896383, 42.3061841375396], 
                [-71.1057822147196, 42.3064221202747], 
                [-71.1055196434503, 42.3066198496961]
              ], 
              [
                [-71.1061198896383, 42.3061841375396], 
                [-71.1065869327377, 42.3065666782565], 
                [-71.1066629284141, 42.3066308533584], 
                [-71.1068893245269, 42.306822048243], 
                [-71.107023619967, 42.3069552987598]
              ], 
              [
                [-71.1073329162075, 42.3063734164533], 
                [-71.1070834890874, 42.3061339839066], 
                [-71.1067022827084, 42.3057717354638], 
                [-71.1065213027213, 42.3055997560801], 
                [-71.1063165542102, 42.3054296869393]
              ], 
              [
                [-71.1074648122474, 42.3064959691741], 
                [-71.1073329162075, 42.3063734164533]
              ], 
              [
                [-71.1066033332798, 42.3073730649688], 
                [-71.1064110929107, 42.3072328576452], 
                [-71.1062133566487, 42.3070875850271], 
                [-71.1059224803631, 42.3068738794742], 
                [-71.1055503451718, 42.306649778085], 
                [-71.1055196434503, 42.3066198496961]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 32, 
            "OBJECTID" : null, 
            "Name" : "Stonybrook Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 3922.34961149, 
            "Link" : "https://www.boston.gov/departments/transportation/neighborhood-slow-streets/stonybrook", 
            "GlobalID" : "4f59d03b-9cb5-4623-b858-784ca55d0584", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 33, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0859785120231, 42.2811691357543], 
                [-71.0858747512179, 42.2813358768745], 
                [-71.0858070451949, 42.2814346690621], 
                [-71.0856886409523, 42.2816086770554], 
                [-71.085525011925, 42.2818331613251], 
                [-71.0852770364824, 42.2821513123708], 
                [-71.0852035075797, 42.2822720247452], 
                [-71.0852031275924, 42.2823299792834], 
                [-71.0852475043674, 42.2823802183368], 
                [-71.0854134124206, 42.2826251324839]
              ], 
              [
                [-71.0838215366517, 42.2812913214775], 
                [-71.0841967288099, 42.2815638965463], 
                [-71.0842480459688, 42.2816254127473], 
                [-71.0842318987516, 42.2817181990219], 
                [-71.0840543727868, 42.2819521974921], 
                [-71.0837937059459, 42.2822978747049], 
                [-71.0836543206514, 42.2824357881649]
              ], 
              [
                [-71.0823787102531, 42.2819056041634], 
                [-71.0826225112245, 42.28230937908], 
                [-71.0831651924708, 42.2832403505484], 
                [-71.0832561792327, 42.2834629395571], 
                [-71.0834853951572, 42.2831188425093], 
                [-71.0836764641232, 42.2828708272517], 
                [-71.083732068941, 42.282770310011], 
                [-71.083752324154, 42.2827146760114], 
                [-71.0837527607352, 42.2826482773566], 
                [-71.0837135268152, 42.282536159726], 
                [-71.0836543206514, 42.2824357881649]
              ], 
              [
                [-71.0815891036947, 42.2821103637279], 
                [-71.0818709644882, 42.2828023758018], 
                [-71.0821609532383, 42.2834707791356], 
                [-71.0823315702602, 42.283825893207]
              ], 
              [
                [-71.0836543206514, 42.2824357881649], 
                [-71.0833979908767, 42.2819779558666], 
                [-71.0831907010316, 42.2816384624766]
              ], 
              [
                [-71.0801754608647, 42.2824596980698], 
                [-71.0804081002688, 42.2827728428156], 
                [-71.0805411129146, 42.2829415768206], 
                [-71.0805854277059, 42.2830008194049]
              ], 
              [
                [-71.0793587188966, 42.282583316174], 
                [-71.0794526287764, 42.2827333374321], 
                [-71.0798350640507, 42.2832265262286], 
                [-71.0799961751003, 42.2833852322414], 
                [-71.0801412000181, 42.28339814337], 
                [-71.0804097765251, 42.2833783038151], 
                [-71.080756615158, 42.2833255507194]
              ], 
              [
                [-71.0783793306581, 42.282750224355], 
                [-71.0786011983636, 42.2830301289782], 
                [-71.079276876086, 42.283952603632], 
                [-71.0799638096989, 42.2848948121507], 
                [-71.0802240336705, 42.2852491326648], 
                [-71.0802794255875, 42.2853241700707], 
                [-71.0804007466599, 42.2854844172656]
              ], 
              [
                [-71.0814478382264, 42.2827614461909], 
                [-71.0808542755041, 42.282938778182], 
                [-71.0805854277059, 42.2830008194049]
              ], 
              [
                [-71.0772321739554, 42.2829620817793], 
                [-71.0775423209005, 42.283411685863], 
                [-71.0779519373987, 42.2840028872484], 
                [-71.0786105273678, 42.284987762414], 
                [-71.079230373897, 42.2859044040449], 
                [-71.0794242509966, 42.2861797084734], 
                [-71.0795734791316, 42.286331058275]
              ], 
              [
                [-71.0805854277059, 42.2830008194049], 
                [-71.0806847023245, 42.2832003729281], 
                [-71.080756615158, 42.2833255507194]
              ], 
              [
                [-71.0762571120033, 42.2831599300627], 
                [-71.0762992214306, 42.2832653075552], 
                [-71.0766311309618, 42.2837746384789], 
                [-71.0768305740228, 42.2840364616965], 
                [-71.0770850577597, 42.2844245307491]
              ], 
              [
                [-71.080756615158, 42.2833255507194], 
                [-71.0808227060101, 42.2834720950363], 
                [-71.0808324653073, 42.2834972659512], 
                [-71.0809875549496, 42.2838975262751], 
                [-71.0811466007723, 42.2842548490256]
              ], 
              [
                [-71.0770850577597, 42.2844245307491], 
                [-71.0772545662605, 42.2849996610586], 
                [-71.077501720643, 42.2856639818686], 
                [-71.0777973624912, 42.2865873157832], 
                [-71.0780823170824, 42.2874380263224], 
                [-71.0781977568847, 42.287713043608]
              ], 
              [
                [-71.0788578982442, 42.2871283823948], 
                [-71.078599868857, 42.2865896995721], 
                [-71.0781126028839, 42.2859064947841], 
                [-71.0776252955884, 42.2852013422109], 
                [-71.0770850577597, 42.2844245307491]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 33, 
            "OBJECTID" : null, 
            "Name" : "Redefine Our Community Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 4115.86643314, 
            "Link" : "https://www.boston.gov/redefining-our-community", 
            "GlobalID" : "1f38acd2-a8e1-4b87-a368-bd25281b1e82", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 34, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0571749038036, 42.3427427815365], 
                [-71.0571525716857, 42.3415882925182], 
                [-71.0587754878409, 42.3420313926468], 
                [-71.0611618713763, 42.3426397504601], 
                [-71.0622270927419, 42.3429098197475]
              ], 
              [
                [-71.0571749038036, 42.3427427815365], 
                [-71.0571749612958, 42.3429759184859], 
                [-71.0580692242797, 42.3434503512281]
              ], 
              [
                [-71.0624100068018, 42.3425298145605], 
                [-71.0629328559415, 42.3415843398278], 
                [-71.0636550735822, 42.3403736800923], 
                [-71.0638384727323, 42.3399990074308], 
                [-71.0641524186527, 42.3394392797599], 
                [-71.0643417862095, 42.3394990900361], 
                [-71.0644256367548, 42.3395876516366], 
                [-71.0645575372863, 42.3396537698036], 
                [-71.06477700649, 42.3396451649838], 
                [-71.0649457657959, 42.3395824717409]
              ], 
              [
                [-71.0580692242797, 42.3434503512281], 
                [-71.0582670476783, 42.3430833902876], 
                [-71.0575801598795, 42.3429095236173], 
                [-71.0571576372856, 42.3426101399666]
              ], 
              [
                [-71.0580692242797, 42.3434503512281], 
                [-71.0604080402242, 42.3437173860543], 
                [-71.0609872469699, 42.3437916041706], 
                [-71.0604093311033, 42.3437175400931]
              ], 
              [
                [-71.0617242841178, 42.3439357197651], 
                [-71.0622611317047, 42.3428515936272], 
                [-71.0624068582067, 42.3425432593476]
              ], 
              [
                [-71.0609937381962, 42.3437751711674], 
                [-71.0609755976173, 42.343785012379], 
                [-71.0617448797923, 42.343927326006], 
                [-71.0617890544465, 42.3438059968221], 
                [-71.0621097053922, 42.3431610146356], 
                [-71.0622605990037, 42.3428512583226]
              ], 
              [
                [-71.0579906136075, 42.3435693744945], 
                [-71.0579868083439, 42.34357542186], 
                [-71.057973499803, 42.3435988218657], 
                [-71.0580692242797, 42.3434503512281]
              ], 
              [
                [-71.0582165309183, 42.3434678991102], 
                [-71.0583712244035, 42.3434813583039], 
                [-71.0580703759199, 42.343446430525], 
                [-71.0572575191654, 42.3445559325992], 
                [-71.0570290488425, 42.3455436205213], 
                [-71.0572912131751, 42.3445557513404], 
                [-71.0580636681997, 42.3434453250262], 
                [-71.0582044413912, 42.3434622965897], 
                [-71.0582075405789, 42.3434611120795], 
                [-71.0583604113824, 42.3434771321799], 
                [-71.0584494892243, 42.343493332874], 
                [-71.0585042828634, 42.3434997201957], 
                [-71.0584209254932, 42.3434897859847], 
                [-71.0586704945471, 42.3435202313288], 
                [-71.059216183353, 42.3435809825408], 
                [-71.0609794585764, 42.3437903001539], 
                [-71.0617243155589, 42.3439424098068], 
                [-71.0609864133334, 42.343786742658], 
                [-71.0617261463254, 42.3439428480191], 
                [-71.0609778811348, 42.3437910524202], 
                [-71.0617236076864, 42.3439366267319], 
                [-71.0609761815223, 42.3437880526504], 
                [-71.0617334640017, 42.3439412312812], 
                [-71.0617401681287, 42.3439452137015]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 34, 
            "OBJECTID" : null, 
            "Name" : "South Bay Harbor Trail Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 4335.73486631, 
            "Link" : "https://www.boston.gov/departments/transportation/south-bay-harbor-trail-project", 
            "GlobalID" : "c74fc11b-33a9-41e9-9ec1-6f5acfbd5448", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "The trail will connect Boston's neighborhoods to its waterfront via a three-and-a-half-mile route. The walk- and bike-friendly route will go through Roxbury, the South End, and South Boston.", 
            "ProjectTyp" : "Street Reconstruction"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 35, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1001449997492, 42.3228317002093], 
              [-71.1035781999667, 42.3228634002296], 
              [-71.1076981002351, 42.3224825997573], 
              [-71.1098438996661, 42.3219115000015], 
              [-71.1116034001687, 42.3194998997061], 
              [-71.1140924997686, 42.3159458997128], 
              [-71.1140066001662, 42.3131215003016], 
              [-71.1145644997717, 42.3107414001289], 
              [-71.1156373999364, 42.3095988999348], 
              [-71.1156373999364, 42.3068377003253], 
              [-71.1145644997717, 42.305409500217], 
              [-71.1144357999376, 42.3008706996851]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 35, 
            "OBJECTID" : null, 
            "Name" : "Centre Street South Streetscape Design", 
            "Shape_Leng" : null, 
            "Shape__Length" : 4456.54266399, 
            "Link" : "https://www.boston.gov/departments/transportation/centre-south-streetscape-design", 
            "GlobalID" : "801214c7-ca02-4b83-a2cf-906786112468", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Streetscape", 
            "Descriptio" : "We're improving the streetscape of the Centre South corridor in Jamaica Plain", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 36, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0831970997314, 42.3306430000506], 
              [-71.0810047999081, 42.3327935001174], 
              [-71.0804469003025, 42.3338722002834], 
              [-71.0775715996906, 42.3359341999539], 
              [-71.0762841000894, 42.3369334997829], 
              [-71.0709625998222, 42.3406291001407], 
              [-71.0702652996509, 42.3410493996887], 
              [-71.0694927997105, 42.3414062998516], 
              [-71.0680444001639, 42.3420168999923], 
              [-71.0673577001129, 42.3425720000687], 
              [-71.0662312001702, 42.343468100291], 
              [-71.0661454002808, 42.3438328997909], 
              [-71.0646659001607, 42.3461706002485], 
              [-71.0641479998398, 42.3483721997546], 
              [-71.0636759998367, 42.349878699929], 
              [-71.0630537000085, 42.3509888001669], 
              [-71.0626531996138, 42.3520208997017], 
              [-71.062560700089, 42.3524255998596], 
              [-71.0625553003158, 42.3532204000516], 
              [-71.0624600995569, 42.3535115000205], 
              [-71.0617265002616, 42.354395900001], 
              [-71.0606054000921, 42.3554067001445]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 36, 
            "OBJECTID" : null, 
            "Name" : "Improved Silver Line: Nubian Square to Downtown", 
            "Shape_Leng" : null, 
            "Shape__Length" : 4667.1762997, 
            "Link" : "https://www.boston.gov/departments/transportation/improved-silver-line-dudley-downtown", 
            "GlobalID" : "7943fddf-9405-4dc1-b03e-d2c7b2f0f7a4", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bus Lane", 
            "Descriptio" : "Go Boston 2030 makes an early action commitment to improve rapid bus service on the Silver Line from Nubian Square to Downtown.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 37, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0634736085049, 42.3476138737437], 
                [-71.0630600798436, 42.347341176278], 
                [-71.0629672919596, 42.3472676760692], 
                [-71.0628897781304, 42.3472324921277]
              ], 
              [
                [-71.0634736085049, 42.3476138737437], 
                [-71.0634714812943, 42.347620751283]
              ], 
              [
                [-71.0634714812943, 42.347620751283], 
                [-71.0630606709351, 42.3473498471007], 
                [-71.0629678830511, 42.3472763469021], 
                [-71.0628903692218, 42.3472411629654]
              ], 
              [
                [-71.0634714812943, 42.347620751283], 
                [-71.0633670153116, 42.3479584422544]
              ], 
              [
                [-71.0634742004947, 42.3476225445288], 
                [-71.0634714812943, 42.347620751283]
              ], 
              [
                [-71.0634742004947, 42.3476225445288], 
                [-71.063367606403, 42.3479671129919]
              ], 
              [
                [-71.064296541662, 42.3478222092744], 
                [-71.063611781972, 42.3477049793359], 
                [-71.0634736085049, 42.3476138737437]
              ], 
              [
                [-71.0642971327534, 42.3478308800308], 
                [-71.0636123730635, 42.3477136501085], 
                [-71.0634742004947, 42.3476225445288]
              ], 
              [
                [-71.0633670153116, 42.3479584422544], 
                [-71.0626651085795, 42.3478182616234]
              ], 
              [
                [-71.0633670153116, 42.3479584422544], 
                [-71.0633646814885, 42.3479665287463]
              ], 
              [
                [-71.0633646814885, 42.3479665287463], 
                [-71.0626657005693, 42.3478269323803]
              ], 
              [
                [-71.0633646814885, 42.3479665287463], 
                [-71.0632683111231, 42.348300454143]
              ], 
              [
                [-71.063367606403, 42.3479671129919], 
                [-71.0633646814885, 42.3479665287463]
              ], 
              [
                [-71.063367606403, 42.3479671129919], 
                [-71.0632712971231, 42.3483008305811]
              ], 
              [
                [-71.0610950331259, 42.3481135692703], 
                [-71.0611475225863, 42.3480096739473], 
                [-71.061257763838, 42.3478092170799], 
                [-71.0613679790385, 42.3476402698406], 
                [-71.0617543219843, 42.3472214218695], 
                [-71.061920969351, 42.3471179606065], 
                [-71.0620871594752, 42.3470527558826], 
                [-71.0622689587258, 42.347007313506], 
                [-71.062450591788, 42.3469849332313], 
                [-71.0626369706499, 42.3469895793847], 
                [-71.0629605770529, 42.347058333518]
              ], 
              [
                [-71.0610994456506, 42.3481146760149], 
                [-71.0611481136778, 42.3480183453417], 
                [-71.0612583549294, 42.3478178878381], 
                [-71.0613685701299, 42.347648940622], 
                [-71.0617549130758, 42.3472300927088], 
                [-71.0619215604424, 42.34712663146], 
                [-71.0620877505666, 42.3470614267451], 
                [-71.0622695498172, 42.3470159843748], 
                [-71.0624511828794, 42.3469936041031], 
                [-71.0626375617413, 42.346998249592], 
                [-71.0629611681443, 42.3470670043797]
              ], 
              [
                [-71.0610994456506, 42.3481146760149], 
                [-71.0610950331259, 42.3481135692703]
              ], 
              [
                [-71.0610956242174, 42.3481222399865], 
                [-71.0610994456506, 42.3481146760149]
              ], 
              [
                [-71.0617365443248, 42.348274476588], 
                [-71.0610994456506, 42.3481146760149]
              ], 
              [
                [-71.0617365443248, 42.348274476588], 
                [-71.0617335358669, 42.3482822450253]
              ], 
              [
                [-71.0617335358669, 42.3482822450253], 
                [-71.0610956242174, 42.3481222399865]
              ], 
              [
                [-71.0617335358669, 42.3482822450253], 
                [-71.0612630737796, 42.3494971574482]
              ], 
              [
                [-71.061737134518, 42.348283147282], 
                [-71.0617335358669, 42.3482822450253]
              ], 
              [
                [-71.061737134518, 42.348283147282], 
                [-71.0612665035474, 42.349498498525]
              ], 
              [
                [-71.0632683111231, 42.348300454143], 
                [-71.0630640656686, 42.3482746830648], 
                [-71.0627118578052, 42.348227204687], 
                [-71.0625099479704, 42.3481915472485], 
                [-71.061806231133, 42.3480228792171], 
                [-71.0617365443248, 42.348274476588]
              ], 
              [
                [-71.0632712971231, 42.3483008305811], 
                [-71.0632683111231, 42.348300454143]
              ], 
              [
                [-71.0632712971231, 42.3483008305811], 
                [-71.0632689031129, 42.3483091248334]
              ], 
              [
                [-71.0632689031129, 42.3483091248334], 
                [-71.0630646576583, 42.3482833544226], 
                [-71.0627124488967, 42.3482358753875], 
                [-71.0625105390618, 42.3482002186178], 
                [-71.0618068222245, 42.3480315499458], 
                [-71.061737134518, 42.348283147282]
              ], 
              [
                [-71.0635812473372, 42.3483399416258], 
                [-71.0632712971231, 42.3483008305811]
              ], 
              [
                [-71.0635812473372, 42.3483399416258], 
                [-71.0635788200893, 42.3483482312256]
              ], 
              [
                [-71.0635788200893, 42.3483482312256], 
                [-71.0632689031129, 42.3483091248334]
              ], 
              [
                [-71.0635788200893, 42.3483482312256], 
                [-71.0634012914296, 42.3489545567805], 
                [-71.0631420888426, 42.348884105786], 
                [-71.0631139176752, 42.3488764496232], 
                [-71.0626964597829, 42.3487629906517], 
                [-71.0623094943046, 42.3486578137313]
              ], 
              [
                [-71.063581839327, 42.3483486123108], 
                [-71.0635788200893, 42.3483482312256]
              ], 
              [
                [-71.063581839327, 42.3483486123108], 
                [-71.063401882521, 42.3489632280446], 
                [-71.0631426808323, 42.3488927770598], 
                [-71.0631145087667, 42.3488851208981], 
                [-71.0626970508744, 42.3487716619422], 
                [-71.0623100853961, 42.3486664850363]
              ], 
              [
                [-71.0641497919788, 42.3484048422712], 
                [-71.0635812473372, 42.3483399416258]
              ], 
              [
                [-71.0641503839686, 42.3484135129472], 
                [-71.063581839327, 42.3483486123108]
              ], 
              [
                [-71.0606363973593, 42.3492456253861], 
                [-71.0606682857553, 42.3491602176503], 
                [-71.0608688202694, 42.3486556952001], 
                [-71.0610376388641, 42.348239954467], 
                [-71.0610950331259, 42.3481135692703]
              ], 
              [
                [-71.0606397274141, 42.3492469618209], 
                [-71.0606688768467, 42.3491688888861], 
                [-71.0608694104625, 42.3486643665053], 
                [-71.0610382299556, 42.3482486258297], 
                [-71.0610956242174, 42.3481222399865]
              ], 
              [
                [-71.0606397274141, 42.3492469618209], 
                [-71.0606363973593, 42.3492456253861]
              ], 
              [
                [-71.0606369884508, 42.3492542966101], 
                [-71.0606397274141, 42.3492469618209]
              ], 
              [
                [-71.0612630737796, 42.3494971574482], 
                [-71.0606397274141, 42.3492469618209]
              ], 
              [
                [-71.0612630737796, 42.3494971574482], 
                [-71.0612665035474, 42.349498498525]
              ], 
              [
                [-71.0612630737796, 42.3494971574482], 
                [-71.0612602952904, 42.3495044769385]
              ], 
              [
                [-71.0612665035474, 42.349498498525], 
                [-71.0612636648711, 42.3495058293014]
              ], 
              [
                [-71.0612665035474, 42.349498498525], 
                [-71.0619239167234, 42.3497554980921], 
                [-71.0626471791048, 42.3500669305769], 
                [-71.062698297736, 42.3501504204231], 
                [-71.0626958713864, 42.350154162121]
              ], 
              [
                [-71.0612602952904, 42.3495044769385], 
                [-71.0606369884508, 42.3492542966101]
              ], 
              [
                [-71.0612602952904, 42.3495044769385], 
                [-71.0612227331351, 42.3496034456577], 
                [-71.0608959826287, 42.3504644221939]
              ], 
              [
                [-71.0612636648711, 42.3495058293014], 
                [-71.0612602952904, 42.3495044769385]
              ], 
              [
                [-71.0612636648711, 42.3495058293014], 
                [-71.0619245078149, 42.3497641692458], 
                [-71.0626477701962, 42.3500756023514], 
                [-71.0626958713864, 42.350154162121]
              ], 
              [
                [-71.0612636648711, 42.3495058293014], 
                [-71.0612233242266, 42.3496121168323], 
                [-71.0608965737201, 42.3504730939136]
              ], 
              [
                [-71.0626958713864, 42.350154162121], 
                [-71.0624394859161, 42.3505495533079], 
                [-71.0623602985255, 42.3506454784503], 
                [-71.0622460076685, 42.3508077209996]
              ], 
              [
                [-71.0626958713864, 42.350154162121], 
                [-71.0626988897258, 42.3501590915222], 
                [-71.0624400779059, 42.3505582250158], 
                [-71.062360889617, 42.350654150145], 
                [-71.06224659876, 42.3508163926719]
              ], 
              [
                [-71.0602540375434, 42.3502751325021], 
                [-71.0606363973593, 42.3492456253861]
              ], 
              [
                [-71.0602546286349, 42.350283804248], 
                [-71.0606369884508, 42.3492542966101]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 37, 
            "OBJECTID" : null, 
            "Name" : "Chinatown Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 4680.69594191, 
            "Link" : "https://www.boston.gov/departments/transportation/chinatown", 
            "GlobalID" : "ca81200d-91f2-49f2-8c11-ee28926e9a01", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 39, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0824164682411, 42.3097404990517], 
              [-71.0824193275786, 42.3097427471075], 
              [-71.0824176558139, 42.3097418848213], 
              [-71.0824168069059, 42.3097417346852], 
              [-71.0824177752898, 42.309740483108], 
              [-71.0824157513855, 42.3097413792745], 
              [-71.0824195368861, 42.3097414264412], 
              [-71.0824166344294, 42.3097420243283], 
              [-71.0824160154902, 42.309741215852], 
              [-71.0824160307615, 42.3097416151078], 
              [-71.0824164808175, 42.3097398307466], 
              [-71.0824161493392, 42.3097399755682], 
              [-71.0824161924583, 42.3097394128899], 
              [-71.0824163406803, 42.3097418522697], 
              [-71.0824169632128, 42.3097405495399], 
              [-71.0824165580726, 42.3097409414882], 
              [-71.082418248702, 42.309740966068], 
              [-71.0824172389956, 42.3097412683332], 
              [-71.0842543530404, 42.3067291607606], 
              [-71.0932483719033, 42.2785030382931], 
              [-71.0936375193894, 42.2677044224477]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 39, 
            "OBJECTID" : null, 
            "Name" : "Blue Hill Avenue Transportation Action Plan", 
            "Shape_Leng" : null, 
            "Shape__Length" : 6490.24854157, 
            "Link" : "https://www.boston.gov/departments/transportation/blue-hill-avenue", 
            "GlobalID" : "76b09f52-d44a-45fc-9c0e-2fea8a87cdb3", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "We're improving transportation equity and quality of life along a vital commercial corridor", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 40, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0784478289951, 42.2967940680735], 
                [-71.0785517586836, 42.2974634883958], 
                [-71.0786873674606, 42.2983558492769], 
                [-71.0787426408, 42.2987730772161], 
                [-71.078743204942, 42.2987773196326], 
                [-71.0788169197959, 42.2993337128983], 
                [-71.0788173024782, 42.2993407797641]
              ], 
              [
                [-71.0784484227815, 42.2968027285891], 
                [-71.0785523515717, 42.2974721494838], 
                [-71.078687961247, 42.2983645102421], 
                [-71.0787432345864, 42.2987817381239], 
                [-71.0787437987284, 42.2987859805398], 
                [-71.0788173024782, 42.2993407797641]
              ], 
              [
                [-71.0777390708124, 42.2969495824196], 
                [-71.0778400189924, 42.2972695594472], 
                [-71.0780316727617, 42.2979387408308], 
                [-71.0781429380928, 42.2983892984695], 
                [-71.0781849882312, 42.2985903334438], 
                [-71.0782112244274, 42.2987485449473], 
                [-71.0782425953937, 42.2989596661958], 
                [-71.0782942602007, 42.2993683675093], 
                [-71.0783400428391, 42.2998344405087]
              ], 
              [
                [-71.0777396637005, 42.2969582435783], 
                [-71.0778406127788, 42.2972782205619], 
                [-71.0780322656498, 42.2979474018534], 
                [-71.0781435318792, 42.2983979594301], 
                [-71.0781855811193, 42.2985989943768], 
                [-71.0782118173155, 42.2987572058585], 
                [-71.0782431891802, 42.2989683277424], 
                [-71.0782948539871, 42.2993770289998], 
                [-71.0783397877176, 42.2998344690789]
              ], 
              [
                [-71.0772759803003, 42.2970615415077], 
                [-71.0773412339225, 42.2972778544495], 
                [-71.0773666751097, 42.2974411303581], 
                [-71.0773661307306, 42.297442484505]
              ], 
              [
                [-71.0772765731883, 42.2970702026509], 
                [-71.0773418268106, 42.2972865148986], 
                [-71.0773661307306, 42.297442484505]
              ], 
              [
                [-71.0773661307306, 42.297442484505], 
                [-71.077332764606, 42.2975254056802], 
                [-71.0772151643555, 42.2976285079964], 
                [-71.0771189098728, 42.2977125598137], 
                [-71.0770653370442, 42.2977618783028]
              ], 
              [
                [-71.0773661307306, 42.297442484505], 
                [-71.0773672688961, 42.2974497907848], 
                [-71.0773333574941, 42.2975340667597], 
                [-71.0772157581419, 42.2976371690616], 
                [-71.0771195027609, 42.2977212208675], 
                [-71.077068285315, 42.2977683705997]
              ], 
              [
                [-71.0770653370442, 42.2977618783028], 
                [-71.077068285315, 42.2977683705997]
              ], 
              [
                [-71.0770653370442, 42.2977618783028], 
                [-71.0770187468203, 42.2977864641116], 
                [-71.0768987866956, 42.2978451073597], 
                [-71.0767653823844, 42.2979307043842], 
                [-71.0767424960058, 42.2979531293568]
              ], 
              [
                [-71.077068285315, 42.2977683705997], 
                [-71.0770659299323, 42.2977705393497]
              ], 
              [
                [-71.077068285315, 42.2977683705997], 
                [-71.0772227569163, 42.2981085099456], 
                [-71.0773344282859, 42.2982974231118], 
                [-71.0774198490863, 42.2984462840471], 
                [-71.0774718094389, 42.2986096579205], 
                [-71.0776014983182, 42.2991097999448], 
                [-71.0778162774178, 42.2998927263832]
              ], 
              [
                [-71.0770659299323, 42.2977705393497], 
                [-71.0770193397084, 42.2977951251551], 
                [-71.0768993795837, 42.2978537683951], 
                [-71.0767659752724, 42.2979393654079], 
                [-71.0767430888939, 42.2979617903774]
              ], 
              [
                [-71.0770659299323, 42.2977705393497], 
                [-71.0772233498044, 42.2981171709448], 
                [-71.077335021174, 42.2983060840851], 
                [-71.0774204419744, 42.2984549456643], 
                [-71.077472402327, 42.2986183188509], 
                [-71.0776020921046, 42.2991184608063], 
                [-71.0778145454659, 42.2998929144149]
              ], 
              [
                [-71.0767424960058, 42.2979531293568], 
                [-71.076660883164, 42.2979168175082], 
                [-71.0766062215773, 42.2979014236701], 
                [-71.0764060409993, 42.2978854922929], 
                [-71.0761397731626, 42.2978625643117], 
                [-71.076029842728, 42.2978390881553]
              ], 
              [
                [-71.0767424960058, 42.2979531293568], 
                [-71.0767407694439, 42.2979607584968]
              ], 
              [
                [-71.0767407694439, 42.2979607584968], 
                [-71.0766614760521, 42.2979254785339], 
                [-71.0766068144653, 42.2979100846979], 
                [-71.0764066338874, 42.2978941533228], 
                [-71.0761403660507, 42.2978712253448], 
                [-71.0760304356161, 42.2978477491916]
              ], 
              [
                [-71.0767407694439, 42.2979607584968], 
                [-71.0767110612591, 42.2980919952406], 
                [-71.0767032072886, 42.2982748407895], 
                [-71.0767038873133, 42.2982814792104]
              ], 
              [
                [-71.0767430888939, 42.2979617903774], 
                [-71.0767407694439, 42.2979607584968]
              ], 
              [
                [-71.0767430888939, 42.2979617903774], 
                [-71.0767116541472, 42.2981006562421], 
                [-71.0767038873133, 42.2982814792104]
              ], 
              [
                [-71.0767038873133, 42.2982814792104], 
                [-71.0767281076899, 42.2985180167663], 
                [-71.0767929319175, 42.2987703370867], 
                [-71.076936545582, 42.2991422427884], 
                [-71.0771460973849, 42.2996280482543], 
                [-71.0772908060957, 42.2999498747126]
              ], 
              [
                [-71.0767038873133, 42.2982814792104], 
                [-71.0767038001767, 42.2982835017659], 
                [-71.076728700578, 42.2985266777093], 
                [-71.0767935257039, 42.2987789979949], 
                [-71.07693713847, 42.2991509036455], 
                [-71.0771466911713, 42.299636709709], 
                [-71.07728768984, 42.2999502853257]
              ], 
              [
                [-71.0757373413901, 42.2984220785548], 
                [-71.0758640110316, 42.2984377400342], 
                [-71.0759326198615, 42.2984920120039], 
                [-71.075959469607, 42.2985286829815], 
                [-71.0760078420884, 42.2986340879202], 
                [-71.0762002944599, 42.2991260240264], 
                [-71.0763236466232, 42.2994100710199], 
                [-71.0764148399975, 42.2996292947172], 
                [-71.076457986979, 42.2996947266744], 
                [-71.0765335972781, 42.2997512738793], 
                [-71.076810273894, 42.2998901510794], 
                [-71.0770000600658, 42.2999881939366]
              ], 
              [
                [-71.0757379342782, 42.2984307395109], 
                [-71.0758646039197, 42.2984464009882], 
                [-71.0759332118512, 42.2985006729505], 
                [-71.0759600624951, 42.2985373445874], 
                [-71.0760084349765, 42.2986427488472], 
                [-71.076200887348, 42.2991346848857], 
                [-71.0763242395113, 42.2994187325046], 
                [-71.076415433784, 42.2996379561717], 
                [-71.0764585798671, 42.2997033881199], 
                [-71.0765341901662, 42.299759935317], 
                [-71.0768108676804, 42.299898812498], 
                [-71.0769933388708, 42.299993076774]
              ], 
              [
                [-71.0750039262494, 42.2989730518594], 
                [-71.0751333950414, 42.2992199898013], 
                [-71.075258520479, 42.2994370859979], 
                [-71.0754664642976, 42.2998508697105], 
                [-71.0756516286372, 42.3001857920774], 
                [-71.0758550638114, 42.3005939259948], 
                [-71.0759335289565, 42.3007900326195], 
                [-71.0759404917983, 42.3008536428792], 
                [-71.0761562734177, 42.3006636869418], 
                [-71.0768844765331, 42.3000721735046], 
                [-71.0769933388708, 42.299993076774]
              ], 
              [
                [-71.0750045191375, 42.2989817127398], 
                [-71.0751339870312, 42.2992286506477], 
                [-71.0752591133671, 42.2994457474789], 
                [-71.0754670562874, 42.2998595311345], 
                [-71.0756522215253, 42.3001944534554], 
                [-71.0758556566995, 42.3006025873166], 
                [-71.0759341218446, 42.3007986945787], 
                [-71.0759410846864, 42.3008623048297], 
                [-71.0761568663058, 42.3006723489184], 
                [-71.0768850703195, 42.3000808348982], 
                [-71.0770006529539, 42.2999968553418]
              ], 
              [
                [-71.0788173024782, 42.2993407797641], 
                [-71.078841053036, 42.2997794468024]
              ], 
              [
                [-71.0788173024782, 42.2993407797641], 
                [-71.0788175135823, 42.299342373729], 
                [-71.0788416468224, 42.2997881075718]
              ], 
              [
                [-71.078841053036, 42.2997794468024], 
                [-71.0788415498044, 42.2997881182026]
              ], 
              [
                [-71.078841053036, 42.2997794468024], 
                [-71.0783400428391, 42.2998344405087]
              ], 
              [
                [-71.0788416468224, 42.2997881075718], 
                [-71.0788415498044, 42.2997881182026]
              ], 
              [
                [-71.0788416468224, 42.2997881075718], 
                [-71.0788613396901, 42.3001319833398], 
                [-71.0788363961696, 42.3005775415028], 
                [-71.0788188323092, 42.3007963611585]
              ], 
              [
                [-71.0788415498044, 42.2997881182026], 
                [-71.0783406357272, 42.2998431019349]
              ], 
              [
                [-71.0788415498044, 42.2997881182026], 
                [-71.0788607459037, 42.3001233219533], 
                [-71.0788358023832, 42.3005688801775], 
                [-71.0788182385227, 42.3007876998633]
              ], 
              [
                [-71.0783400428391, 42.2998344405087], 
                [-71.0783397877176, 42.2998344690789]
              ], 
              [
                [-71.0783400428391, 42.2998344405087], 
                [-71.0783401488403, 42.2998381466638]
              ], 
              [
                [-71.0783397877176, 42.2998344690789], 
                [-71.0783401488403, 42.2998381466638]
              ], 
              [
                [-71.0783397877176, 42.2998344690789], 
                [-71.0778162774178, 42.2998927263832]
              ], 
              [
                [-71.0783401488403, 42.2998381466638], 
                [-71.0783406357272, 42.2998431019349]
              ], 
              [
                [-71.0783401488403, 42.2998381466638], 
                [-71.0783402916725, 42.2998431404715]
              ], 
              [
                [-71.0783406357272, 42.2998431019349], 
                [-71.0783402916725, 42.2998431404715]
              ], 
              [
                [-71.0783406357272, 42.2998431019349], 
                [-71.0783494014878, 42.3001492396673], 
                [-71.0783427701243, 42.3003478399098], 
                [-71.0782780995087, 42.300567406503]
              ], 
              [
                [-71.0783402916725, 42.2998431404715], 
                [-71.0778168703059, 42.2999013878015]
              ], 
              [
                [-71.0783402916725, 42.2998431404715], 
                [-71.0783488085997, 42.3001405782831], 
                [-71.0783421763379, 42.300339178553], 
                [-71.0782752922735, 42.3005662617143]
              ], 
              [
                [-71.0778162774178, 42.2998927263832], 
                [-71.0778145454659, 42.2998929144149]
              ], 
              [
                [-71.0778145454659, 42.2998929144149], 
                [-71.0778168703059, 42.2999013878015]
              ], 
              [
                [-71.0778145454659, 42.2998929144149], 
                [-71.0772908060957, 42.2999498747126]
              ], 
              [
                [-71.0778168703059, 42.2999013878015], 
                [-71.0772913998821, 42.299958536123]
              ], 
              [
                [-71.0772908060957, 42.2999498747126], 
                [-71.07728768984, 42.2999502853257]
              ], 
              [
                [-71.07728768984, 42.2999502853257], 
                [-71.0772913998821, 42.299958536123]
              ], 
              [
                [-71.07728768984, 42.2999502853257], 
                [-71.0770000600658, 42.2999881939366]
              ], 
              [
                [-71.0772913998821, 42.299958536123], 
                [-71.0770151104401, 42.2999949497796]
              ], 
              [
                [-71.0769933388708, 42.299993076774], 
                [-71.0770000600658, 42.2999881939366]
              ], 
              [
                [-71.0769933388708, 42.299993076774], 
                [-71.0770006529539, 42.2999968553418]
              ], 
              [
                [-71.0770151104401, 42.2999949497796], 
                [-71.0770000600658, 42.2999881939366]
              ], 
              [
                [-71.0770151104401, 42.2999949497796], 
                [-71.0770006529539, 42.2999968553418]
              ], 
              [
                [-71.0782752922735, 42.3005662617143], 
                [-71.0771466687134, 42.3000540049055], 
                [-71.0770151104401, 42.2999949497796]
              ], 
              [
                [-71.0782780995087, 42.300567406503], 
                [-71.0782752922735, 42.3005662617143]
              ], 
              [
                [-71.0782780995087, 42.300567406503], 
                [-71.0782758860599, 42.3005749230399]
              ], 
              [
                [-71.0782758860599, 42.3005749230399], 
                [-71.0771472616015, 42.3000626663016], 
                [-71.0770006529539, 42.2999968553418]
              ], 
              [
                [-71.0788182385227, 42.3007876998633], 
                [-71.0782780995087, 42.300567406503]
              ], 
              [
                [-71.0788170536449, 42.300795635619], 
                [-71.0788182385227, 42.3007876998633]
              ], 
              [
                [-71.0788170536449, 42.300795635619], 
                [-71.0782758860599, 42.3005749230399]
              ], 
              [
                [-71.0788188323092, 42.3007963611585], 
                [-71.0788170536449, 42.300795635619]
              ], 
              [
                [-71.0775901193585, 42.3021223923241], 
                [-71.0777865818094, 42.3020443372911], 
                [-71.0779992947839, 42.3019725315184], 
                [-71.0782884912199, 42.3018559914708], 
                [-71.078361750628, 42.3018160416102], 
                [-71.0784360817262, 42.3017755050563], 
                [-71.0785507732318, 42.3016825171115], 
                [-71.0786332547445, 42.3015899808249], 
                [-71.0786992530701, 42.3014681161806], 
                [-71.0787553663343, 42.3012089240564], 
                [-71.0788170536449, 42.300795635619]
              ], 
              [
                [-71.0775907122466, 42.3021310541001], 
                [-71.0777871755958, 42.3020529984134], 
                [-71.0779998885703, 42.301981193315], 
                [-71.0782890850063, 42.3018646532834], 
                [-71.0783623444144, 42.3018247034283], 
                [-71.0784366755126, 42.30178416688], 
                [-71.0785513670182, 42.301691178948], 
                [-71.0786338494292, 42.3015986426741], 
                [-71.0786998468565, 42.3014767773822], 
                [-71.0787559601207, 42.3012175859581], 
                [-71.0788188323092, 42.3007963611585]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 40, 
            "OBJECTID" : null, 
            "Name" : "Washington - Harvard - Norwell Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 7043.00204394, 
            "Link" : "https://www.boston.gov/departments/transportation/neighborhood-slow-streets/washington-harvard-norwell", 
            "GlobalID" : "26e5b86c-9744-4794-9f9b-3360815507f0", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 41, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1133690002321, 42.3002374998749], 
              [-71.1170167998861, 42.2948728998683], 
              [-71.1175747003899, 42.2937936001698], 
              [-71.1186046997115, 42.2872855999412], 
              [-71.1190337997699, 42.2848092997545], 
              [-71.1192055001601, 42.2783320997198], 
              [-71.1196775998762, 42.2756331002628], 
              [-71.1215388004487, 42.2626269002484], 
              [-71.1223971002785, 42.2611659000107], 
              [-71.1229120002263, 42.2604352997704], 
              [-71.1235129003879, 42.2586248999093], 
              [-71.1256157001611, 42.2546862997878]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 41, 
            "OBJECTID" : null, 
            "Name" : "Hyde Park Ave Multimodal Corridor", 
            "Shape_Leng" : null, 
            "Shape__Length" : 7071.98899432, 
            "Link" : "https://www.boston.gov/departments/transportation/hyde-park-avenue-multimodal-corridor", 
            "GlobalID" : "405a9e2f-973a-4907-b650-75efe09c713b", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "More than 10,000 people ride along Hyde Park Avenue everyday. We want to improve transit travel along this major corridor and reduce delay during peak hours.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 42, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0741445187968, 42.2908401435692], 
                [-71.0742599810569, 42.2911388007612], 
                [-71.074342215533, 42.2913636172204], 
                [-71.0744468495006, 42.2916098972326], 
                [-71.0745950140304, 42.2920048936261], 
                [-71.074732034959, 42.2924229151943], 
                [-71.0749791336459, 42.2930968055223]
              ], 
              [
                [-71.0741451107866, 42.2908488029099], 
                [-71.0742605730467, 42.2911474607254], 
                [-71.0743428075228, 42.2913722764892], 
                [-71.0744474405921, 42.2916185571321], 
                [-71.0745956060201, 42.2920135534713], 
                [-71.0747326269487, 42.292431574982], 
                [-71.0749797256356, 42.2931054658818]
              ], 
              [
                [-71.0751642611545, 42.2912563434601], 
                [-71.0751939325084, 42.2911689192505]
              ], 
              [
                [-71.0751642611545, 42.2912563434601], 
                [-71.0751624824903, 42.2912511795202], 
                [-71.0751933405186, 42.2911602592892]
              ], 
              [
                [-71.0761053775687, 42.2914241563228], 
                [-71.0763027095888, 42.2920038875636], 
                [-71.0765966581127, 42.2927859833472]
              ], 
              [
                [-71.0761059704568, 42.2914328162478], 
                [-71.0763033024769, 42.2920125474089], 
                [-71.076594174271, 42.2927864584633]
              ], 
              [
                [-71.0771813499716, 42.2917387210886], 
                [-71.0771696655847, 42.2918427758153], 
                [-71.0771708657339, 42.2918460259238]
              ], 
              [
                [-71.0771819428597, 42.2917473809704], 
                [-71.0771708657339, 42.2918460259238]
              ], 
              [
                [-71.0771708657339, 42.2918460259238], 
                [-71.0772189830938, 42.2919763165273], 
                [-71.0773397220579, 42.2923098740228], 
                [-71.0774383588727, 42.2926056489547]
              ], 
              [
                [-71.0771708657339, 42.2918460259238], 
                [-71.0771702584728, 42.2918514356828], 
                [-71.0772195759819, 42.2919849763764], 
                [-71.077340314946, 42.292318533826], 
                [-71.0774362208823, 42.2926061187562]
              ], 
              [
                [-71.0774383588727, 42.2926056489547], 
                [-71.0774362208823, 42.2926061187562]
              ], 
              [
                [-71.0774383588727, 42.2926056489547], 
                [-71.0777573407486, 42.293385580326], 
                [-71.0779329020979, 42.2938813928487], 
                [-71.0780421893387, 42.2942565461771], 
                [-71.0780856821715, 42.2944401377779]
              ], 
              [
                [-71.0774362208823, 42.2926061187562], 
                [-71.0774389517608, 42.2926143087173]
              ], 
              [
                [-71.0774362208823, 42.2926061187562], 
                [-71.0771563866882, 42.2926676288268], 
                [-71.0765966581127, 42.2927859833472]
              ], 
              [
                [-71.0774389517608, 42.2926143087173], 
                [-71.0771569795763, 42.2926762885808], 
                [-71.0765997465207, 42.2927941161381]
              ], 
              [
                [-71.0774389517608, 42.2926143087173], 
                [-71.0777579336367, 42.2933942399813], 
                [-71.0779334949859, 42.2938900531003], 
                [-71.0780427822268, 42.2942652063771], 
                [-71.0780842888845, 42.2944404102149]
              ], 
              [
                [-71.0765966581127, 42.2927859833472], 
                [-71.076594174271, 42.2927864584633]
              ], 
              [
                [-71.0765966581127, 42.2927859833472], 
                [-71.0765997465207, 42.2927941161381]
              ], 
              [
                [-71.076594174271, 42.2927864584633], 
                [-71.0765972510008, 42.2927946437495]
              ], 
              [
                [-71.076594174271, 42.2927864584633], 
                [-71.0757626657962, 42.2929455258004]
              ], 
              [
                [-71.0765997465207, 42.2927941161381], 
                [-71.0765972510008, 42.2927946437495]
              ], 
              [
                [-71.0765997465207, 42.2927941161381], 
                [-71.0768189749759, 42.2933714392763], 
                [-71.077038271703, 42.2940120201227], 
                [-71.0771864308429, 42.2944396487202], 
                [-71.0772488089579, 42.2946036183941]
              ], 
              [
                [-71.0765972510008, 42.2927946437495], 
                [-71.0757659042228, 42.2929536798346]
              ], 
              [
                [-71.0765972510008, 42.2927946437495], 
                [-71.076819567864, 42.2933800989336], 
                [-71.0770388645911, 42.2940206803564], 
                [-71.0771870237309, 42.2944483095595], 
                [-71.0772462837936, 42.2946040815358]
              ], 
              [
                [-71.0757626657962, 42.2929455258004], 
                [-71.0756448472551, 42.2925737130797], 
                [-71.0753099858599, 42.2916794913728], 
                [-71.0751642611545, 42.2912563434601]
              ], 
              [
                [-71.0757626657962, 42.2929455258004], 
                [-71.0757606382986, 42.2929459171887]
              ], 
              [
                [-71.0757606382986, 42.2929459171887], 
                [-71.0756454392449, 42.2925823735112], 
                [-71.0753105778497, 42.2916881512627], 
                [-71.0751630744801, 42.291259839469], 
                [-71.0751642611545, 42.2912563434601]
              ], 
              [
                [-71.0757606382986, 42.2929459171887], 
                [-71.0749791336459, 42.2930968055223]
              ], 
              [
                [-71.0757659042228, 42.2929536798346], 
                [-71.0757626657962, 42.2929455258004]
              ], 
              [
                [-71.0757659042228, 42.2929536798346], 
                [-71.0757632586843, 42.2929541861808]
              ], 
              [
                [-71.0757632586843, 42.2929541861808], 
                [-71.0757606382986, 42.2929459171887]
              ], 
              [
                [-71.0757632586843, 42.2929541861808], 
                [-71.0749823352415, 42.2931049621949]
              ], 
              [
                [-71.0749791336459, 42.2930968055223], 
                [-71.0749823352415, 42.2931049621949]
              ], 
              [
                [-71.0749823352415, 42.2931049621949], 
                [-71.0749797256356, 42.2931054658818]
              ], 
              [
                [-71.0749823352415, 42.2931049621949], 
                [-71.0751384076407, 42.2935025327513], 
                [-71.0752646865151, 42.2938569291098], 
                [-71.0756314147467, 42.2948885688753]
              ], 
              [
                [-71.0749797256356, 42.2931054658818], 
                [-71.0751389996304, 42.2935111930551], 
                [-71.0752652785049, 42.2938655893648], 
                [-71.0756320067365, 42.2948972296529]
              ], 
              [
                [-71.0783588140353, 42.2943745973661], 
                [-71.0780856821715, 42.2944401377779]
              ], 
              [
                [-71.0783594078217, 42.29438325755], 
                [-71.07808725063, 42.2944485640556]
              ], 
              [
                [-71.0780856821715, 42.2944401377779], 
                [-71.0780842888845, 42.2944404102149]
              ], 
              [
                [-71.0780856821715, 42.2944401377779], 
                [-71.07808725063, 42.2944485640556]
              ], 
              [
                [-71.0780842888845, 42.2944404102149], 
                [-71.0780862759579, 42.2944487979527]
              ], 
              [
                [-71.0780842888845, 42.2944404102149], 
                [-71.0772488089579, 42.2946036183941]
              ], 
              [
                [-71.07808725063, 42.2944485640556], 
                [-71.0780862759579, 42.2944487979527]
              ], 
              [
                [-71.07808725063, 42.2944485640556], 
                [-71.0782422711019, 42.2952813738778], 
                [-71.0783159931424, 42.2957059120575], 
                [-71.078328751016, 42.2958106187159]
              ], 
              [
                [-71.0780862759579, 42.2944487979527], 
                [-71.0772509846775, 42.2946119695638]
              ], 
              [
                [-71.0780862759579, 42.2944487979527], 
                [-71.07824286399, 42.2952900346014], 
                [-71.0783165869288, 42.2957145727227], 
                [-71.0783283000617, 42.2958107110767]
              ], 
              [
                [-71.0772488089579, 42.2946036183941], 
                [-71.0772462837936, 42.2946040815358]
              ], 
              [
                [-71.0772488089579, 42.2946036183941], 
                [-71.0772509846775, 42.2946119695638]
              ], 
              [
                [-71.0772462837936, 42.2946040815358], 
                [-71.0772494018459, 42.2946122785464]
              ], 
              [
                [-71.0772462837936, 42.2946040815358], 
                [-71.0764486121606, 42.2947503471152]
              ], 
              [
                [-71.0772509846775, 42.2946119695638], 
                [-71.0772494018459, 42.2946122785464]
              ], 
              [
                [-71.0772509846775, 42.2946119695638], 
                [-71.0773450625423, 42.2949730961269], 
                [-71.0775103462663, 42.2957029518559], 
                [-71.0775550122989, 42.2959664511112]
              ], 
              [
                [-71.0772494018459, 42.2946122785464], 
                [-71.0764509774248, 42.294758682318]
              ], 
              [
                [-71.0772494018459, 42.2946122785464], 
                [-71.0773456554303, 42.2949817568929], 
                [-71.0775109391544, 42.2957116125215], 
                [-71.0775541651876, 42.2959666145695]
              ], 
              [
                [-71.0764486121606, 42.2947503471152], 
                [-71.0762741611291, 42.2942888606181], 
                [-71.0760676959375, 42.2937135978292], 
                [-71.0757659042228, 42.2929536798346]
              ], 
              [
                [-71.0764486121606, 42.2947503471152], 
                [-71.0764460923863, 42.2947507730452]
              ], 
              [
                [-71.0764460923863, 42.2947507730452], 
                [-71.0762747540172, 42.2942975214782], 
                [-71.0760682888256, 42.2937222581039], 
                [-71.0757632586843, 42.2929541861808]
              ], 
              [
                [-71.0764460923863, 42.2947507730452], 
                [-71.0756314147467, 42.2948885688753]
              ], 
              [
                [-71.0764509774248, 42.294758682318], 
                [-71.0764486121606, 42.2947503471152]
              ], 
              [
                [-71.0764509774248, 42.294758682318], 
                [-71.0764492050487, 42.2947590072474]
              ], 
              [
                [-71.0764492050487, 42.2947590072474], 
                [-71.0764460923863, 42.2947507730452]
              ], 
              [
                [-71.0764492050487, 42.2947590072474], 
                [-71.0756342085072, 42.294896856882]
              ], 
              [
                [-71.0756314147467, 42.2948885688753], 
                [-71.0756342085072, 42.294896856882]
              ], 
              [
                [-71.0756342085072, 42.294896856882], 
                [-71.0756320067365, 42.2948972296529]
              ], 
              [
                [-71.0756342085072, 42.294896856882], 
                [-71.0758021539395, 42.2953950555814], 
                [-71.0758836904245, 42.2956969590255], 
                [-71.0760454797022, 42.2962388596948]
              ], 
              [
                [-71.0756320067365, 42.2948972296529], 
                [-71.0758027459293, 42.2954037162893], 
                [-71.0758842833126, 42.2957056196919], 
                [-71.0760460725903, 42.2962475202867]
              ], 
              [
                [-71.078328751016, 42.2958106187159], 
                [-71.0783283000617, 42.2958107110767]
              ], 
              [
                [-71.078328751016, 42.2958106187159], 
                [-71.0783905595991, 42.2963459568604], 
                [-71.0784478289951, 42.2967940680735]
              ], 
              [
                [-71.0783283000617, 42.2958107110767], 
                [-71.0783293439041, 42.2958192793667]
              ], 
              [
                [-71.0783283000617, 42.2958107110767], 
                [-71.0780615965421, 42.2958653441219], 
                [-71.0775550122989, 42.2959664511112]
              ], 
              [
                [-71.0783293439041, 42.2958192793667], 
                [-71.0780621903285, 42.2958740047652], 
                [-71.0775566059102, 42.2959749117368]
              ], 
              [
                [-71.0783293439041, 42.2958192793667], 
                [-71.0783911533855, 42.2963546174377], 
                [-71.0784484227815, 42.2968027285891]
              ], 
              [
                [-71.0775550122989, 42.2959664511112], 
                [-71.0775541651876, 42.2959666145695]
              ], 
              [
                [-71.0775550122989, 42.2959664511112], 
                [-71.0775566059102, 42.2959749117368]
              ], 
              [
                [-71.0775541651876, 42.2959666145695], 
                [-71.077555605187, 42.2959751117406]
              ], 
              [
                [-71.0775541651876, 42.2959666145695], 
                [-71.0771516489734, 42.2960443063659], 
                [-71.0767921602646, 42.2961076928445]
              ], 
              [
                [-71.0775566059102, 42.2959749117368], 
                [-71.077555605187, 42.2959751117406]
              ], 
              [
                [-71.0775566059102, 42.2959749117368], 
                [-71.0776390065746, 42.2964124088528], 
                [-71.0777390708124, 42.2969495824196]
              ], 
              [
                [-71.077555605187, 42.2959751117406], 
                [-71.0771522427598, 42.2960529669846], 
                [-71.0767942461527, 42.2961160903271]
              ], 
              [
                [-71.077555605187, 42.2959751117406], 
                [-71.0776395994627, 42.2964210700853], 
                [-71.0777396637005, 42.2969582435783]
              ], 
              [
                [-71.0767921602646, 42.2961076928445], 
                [-71.076684984963, 42.2956999139115], 
                [-71.0766265872831, 42.2954228543633], 
                [-71.0765176602666, 42.2949936822222], 
                [-71.0764509774248, 42.294758682318]
              ], 
              [
                [-71.0767921602646, 42.2961076928445], 
                [-71.0767905621618, 42.2961080171024]
              ], 
              [
                [-71.0767905621618, 42.2961080171024], 
                [-71.0766855778511, 42.2957085745776], 
                [-71.0766271801711, 42.2954315150674], 
                [-71.0765182522564, 42.2950023429854], 
                [-71.0764492050487, 42.2947590072474]
              ], 
              [
                [-71.0767905621618, 42.2961080171024], 
                [-71.0764976862263, 42.2961673788684], 
                [-71.0760454797022, 42.2962388596948]
              ], 
              [
                [-71.0767942461527, 42.2961160903271], 
                [-71.0767921602646, 42.2961076928445]
              ], 
              [
                [-71.0767942461527, 42.2961160903271], 
                [-71.0767927531527, 42.2961163534544]
              ], 
              [
                [-71.0767927531527, 42.2961163534544], 
                [-71.0767905621618, 42.2961080171024]
              ], 
              [
                [-71.0767927531527, 42.2961163534544], 
                [-71.0764982791144, 42.2961760394702], 
                [-71.0760477587281, 42.2962472538377]
              ], 
              [
                [-71.0760454797022, 42.2962388596948], 
                [-71.0760477587281, 42.2962472538377]
              ], 
              [
                [-71.0760477587281, 42.2962472538377], 
                [-71.0760460725903, 42.2962475202867]
              ], 
              [
                [-71.0760477587281, 42.2962472538377], 
                [-71.0761390527137, 42.2965835701351], 
                [-71.0762829942633, 42.2970466318468], 
                [-71.0762831631466, 42.2970539288701]
              ], 
              [
                [-71.0760460725903, 42.2962475202867], 
                [-71.0761396456018, 42.2965922313441], 
                [-71.0762831631466, 42.2970539288701]
              ], 
              [
                [-71.0762831631466, 42.2970539288701], 
                [-71.0762891638927, 42.2973133693262]
              ], 
              [
                [-71.0762831631466, 42.2970539288701], 
                [-71.0762835871514, 42.2970552929921], 
                [-71.0762897567808, 42.2973220297704]
              ], 
              [
                [-71.077036151679, 42.2971096166516], 
                [-71.0768980707383, 42.2965340414189], 
                [-71.0767942461527, 42.2961160903271]
              ], 
              [
                [-71.0770367445671, 42.2971182777883], 
                [-71.0768986636264, 42.2965427019702], 
                [-71.0767927531527, 42.2961163534544]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 42, 
            "OBJECTID" : null, 
            "Name" : "West of Washington Street Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 8827.3341778, 
            "Link" : "https://www.boston.gov/departments/transportation/west-washington-street", 
            "GlobalID" : "9a1bf1f3-44e9-4423-b85c-084b16e6018c", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 43, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0788906023105, 42.2785668099746], 
                [-71.0786377948299, 42.2787532574291], 
                [-71.0784525199976, 42.2788690559479], 
                [-71.0781725007505, 42.2789890056178], 
                [-71.0779595560107, 42.279050116242]
              ], 
              [
                [-71.0788911943002, 42.2785754676793], 
                [-71.0786383868197, 42.2787619144435], 
                [-71.0784531119873, 42.278877713611], 
                [-71.0781730927402, 42.2789976625998], 
                [-71.0779630881864, 42.2790579304484]
              ], 
              [
                [-71.0802825517247, 42.2789922317977], 
                [-71.080122391991, 42.2790625477221], 
                [-71.0797499648472, 42.2791776630857], 
                [-71.0789605127992, 42.2793914081346], 
                [-71.0782046658275, 42.2795923269555]
              ], 
              [
                [-71.0802831446128, 42.2790008894439], 
                [-71.0801229848791, 42.2790712046941], 
                [-71.0797505577353, 42.2791863207064], 
                [-71.0789611056872, 42.2794000650613], 
                [-71.0782076176915, 42.2796003571018]
              ], 
              [
                [-71.0779595560107, 42.279050116242], 
                [-71.0779630881864, 42.2790579304484]
              ], 
              [
                [-71.0779595560107, 42.279050116242], 
                [-71.0775059391315, 42.2791818071258], 
                [-71.0769351433118, 42.2793006848003], 
                [-71.0762354509269, 42.279460159719], 
                [-71.0752529087034, 42.2796804810507]
              ], 
              [
                [-71.0779630881864, 42.2790579304484], 
                [-71.0779601488987, 42.2790587738802]
              ], 
              [
                [-71.0779630881864, 42.2790579304484], 
                [-71.0782046658275, 42.2795923269555]
              ], 
              [
                [-71.0779601488987, 42.2790587738802], 
                [-71.0782016995904, 42.2795931145505]
              ], 
              [
                [-71.0779601488987, 42.2790587738802], 
                [-71.0775065311213, 42.279190464746], 
                [-71.0769357353016, 42.2793093424041], 
                [-71.0762360429167, 42.2794688166363], 
                [-71.0752534997949, 42.2796891386024]
              ], 
              [
                [-71.0782046658275, 42.2795923269555], 
                [-71.0782016995904, 42.2795931145505]
              ], 
              [
                [-71.0782046658275, 42.2795923269555], 
                [-71.0782076176915, 42.2796003571018]
              ], 
              [
                [-71.0782016995904, 42.2795931145505], 
                [-71.0782052578173, 42.2796009845192]
              ], 
              [
                [-71.0782016995904, 42.2795931145505], 
                [-71.0780896706914, 42.2796228524061], 
                [-71.0773954059274, 42.2798200551805], 
                [-71.0765023098551, 42.2800626630357], 
                [-71.0759200874649, 42.2802186274411], 
                [-71.0754665756887, 42.2803328693635]
              ], 
              [
                [-71.0782076176915, 42.2796003571018], 
                [-71.0782052578173, 42.2796009845192]
              ], 
              [
                [-71.0782076176915, 42.2796003571018], 
                [-71.0783914722875, 42.2801005623493], 
                [-71.0785293484122, 42.2804184217314]
              ], 
              [
                [-71.0782052578173, 42.2796009845192], 
                [-71.0780902626811, 42.2796315099656], 
                [-71.0773959979172, 42.2798287127129], 
                [-71.0765029018449, 42.2800713211995], 
                [-71.0759206794547, 42.2802272849188], 
                [-71.0754671667801, 42.2803415268255]
              ], 
              [
                [-71.0782052578173, 42.2796009845192], 
                [-71.0783920651756, 42.2801092198432], 
                [-71.0785264630235, 42.2804190604394]
              ], 
              [
                [-71.0785293484122, 42.2804184217314], 
                [-71.0791279929041, 42.280300200826], 
                [-71.0800068336112, 42.2800918490251], 
                [-71.0807847306298, 42.2799365728663], 
                [-71.0815127343192, 42.2797631052562]
              ], 
              [
                [-71.0785293484122, 42.2804184217314], 
                [-71.0785345613358, 42.2804261666469]
              ], 
              [
                [-71.0785264630235, 42.2804190604394], 
                [-71.0785293484122, 42.2804184217314]
              ], 
              [
                [-71.0785264630235, 42.2804190604394], 
                [-71.0785299413003, 42.2804270791817]
              ], 
              [
                [-71.0785345613358, 42.2804261666469], 
                [-71.0791285857922, 42.2803088589571], 
                [-71.0800074273976, 42.2801005065202], 
                [-71.0807853244162, 42.2799452303828], 
                [-71.0815133272073, 42.2797717621319]
              ], 
              [
                [-71.0785345613358, 42.2804261666469], 
                [-71.078639834904, 42.280582572794], 
                [-71.07911110817, 42.2811588035619]
              ], 
              [
                [-71.0785299413003, 42.2804270791817], 
                [-71.0785345613358, 42.2804261666469]
              ], 
              [
                [-71.0785299413003, 42.2804270791817], 
                [-71.0786404268937, 42.2805912302216], 
                [-71.0791055799377, 42.281159977282]
              ], 
              [
                [-71.0815949634053, 42.2806209450088], 
                [-71.0815998933596, 42.2806285981809]
              ], 
              [
                [-71.0815949634053, 42.2806209450088], 
                [-71.0807256331622, 42.2808225963129], 
                [-71.0797316832329, 42.2810192822442], 
                [-71.07911110817, 42.2811588035619]
              ], 
              [
                [-71.0815998933596, 42.2806285981809], 
                [-71.0815955562934, 42.2806296030959]
              ], 
              [
                [-71.0815998933596, 42.2806285981809], 
                [-71.082024745285, 42.2812881711819]
              ], 
              [
                [-71.0815955562934, 42.2806296030959], 
                [-71.0807262260503, 42.2808312537075], 
                [-71.079732276121, 42.2810279402765], 
                [-71.0791168331333, 42.2811663077936]
              ], 
              [
                [-71.0815955562934, 42.2806296030959], 
                [-71.0820205456611, 42.2812893874353]
              ], 
              [
                [-71.08447444298, 42.2808424060998], 
                [-71.0843125135652, 42.2809808065908], 
                [-71.0841971348484, 42.2810698553181], 
                [-71.0838215366517, 42.2812913214775], 
                [-71.0833259028718, 42.2815607409475], 
                [-71.0831907010316, 42.2816384624766]
              ], 
              [
                [-71.0844750376647, 42.2808510634917], 
                [-71.0843131082499, 42.2809894639638], 
                [-71.0841977295331, 42.2810785133435], 
                [-71.0838221313364, 42.2812999788078], 
                [-71.0833264975565, 42.2815693989054], 
                [-71.083191294818, 42.2816471204238]
              ], 
              [
                [-71.0757355806921, 42.2810377886456], 
                [-71.0760383713333, 42.2809713809128], 
                [-71.0765980262469, 42.2808485306099], 
                [-71.0776420554566, 42.280614917512], 
                [-71.0785264630235, 42.2804190604394]
              ], 
              [
                [-71.0757361726819, 42.2810464466754], 
                [-71.0760389624248, 42.2809800389517], 
                [-71.0765986182367, 42.2808571886656], 
                [-71.0776426474464, 42.2806235749352], 
                [-71.0785299413003, 42.2804270791817]
              ], 
              [
                [-71.07911110817, 42.2811588035619], 
                [-71.0791055799377, 42.281159977282]
              ], 
              [
                [-71.07911110817, 42.2811588035619], 
                [-71.0791168331333, 42.2811663077936]
              ], 
              [
                [-71.0791055799377, 42.281159977282], 
                [-71.0791117010581, 42.281167461575]
              ], 
              [
                [-71.0791055799377, 42.281159977282], 
                [-71.0785275760362, 42.2812827073462], 
                [-71.0771109094769, 42.2815746001928], 
                [-71.0760267174892, 42.2818063747337]
              ], 
              [
                [-71.0791168331333, 42.2811663077936], 
                [-71.0791117010581, 42.281167461575]
              ], 
              [
                [-71.0791168331333, 42.2811663077936], 
                [-71.0793216319501, 42.2814347328654], 
                [-71.0796653615138, 42.2818501322305]
              ], 
              [
                [-71.0791117010581, 42.281167461575], 
                [-71.0785281689243, 42.2812913653424], 
                [-71.0771115014667, 42.2815832574842], 
                [-71.0760273094789, 42.2818150326579]
              ], 
              [
                [-71.0791117010581, 42.281167461575], 
                [-71.0793222248382, 42.2814433908406], 
                [-71.0796597057208, 42.2818512381472]
              ], 
              [
                [-71.082024745285, 42.2812881711819], 
                [-71.0820205456611, 42.2812893874353]
              ], 
              [
                [-71.082024745285, 42.2812881711819], 
                [-71.0823787102531, 42.2819056041634]
              ], 
              [
                [-71.0820205456611, 42.2812893874353], 
                [-71.0820253390714, 42.2812968291773]
              ], 
              [
                [-71.0820205456611, 42.2812893874353], 
                [-71.0814547759153, 42.2814532152185], 
                [-71.0808551531582, 42.2816035176416], 
                [-71.0802776514148, 42.281732518146], 
                [-71.0796653615138, 42.2818501322305]
              ], 
              [
                [-71.0820253390714, 42.2812968291773], 
                [-71.0814553697018, 42.2814618725266], 
                [-71.0808557469445, 42.2816121749291], 
                [-71.0802782452012, 42.2817411760803], 
                [-71.0796715311431, 42.281857718792]
              ], 
              [
                [-71.0820253390714, 42.2812968291773], 
                [-71.0823749220575, 42.2819066190272]
              ], 
              [
                [-71.0831907010316, 42.2816384624766], 
                [-71.0827368955063, 42.280848488074], 
                [-71.0825989008039, 42.2806032141042], 
                [-71.0825254266985, 42.2804605252682], 
                [-71.0818148566138, 42.2805699801093], 
                [-71.0815949634053, 42.2806209450088]
              ], 
              [
                [-71.0831907010316, 42.2816384624766], 
                [-71.0831870484817, 42.2816397285694]
              ], 
              [
                [-71.0831870484817, 42.2816397285694], 
                [-71.0827374892927, 42.2808571454651], 
                [-71.0825994954886, 42.280611871529], 
                [-71.0825260204849, 42.2804691827127], 
                [-71.0818154504002, 42.2805786382034], 
                [-71.0815998933596, 42.2806285981809]
              ], 
              [
                [-71.0831870484817, 42.2816397285694], 
                [-71.0829256432256, 42.2817303441914], 
                [-71.0825357312732, 42.2818515937154], 
                [-71.0823787102531, 42.2819056041634]
              ], 
              [
                [-71.083191294818, 42.2816471204238], 
                [-71.0831870484817, 42.2816397285694]
              ], 
              [
                [-71.083191294818, 42.2816471204238], 
                [-71.082926237012, 42.281739002126], 
                [-71.0825363250595, 42.2818602509687], 
                [-71.0823793040395, 42.2819142620739]
              ], 
              [
                [-71.0796653615138, 42.2818501322305], 
                [-71.0796597057208, 42.2818512381472]
              ], 
              [
                [-71.0796653615138, 42.2818501322305], 
                [-71.0796715311431, 42.281857718792]
              ], 
              [
                [-71.0796597057208, 42.2818512381472], 
                [-71.0796659544019, 42.2818587901487]
              ], 
              [
                [-71.0796597057208, 42.2818512381472], 
                [-71.0791287412007, 42.2819550772573], 
                [-71.0770356396393, 42.282378409939], 
                [-71.0761613803401, 42.2825462431298]
              ], 
              [
                [-71.0796715311431, 42.281857718792], 
                [-71.0796659544019, 42.2818587901487]
              ], 
              [
                [-71.0796715311431, 42.281857718792], 
                [-71.0798760029732, 42.282109175404], 
                [-71.0801754608647, 42.2824596980698]
              ], 
              [
                [-71.0796659544019, 42.2818587901487], 
                [-71.0798765958613, 42.2821178332866], 
                [-71.0801695535434, 42.2824607481488]
              ], 
              [
                [-71.0796659544019, 42.2818587901487], 
                [-71.0791293340888, 42.281963735161], 
                [-71.077036231629, 42.2823870677845], 
                [-71.0761619723299, 42.2825549009524]
              ], 
              [
                [-71.0823787102531, 42.2819056041634], 
                [-71.0823749220575, 42.2819066190272]
              ], 
              [
                [-71.0823749220575, 42.2819066190272], 
                [-71.0823793040395, 42.2819142620739]
              ], 
              [
                [-71.0823749220575, 42.2819066190272], 
                [-71.0817239893279, 42.2820810311298], 
                [-71.0815891036947, 42.2821103637279], 
                [-71.0809194518712, 42.2822789825358], 
                [-71.0801754608647, 42.2824596980698]
              ], 
              [
                [-71.0823793040395, 42.2819142620739], 
                [-71.0817245831143, 42.2820896890163], 
                [-71.0815896965828, 42.2821190216103], 
                [-71.0809200456576, 42.282287640395], 
                [-71.0801760537528, 42.2824683565688]
              ], 
              [
                [-71.0801754608647, 42.2824596980698], 
                [-71.0801695535434, 42.2824607481488]
              ], 
              [
                [-71.0801695535434, 42.2824607481488], 
                [-71.0801760537528, 42.2824683565688]
              ], 
              [
                [-71.0801695535434, 42.2824607481488], 
                [-71.0798124399803, 42.2825242094414], 
                [-71.0793587188966, 42.282583316174], 
                [-71.0788986826564, 42.2826508433964], 
                [-71.0783793306581, 42.282750224355], 
                [-71.0775948175474, 42.2828970139192], 
                [-71.0772321739554, 42.2829620817793], 
                [-71.0768014973537, 42.2830578395088], 
                [-71.0762571120033, 42.2831599300627]
              ], 
              [
                [-71.0801760537528, 42.2824683565688], 
                [-71.0798130328684, 42.2825328672669], 
                [-71.0793593117847, 42.282591974656], 
                [-71.0788992755445, 42.2826595018691], 
                [-71.0783799235462, 42.2827588821495], 
                [-71.0775954104355, 42.2829056723581], 
                [-71.0772327659452, 42.2829707402092], 
                [-71.0768020893435, 42.2830664979256], 
                [-71.0762577039931, 42.2831685884655]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 43, 
            "OBJECTID" : null, 
            "Name" : "Dorchester Unified Neighborhood - West Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 10183.56867045, 
            "Link" : "https://www.boston.gov/dorchester-unified-neighborhood-east-and-west", 
            "GlobalID" : "1ad62ea7-ee0d-4ffd-80db-4034250c1780", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 44, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0722234976129, 42.2781100263012], 
                [-71.0722821351431, 42.2782582988783]
              ], 
              [
                [-71.0722240887043, 42.2781186840687], 
                [-71.0722794527736, 42.2782586803881]
              ], 
              [
                [-71.0747275802135, 42.2781328265484], 
                [-71.0743858790457, 42.2781850190375], 
                [-71.0740723194008, 42.27825025128], 
                [-71.0729984391742, 42.2783920019829], 
                [-71.0723663513026, 42.2784712441497]
              ], 
              [
                [-71.0747281713049, 42.2781414836481], 
                [-71.0743864701371, 42.27819367613], 
                [-71.0740729104923, 42.2782589090281], 
                [-71.0729990293674, 42.2784006590469], 
                [-71.0723688998231, 42.2784796559473]
              ], 
              [
                [-71.0722821351431, 42.2782582988783], 
                [-71.0722794527736, 42.2782586803881]
              ], 
              [
                [-71.0722821351431, 42.2782582988783], 
                [-71.0723663513026, 42.2784712441497]
              ], 
              [
                [-71.0722794527736, 42.2782586803881], 
                [-71.0722827262345, 42.2782669566253]
              ], 
              [
                [-71.0722794527736, 42.2782586803881], 
                [-71.0714733558416, 42.278373284775], 
                [-71.0710139726767, 42.2784474988937], 
                [-71.0704093049809, 42.2786285238434], 
                [-71.070059993286, 42.2787409568232], 
                [-71.0698424437821, 42.2788175200304], 
                [-71.0696986064371, 42.2789046038026], 
                [-71.0696404522005, 42.279029604693]
              ], 
              [
                [-71.0722827262345, 42.2782669566253], 
                [-71.0723669414958, 42.2784799012029]
              ], 
              [
                [-71.0722827262345, 42.2782669566253], 
                [-71.0714739460348, 42.2783819418416], 
                [-71.0710145628698, 42.2784561566147], 
                [-71.0704098942757, 42.2786371815396], 
                [-71.0700605834791, 42.2787496145039], 
                [-71.0698430330769, 42.2788261777005], 
                [-71.0696991957319, 42.2789132607962], 
                [-71.0696410423937, 42.2790382623341]
              ], 
              [
                [-71.0723663513026, 42.2784712441497], 
                [-71.0723688998231, 42.2784796559473]
              ], 
              [
                [-71.0723688998231, 42.2784796559473], 
                [-71.0723669414958, 42.2784799012029]
              ], 
              [
                [-71.0723688998231, 42.2784796559473], 
                [-71.0724484366584, 42.2787422036994]
              ], 
              [
                [-71.0723669414958, 42.2784799012029], 
                [-71.0724465448064, 42.2787426656285]
              ], 
              [
                [-71.0724484366584, 42.2787422036994], 
                [-71.0724465448064, 42.2787426656285]
              ], 
              [
                [-71.0724484366584, 42.2787422036994], 
                [-71.0726950870859, 42.2794425421409]
              ], 
              [
                [-71.0724465448064, 42.2787426656285], 
                [-71.0724490277498, 42.27875086138]
              ], 
              [
                [-71.0724465448064, 42.2787426656285], 
                [-71.0719220885806, 42.2788707840245], 
                [-71.07160856397, 42.2789573964906], 
                [-71.0709649408319, 42.2790883491504], 
                [-71.0698036895624, 42.2793169631682]
              ], 
              [
                [-71.0724490277498, 42.27875086138], 
                [-71.0719226787737, 42.2788794416873], 
                [-71.0716091541631, 42.2789660541416], 
                [-71.0709655301267, 42.2790970067835], 
                [-71.0698042788572, 42.2793256207698]
              ], 
              [
                [-71.0724490277498, 42.27875086138], 
                [-71.0726927945853, 42.2794430120406]
              ], 
              [
                [-71.0750173695376, 42.2789858153286], 
                [-71.0742787854908, 42.2791254415099], 
                [-71.0731539725842, 42.2793463429131], 
                [-71.0726950870859, 42.2794425421409]
              ], 
              [
                [-71.0750179615274, 42.278994472311], 
                [-71.0742793765822, 42.2791340991377], 
                [-71.0731545627773, 42.2793550005107], 
                [-71.0726977739469, 42.2794507603991]
              ], 
              [
                [-71.0726950870859, 42.2794425421409], 
                [-71.0726927945853, 42.2794430120406]
              ], 
              [
                [-71.0726950870859, 42.2794425421409], 
                [-71.0726977739469, 42.2794507603991]
              ], 
              [
                [-71.0726927945853, 42.2794430120406], 
                [-71.0726956781774, 42.2794511997253]
              ], 
              [
                [-71.0726927945853, 42.2794430120406], 
                [-71.0721074101254, 42.2795630211], 
                [-71.071357672596, 42.2796975209935], 
                [-71.0701740011736, 42.2799356204464]
              ], 
              [
                [-71.0726977739469, 42.2794507603991], 
                [-71.0726956781774, 42.2794511997253]
              ], 
              [
                [-71.0726977739469, 42.2794507603991], 
                [-71.0728430108671, 42.2798949322293], 
                [-71.0729248437962, 42.2801765855533]
              ], 
              [
                [-71.0726956781774, 42.2794511997253], 
                [-71.0721080003185, 42.2795716786678], 
                [-71.0713582627891, 42.2797061792074], 
                [-71.0701745904685, 42.2799442779629]
              ], 
              [
                [-71.0726956781774, 42.2794511997253], 
                [-71.0728436019586, 42.2799035897514], 
                [-71.0729230067415, 42.2801768892897]
              ], 
              [
                [-71.0752529087034, 42.2796804810507], 
                [-71.074590086771, 42.2798203894918], 
                [-71.0735489654079, 42.2800455454297], 
                [-71.0729248437962, 42.2801765855533]
              ], 
              [
                [-71.0752534997949, 42.2796891386024], 
                [-71.0745906778625, 42.2798290470242], 
                [-71.073549555601, 42.2800542035958], 
                [-71.0729278163215, 42.2801847425697]
              ], 
              [
                [-71.0713323508847, 42.2801271110631], 
                [-71.0714753240504, 42.2803099662301]
              ], 
              [
                [-71.0713329410779, 42.2801357685533], 
                [-71.0714753563898, 42.2803179098831]
              ], 
              [
                [-71.0729248437962, 42.2801765855533], 
                [-71.0729230067415, 42.2801768892897]
              ], 
              [
                [-71.0729248437962, 42.2801765855533], 
                [-71.0729278163215, 42.2801847425697]
              ], 
              [
                [-71.0729230067415, 42.2801768892897], 
                [-71.0729254339894, 42.2801852430368]
              ], 
              [
                [-71.0729230067415, 42.2801768892897], 
                [-71.0723822649579, 42.2802662834316], 
                [-71.0721248509166, 42.2802900831665], 
                [-71.0718341246496, 42.2803098213409], 
                [-71.0715211632827, 42.2803120285759], 
                [-71.0714753240504, 42.2803099662301]
              ], 
              [
                [-71.0729278163215, 42.2801847425697], 
                [-71.0729254339894, 42.2801852430368]
              ], 
              [
                [-71.0729278163215, 42.2801847425697], 
                [-71.0731578973237, 42.2808161016045]
              ], 
              [
                [-71.0729254339894, 42.2801852430368], 
                [-71.072382855151, 42.2802749409027], 
                [-71.0721254411097, 42.280298741299], 
                [-71.0718347148428, 42.280318478806], 
                [-71.0715217534759, 42.2803206860407], 
                [-71.0714759142436, 42.2803186236953]
              ], 
              [
                [-71.0729254339894, 42.2801852430368], 
                [-71.0731555329578, 42.2808166492549]
              ], 
              [
                [-71.0714753240504, 42.2803099662301], 
                [-71.0714753563898, 42.2803179098831]
              ], 
              [
                [-71.0714753563898, 42.2803179098831], 
                [-71.0714759142436, 42.2803186236953]
              ], 
              [
                [-71.0714753563898, 42.2803179098831], 
                [-71.0714757552418, 42.2804159566243], 
                [-71.071476325672, 42.2804196752208]
              ], 
              [
                [-71.0714759142436, 42.2803186236953], 
                [-71.071476325672, 42.2804196752208]
              ], 
              [
                [-71.0754665756887, 42.2803328693635], 
                [-71.0749542673805, 42.2804564550859], 
                [-71.0740253716474, 42.2806403879855], 
                [-71.0731578973237, 42.2808161016045]
              ], 
              [
                [-71.0754671667801, 42.2803415268255], 
                [-71.0749548593702, 42.2804651131956], 
                [-71.0740259627389, 42.2806490460698], 
                [-71.0731584884151, 42.2808247596647]
              ], 
              [
                [-71.071476325672, 42.2804196752208], 
                [-71.0714917245925, 42.2805201124685], 
                [-71.0714916931515, 42.2805247170071]
              ], 
              [
                [-71.071476325672, 42.2804196752208], 
                [-71.0714763454349, 42.2804246147395], 
                [-71.0714916931515, 42.2805247170071]
              ], 
              [
                [-71.0714916931515, 42.2805247170071], 
                [-71.0714923147857, 42.2805287699047], 
                [-71.0714912718417, 42.2806829433194], 
                [-71.0714288245564, 42.2808408276176], 
                [-71.071299226407, 42.2809843942233], 
                [-71.0711699211083, 42.2811127659344], 
                [-71.0709776861291, 42.2812765808845]
              ], 
              [
                [-71.0714916931515, 42.2805247170071], 
                [-71.0714906807502, 42.2806742859043], 
                [-71.0714282343632, 42.2808321695596], 
                [-71.0712986362138, 42.280975736185], 
                [-71.0711693309152, 42.2811041079137], 
                [-71.0709612451628, 42.2812814299477], 
                [-71.0709776861291, 42.2812765808845]
              ], 
              [
                [-71.0731555329578, 42.2808166492549], 
                [-71.0731578973237, 42.2808161016045]
              ], 
              [
                [-71.0731555329578, 42.2808166492549], 
                [-71.0731584884151, 42.2808247596647]
              ], 
              [
                [-71.0709776861291, 42.2812765808845], 
                [-71.0712636387487, 42.2811922399553], 
                [-71.0727156279632, 42.2809185540226], 
                [-71.0731555329578, 42.2808166492549]
              ], 
              [
                [-71.0709776861291, 42.2812765808845], 
                [-71.0709618353559, 42.281290087944], 
                [-71.0712642289418, 42.2812008979639], 
                [-71.0727162181563, 42.2809272120687], 
                [-71.0731584884151, 42.2808247596647]
              ], 
              [
                [-71.0759550022851, 42.2816524945049], 
                [-71.0752636893851, 42.2817737308863], 
                [-71.0737713217969, 42.2820495465068], 
                [-71.0725095759966, 42.2823138259757], 
                [-71.0713478477217, 42.2825492019559]
              ], 
              [
                [-71.0759555933765, 42.2816611524501], 
                [-71.0752642804766, 42.281782388815], 
                [-71.0737719128883, 42.2820582050622], 
                [-71.0725101670881, 42.2823224838302], 
                [-71.0713484379148, 42.2825578604426]
              ], 
              [
                [-71.0712639810068, 42.2820092663971], 
                [-71.0715131655818, 42.2819432378527], 
                [-71.0724254209225, 42.2817592635626], 
                [-71.0735112918615, 42.2815325964283], 
                [-71.0742358873427, 42.2813934846785], 
                [-71.0749578408787, 42.2812504234514], 
                [-71.0753329701548, 42.2811600889382], 
                [-71.0755233581978, 42.2811028384871], 
                [-71.0757355806921, 42.2810377886456]
              ], 
              [
                [-71.0712645711999, 42.282017924958], 
                [-71.0715137557749, 42.2819518964227], 
                [-71.0724260111156, 42.2817679214932], 
                [-71.0735118829529, 42.2815412543901], 
                [-71.0742364784342, 42.2814021426594], 
                [-71.0749584328684, 42.2812590814519], 
                [-71.0753335621446, 42.2811687469512], 
                [-71.0755239501876, 42.2811114965079], 
                [-71.0757361726819, 42.2810464466754]
              ], 
              [
                [-71.0761023197035, 42.282200536043], 
                [-71.0756337800108, 42.2822927744977], 
                [-71.0747744650848, 42.2824645942291], 
                [-71.0738239783439, 42.2826422560352], 
                [-71.0729234011019, 42.2828071542997], 
                [-71.0720489118341, 42.2829788975284], 
                [-71.0716697365459, 42.2830496090938], 
                [-71.0715402470926, 42.2830628539206], 
                [-71.0713853443, 42.2830604500602]
              ], 
              [
                [-71.0761029116932, 42.282209193913], 
                [-71.0756343720006, 42.2823014323551], 
                [-71.0747750570745, 42.2824732520629], 
                [-71.0738245694353, 42.2826509138445], 
                [-71.0729239921934, 42.282815812751], 
                [-71.0720495020272, 42.2829875552915], 
                [-71.071670326739, 42.2830582675117], 
                [-71.0715408372858, 42.2830715123367], 
                [-71.0713859353914, 42.2830691084766]
              ], 
              [
                [-71.0762093476814, 42.2829087913364], 
                [-71.075851583738, 42.2829800579227], 
                [-71.0751153236328, 42.2831337667655], 
                [-71.0743323637093, 42.2833019235973], 
                [-71.073342995188, 42.2835126393845], 
                [-71.0726815198302, 42.2836435393787], 
                [-71.0718837942983, 42.2838082509305], 
                [-71.0715501600018, 42.2838953490724]
              ], 
              [
                [-71.0762099396711, 42.2829174497737], 
                [-71.0758521757278, 42.2829887163502], 
                [-71.0751159156226, 42.2831424251718], 
                [-71.0743329548007, 42.2833105819806], 
                [-71.0733435862794, 42.2835212977388], 
                [-71.0726821109216, 42.283652197715], 
                [-71.0718843853898, 42.2838169092442], 
                [-71.0715507510933, 42.2839040080387]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 44, 
            "OBJECTID" : null, 
            "Name" : "Dorchester Unified Neighborhood - East Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 10323.5024127, 
            "Link" : "https://www.boston.gov/dorchester-unified-neighborhood-east-and-west", 
            "GlobalID" : "2f0c23dc-5c06-4c96-b857-b793b4bf03d8", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 45, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0816667205072, 42.3406623864279], 
                [-71.0773106804231, 42.344193010313], 
                [-71.0771908999614, 42.3442966662807], 
                [-71.0765025524002, 42.344835429694], 
                [-71.0758426688571, 42.3453692348119], 
                [-71.0752393612106, 42.3458644221175], 
                [-71.0747338648272, 42.3462789403255], 
                [-71.0739170752484, 42.3469325667168], 
                [-71.0735311679855, 42.3472704326771], 
                [-71.0726585022977, 42.3479671707526], 
                [-71.0726134958036, 42.3480046998952], 
                [-71.0718167611135, 42.3486595106808], 
                [-71.0698978626486, 42.3501564001024]
              ], 
              [
                [-71.0666292490625, 42.348782684126], 
                [-71.0668360951398, 42.3486670971596], 
                [-71.0670990266336, 42.3485201681394], 
                [-71.0675339711312, 42.3482749997509], 
                [-71.067821272122, 42.3481147430702], 
                [-71.0680299507625, 42.3479983389239], 
                [-71.0681305701592, 42.3479239398773], 
                [-71.0683414622486, 42.3477497957977], 
                [-71.068519520016, 42.3476098291473], 
                [-71.0685981962652, 42.3474983032179]
              ], 
              [
                [-71.0666292490625, 42.348782684126], 
                [-71.0665121339023, 42.3489016089976], 
                [-71.0664589671122, 42.3490687988129], 
                [-71.0664736240244, 42.3492698020381], 
                [-71.0665618430769, 42.3496914678829], 
                [-71.0667069066222, 42.3503163056909], 
                [-71.066818883419, 42.350793910851], 
                [-71.0668682305725, 42.3509704882621]
              ], 
              [
                [-71.0698978626486, 42.3501564001024], 
                [-71.0686837275583, 42.3504956521964], 
                [-71.0681434987128, 42.3506517389068], 
                [-71.0676805079136, 42.3507726631861], 
                [-71.0675356608623, 42.3508079380901], 
                [-71.0673687844252, 42.3508485791579], 
                [-71.0668682305725, 42.3509704882621]
              ], 
              [
                [-71.0698978626486, 42.3501564001024], 
                [-71.0692684508582, 42.3506559579097], 
                [-71.0688294378907, 42.3510431277323], 
                [-71.0687378456643, 42.3511249346683], 
                [-71.0683496153581, 42.3514518599466], 
                [-71.0684295932661, 42.3516915947315], 
                [-71.0679246915674, 42.3517565868505], 
                [-71.0679082146685, 42.3517589057677], 
                [-71.0675045072882, 42.3518157427785], 
                [-71.0672522971874, 42.3518249566974]
              ], 
              [
                [-71.0630369967341, 42.3509488642346], 
                [-71.0635547389515, 42.3510040250083], 
                [-71.0644019436892, 42.351074494207], 
                [-71.0649117573759, 42.351117343175]
              ], 
              [
                [-71.0668682305725, 42.3509704882621], 
                [-71.0668133767463, 42.35096336678], 
                [-71.0664333552451, 42.3510437431518], 
                [-71.0661446780353, 42.3510962927925], 
                [-71.0660382285725, 42.3511046172145], 
                [-71.0659150237329, 42.3511142508113], 
                [-71.065754609776, 42.3511061481273], 
                [-71.0653907714247, 42.3510912552519], 
                [-71.064923029436, 42.3510816150127]
              ], 
              [
                [-71.0668682305725, 42.3509704882621], 
                [-71.0670325593874, 42.3513441621264], 
                [-71.0672522971874, 42.3518249566974]
              ], 
              [
                [-71.0649161959517, 42.3510814742696], 
                [-71.0644073524455, 42.3510387069348], 
                [-71.0635608960044, 42.350968300101], 
                [-71.0630438993887, 42.3509132182982]
              ], 
              [
                [-71.0649161959517, 42.3510814742696], 
                [-71.0649151646857, 42.3510814530254]
              ], 
              [
                [-71.0649172227261, 42.3510815612382], 
                [-71.0649161959517, 42.3510814742696]
              ], 
              [
                [-71.064923029436, 42.3510816150127], 
                [-71.0650807259892, 42.3505817651583], 
                [-71.0652131178992, 42.3500910717266], 
                [-71.0653619570636, 42.3494604942581], 
                [-71.0654518802202, 42.3490474781992], 
                [-71.0655438793834, 42.348624917733], 
                [-71.0658170498748, 42.3486579040228], 
                [-71.0661517882008, 42.3487043941806], 
                [-71.0664817555743, 42.3487584993198], 
                [-71.0666292490625, 42.348782684126]
              ], 
              [
                [-71.064923029436, 42.3510816150127], 
                [-71.0649161959517, 42.3510814742696]
              ], 
              [
                [-71.0649117573759, 42.351117343175], 
                [-71.064923029436, 42.3510816150127]
              ], 
              [
                [-71.0649138154162, 42.3511174507239], 
                [-71.0653887591985, 42.3511272390033], 
                [-71.0657516228777, 42.3511420927011], 
                [-71.0659159274381, 42.3511503912257], 
                [-71.0660433184269, 42.3511404296767], 
                [-71.0661530476388, 42.3511318509925], 
                [-71.0664458023017, 42.3510785571692], 
                [-71.0668314194088, 42.3509969958097], 
                [-71.0668682305725, 42.3509704882621]
              ], 
              [
                [-71.0672522971874, 42.3518249566974], 
                [-71.0674691693616, 42.3525038068339]
              ], 
              [
                [-71.0645439763187, 42.3523764317513], 
                [-71.0647253138353, 42.3516876532984], 
                [-71.0647726972716, 42.3514964407157], 
                [-71.0649117573759, 42.351117343175]
              ], 
              [
                [-71.0645439763187, 42.3523764317513], 
                [-71.0641039967639, 42.3523377182203], 
                [-71.0639009343906, 42.352327047183], 
                [-71.0633313773477, 42.3523190196726], 
                [-71.0628805299745, 42.3523578142071], 
                [-71.0626095639489, 42.3523811989942]
              ], 
              [
                [-71.0674691693616, 42.3525038068339], 
                [-71.0668841235665, 42.3525240567848], 
                [-71.0663445477961, 42.3524983418753], 
                [-71.0657210208692, 42.3524597738066], 
                [-71.065345048075, 42.3524331540183], 
                [-71.0645439763187, 42.3523764317513]
              ], 
              [
                [-71.0674691693616, 42.3525038068339], 
                [-71.0678650066016, 42.3524647302456], 
                [-71.0686322082785, 42.3523162659415], 
                [-71.0694651271082, 42.3521475976922], 
                [-71.0705791413668, 42.3518878747358], 
                [-71.0706819921786, 42.3519014562713], 
                [-71.0708889487487, 42.3523083552708], 
                [-71.0710949441215, 42.3526871223255], 
                [-71.0712856106422, 42.35307612318], 
                [-71.0715017264349, 42.3534974601077], 
                [-71.0716628401795, 42.3538465596953], 
                [-71.0718779813001, 42.3542761251765], 
                [-71.0720622482228, 42.3546554957566], 
                [-71.0722531123729, 42.3550513551799], 
                [-71.0723681173905, 42.355261281179], 
                [-71.0723978480331, 42.3553158871824], 
                [-71.0726168896387, 42.355415332016]
              ], 
              [
                [-71.0674691693616, 42.3525038068339], 
                [-71.0676227642072, 42.3528397428705], 
                [-71.0677017629516, 42.3530471077753], 
                [-71.067819348829, 42.3532798307673], 
                [-71.0678299381696, 42.3533007927891], 
                [-71.0682263197887, 42.3539949466969], 
                [-71.068660118036, 42.3547927667823], 
                [-71.0690543005793, 42.3555294401599], 
                [-71.0691672592347, 42.355740540211], 
                [-71.0694309507032, 42.356183691944], 
                [-71.0694493410137, 42.3562199867707]
              ], 
              [
                [-71.0747963857743, 42.354817244677], 
                [-71.0742074906983, 42.3549817726852], 
                [-71.0732124897401, 42.3552453802534], 
                [-71.07281317063, 42.3553542397428], 
                [-71.0726168896387, 42.355415332016]
              ], 
              [
                [-71.0726168896387, 42.355415332016], 
                [-71.0722525410443, 42.3555219520931], 
                [-71.0716402430585, 42.3556628218634], 
                [-71.0710385218368, 42.3558045370408], 
                [-71.0703787802275, 42.3559559192726], 
                [-71.0700161519069, 42.3560391238152], 
                [-71.0698484876473, 42.356077594096], 
                [-71.0696726190742, 42.3561647469323], 
                [-71.0694493410137, 42.3562199867707]
              ], 
              [
                [-71.0694493410137, 42.3562199867707], 
                [-71.0694349706641, 42.3562235422353]
              ], 
              [
                [-71.0694493410137, 42.3562199867707], 
                [-71.0696971071489, 42.3567089761148], 
                [-71.0698778383026, 42.3570315827439], 
                [-71.0702797903748, 42.3577816070161], 
                [-71.0702932866636, 42.3578047289071], 
                [-71.0706616255745, 42.3584504032152], 
                [-71.0706838579794, 42.3584912902592], 
                [-71.0707000923333, 42.3585433822862], 
                [-71.0707106349614, 42.3585989612286], 
                [-71.070729219308, 42.3588086191498], 
                [-71.0707757969555, 42.3594861976963], 
                [-71.0708315526903, 42.3600990988191], 
                [-71.0708386332113, 42.3604627171825], 
                [-71.0708479981482, 42.3605705029272], 
                [-71.0708612770447, 42.3606963227578], 
                [-71.0708757695652, 42.3607833941813]
              ], 
              [
                [-71.0598531679412, 42.3592949278571], 
                [-71.0598646699701, 42.3591128039064], 
                [-71.0599230083613, 42.3587237627521], 
                [-71.0600353121448, 42.3585695792988], 
                [-71.0601953919284, 42.3583497982051], 
                [-71.0604427196857, 42.3580102287207], 
                [-71.0606766373925, 42.3577718542912], 
                [-71.0610638813485, 42.3573815303079], 
                [-71.0615500621567, 42.356910345898], 
                [-71.0617910828424, 42.3566769439817], 
                [-71.0620211647428, 42.3565433593087], 
                [-71.0622712458364, 42.3562575468325], 
                [-71.0624442901063, 42.3560879299263], 
                [-71.0631061149087, 42.3554348667405], 
                [-71.063341216595, 42.3551818209881], 
                [-71.0636107156718, 42.3546749988528], 
                [-71.0641544775913, 42.3536022511959], 
                [-71.0642292156264, 42.3533932961907], 
                [-71.0643128874069, 42.3531489368037], 
                [-71.0644172402018, 42.3528441748269], 
                [-71.0645439763187, 42.3523764317513]
              ], 
              [
                [-71.0707065269657, 42.3609366236629], 
                [-71.069688189573, 42.3611990094643], 
                [-71.0679274188526, 42.3612966215987], 
                [-71.0651027957991, 42.3613083066882], 
                [-71.0627022323569, 42.3611902263826], 
                [-71.0613998458749, 42.3610560426202], 
                [-71.0604025416364, 42.3606401449481], 
                [-71.059921394987, 42.359741771092], 
                [-71.0597211506287, 42.3589787570968], 
                [-71.0598249841974, 42.35882670507]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 45, 
            "OBJECTID" : null, 
            "Name" : "Connect Downtown", 
            "Shape_Leng" : null, 
            "Shape__Length" : 10626.7404154, 
            "Link" : "https://www.boston.gov/departments/transportation/connect-downtown", 
            "GlobalID" : "e9241d28-a893-422e-af99-f2e7456badc4", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Bike Network", 
            "Descriptio" : "Connect Downtown centers people — residents, commuters, and tourists — in a redesign of iconic streets in our downtown neighborhoods.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 46, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0898854693484, 42.2730061365035], 
                [-71.0895940846163, 42.2733376427996], 
                [-71.0893980731196, 42.2735670839619], 
                [-71.0888956283132, 42.2741099699898], 
                [-71.0886195284157, 42.2743914524216], 
                [-71.0885086727164, 42.2745122168844], 
                [-71.0883734367402, 42.2746595374507], 
                [-71.0880920502573, 42.274966885683]
              ], 
              [
                [-71.0898860649314, 42.2730147923132], 
                [-71.0895946801993, 42.2733462992285], 
                [-71.0893986687027, 42.2735757396946], 
                [-71.0888962238963, 42.2741186263126], 
                [-71.0886201239987, 42.2744001080411], 
                [-71.0885092674011, 42.274520873152], 
                [-71.0883740323233, 42.2746681936981], 
                [-71.088097970155, 42.2749697258862]
              ], 
              [
                [-71.0905206294582, 42.2735238258861], 
                [-71.0903758407974, 42.2736825516845], 
                [-71.0898567430222, 42.2742248198819]
              ], 
              [
                [-71.0905212250413, 42.2735324816248], 
                [-71.0903764372787, 42.2736912074014], 
                [-71.0898627725144, 42.2742277997042]
              ], 
              [
                [-71.0920357378979, 42.2740558970252], 
                [-71.091680721901, 42.2741812412101], 
                [-71.0914455824855, 42.27431038586], 
                [-71.0913152369377, 42.2744022051442], 
                [-71.0912454683829, 42.2744711649028], 
                [-71.0911894377637, 42.2745531219426], 
                [-71.0911290736715, 42.2746311166617], 
                [-71.0909635707585, 42.274771764147]
              ], 
              [
                [-71.0920363343792, 42.2740645526909], 
                [-71.0916813183823, 42.2741898975232], 
                [-71.0914461789668, 42.2743190421554], 
                [-71.0913158334191, 42.274410861427], 
                [-71.0912460648642, 42.2744798211761], 
                [-71.091190034245, 42.2745617782046], 
                [-71.0911296701529, 42.2746397729129], 
                [-71.0909641672399, 42.2747804203789]
              ], 
              [
                [-71.0898567430222, 42.2742248198819], 
                [-71.0894424525896, 42.2746976872781], 
                [-71.0893780622484, 42.2747841120558], 
                [-71.0893776175823, 42.2748527603229], 
                [-71.0893782652676, 42.2748534343157]
              ], 
              [
                [-71.0898627725144, 42.2742277997042], 
                [-71.0898567430222, 42.2742248198819]
              ], 
              [
                [-71.0898627725144, 42.2742277997042], 
                [-71.0898573386053, 42.274233476189]
              ], 
              [
                [-71.0898573386053, 42.274233476189], 
                [-71.0894430481726, 42.2747063428556], 
                [-71.0893786587297, 42.274792768286], 
                [-71.0893782652676, 42.2748534343157]
              ], 
              [
                [-71.0909635707585, 42.274771764147], 
                [-71.0898627725144, 42.2742277997042]
              ], 
              [
                [-71.0909635707585, 42.274771764147], 
                [-71.0909580164751, 42.2747773807608]
              ], 
              [
                [-71.0909580164751, 42.2747773807608], 
                [-71.0898573386053, 42.274233476189]
              ], 
              [
                [-71.0909580164751, 42.2747773807608], 
                [-71.0908731894612, 42.2748631593533], 
                [-71.0903511694664, 42.2753592831708]
              ], 
              [
                [-71.0909641672399, 42.2747804203789], 
                [-71.0909580164751, 42.2747773807608]
              ], 
              [
                [-71.0909641672399, 42.2747804203789], 
                [-71.0908737859425, 42.2748718155727], 
                [-71.0903517659477, 42.2753679393221]
              ], 
              [
                [-71.0893782652676, 42.2748534343157], 
                [-71.0894237083429, 42.2749007540441], 
                [-71.0896374543799, 42.2750050539356], 
                [-71.0903511694664, 42.2753592831708]
              ], 
              [
                [-71.0893782652676, 42.2748534343157], 
                [-71.0893782131653, 42.2748614165437], 
                [-71.0894243048242, 42.2749094102584], 
                [-71.0896380508613, 42.2750137101356], 
                [-71.0903454534862, 42.2753648060122]
              ], 
              [
                [-71.0880920502573, 42.274966885683], 
                [-71.0878810315055, 42.2752002079836], 
                [-71.0876599668938, 42.2754357408143]
              ], 
              [
                [-71.088097970155, 42.2749697258862], 
                [-71.0880920502573, 42.274966885683]
              ], 
              [
                [-71.088097970155, 42.2749697258862], 
                [-71.0880926458403, 42.2749755418882]
              ], 
              [
                [-71.0880926458403, 42.2749755418882], 
                [-71.0878816270885, 42.2752088641567], 
                [-71.0876660547765, 42.2754385451036]
              ], 
              [
                [-71.0903511694664, 42.2753592831708], 
                [-71.0903454534862, 42.2753648060122]
              ], 
              [
                [-71.0903454534862, 42.2753648060122], 
                [-71.0903517659477, 42.2753679393221]
              ], 
              [
                [-71.0903454534862, 42.2753648060122], 
                [-71.089863771441, 42.275830202528]
              ], 
              [
                [-71.0903517659477, 42.2753679393221], 
                [-71.089864367024, 42.2758388592793]
              ], 
              [
                [-71.0876599668938, 42.2754357408143], 
                [-71.0872029022806, 42.2759281419276]
              ], 
              [
                [-71.0876660547765, 42.2754385451036], 
                [-71.0876599668938, 42.2754357408143]
              ], 
              [
                [-71.0876660547765, 42.2754385451036], 
                [-71.0876605624769, 42.275444396955]
              ], 
              [
                [-71.0876605624769, 42.275444396955], 
                [-71.0872089111116, 42.2759309674647]
              ], 
              [
                [-71.0860491591303, 42.2757799409705], 
                [-71.0854307912281, 42.276461383193], 
                [-71.0845343183886, 42.2774614181575], 
                [-71.0839660351567, 42.2780676294111], 
                [-71.08354605749, 42.2785607131579]
              ], 
              [
                [-71.086049753815, 42.2757885977287], 
                [-71.0854313859128, 42.2764700398576], 
                [-71.0845349130733, 42.2774700746847], 
                [-71.0839666298415, 42.2780762865197], 
                [-71.0835466512764, 42.2785693701988]
              ], 
              [
                [-71.089863771441, 42.275830202528], 
                [-71.0886049146227, 42.2752129286959], 
                [-71.088097970155, 42.2749697258862]
              ], 
              [
                [-71.089863771441, 42.275830202528], 
                [-71.0898585046185, 42.275835984552]
              ], 
              [
                [-71.0898585046185, 42.275835984552], 
                [-71.0886055102057, 42.2752215848673], 
                [-71.0880926458403, 42.2749755418882]
              ], 
              [
                [-71.0898585046185, 42.275835984552], 
                [-71.0897447258012, 42.2759608838521], 
                [-71.0893935330342, 42.2762831782037]
              ], 
              [
                [-71.089864367024, 42.2758388592793], 
                [-71.0898585046185, 42.275835984552]
              ], 
              [
                [-71.089864367024, 42.2758388592793], 
                [-71.0897453222826, 42.2759695399207], 
                [-71.0893941286172, 42.2762918348927]
              ], 
              [
                [-71.0872029022806, 42.2759281419276], 
                [-71.0867559023919, 42.2764171998882], 
                [-71.086223171784, 42.2770083612211], 
                [-71.0859918663781, 42.2772714288867], 
                [-71.0855948191074, 42.2777370299944], 
                [-71.0854188202786, 42.2779429031087], 
                [-71.0847405275604, 42.2786871403979], 
                [-71.0847203639755, 42.2787095130685], 
                [-71.0842982051993, 42.2791778963748], 
                [-71.0838512789724, 42.2796483757868], 
                [-71.0835751826682, 42.279892704376], 
                [-71.0834159769453, 42.2799917261307], 
                [-71.0830005070247, 42.2802282326819], 
                [-71.0827350548583, 42.2804090198959]
              ], 
              [
                [-71.0872089111116, 42.2759309674647], 
                [-71.0872029022806, 42.2759281419276]
              ], 
              [
                [-71.0872089111116, 42.2759309674647], 
                [-71.0872034978637, 42.2759367986655]
              ], 
              [
                [-71.0872034978637, 42.2759367986655], 
                [-71.0867564970766, 42.2764258565588], 
                [-71.0862237664687, 42.2770170178106], 
                [-71.0859924610628, 42.27728008544], 
                [-71.0855954137921, 42.2777456864838], 
                [-71.0854194149633, 42.2779515595698], 
                [-71.0847411222451, 42.2786957974213], 
                [-71.0847209586603, 42.2787181700889], 
                [-71.0842987989857, 42.2791865533309], 
                [-71.0838518727588, 42.2796570333429], 
                [-71.0835757764546, 42.2799013618985], 
                [-71.08341657163, 42.2800003836396], 
                [-71.0830011008111, 42.2802368901583], 
                [-71.0827356486447, 42.2804176773475]
              ], 
              [
                [-71.0893935330342, 42.2762831782037], 
                [-71.0885428599012, 42.2758423588025], 
                [-71.0876660547765, 42.2754385451036]
              ], 
              [
                [-71.0893935330342, 42.2762831782037], 
                [-71.0893881548206, 42.276288739515]
              ], 
              [
                [-71.0893881548206, 42.276288739515], 
                [-71.0885434554842, 42.2758510155521], 
                [-71.0876605624769, 42.275444396955]
              ], 
              [
                [-71.0893881548206, 42.276288739515], 
                [-71.0889314621099, 42.276760933405]
              ], 
              [
                [-71.0893941286172, 42.2762918348927], 
                [-71.0893881548206, 42.276288739515]
              ], 
              [
                [-71.0893941286172, 42.2762918348927], 
                [-71.088932057693, 42.2767695893638]
              ], 
              [
                [-71.0880819756514, 42.2763414985023], 
                [-71.0872089111116, 42.2759309674647]
              ], 
              [
                [-71.0880819756514, 42.2763414985023], 
                [-71.0880762488914, 42.2763471827727]
              ], 
              [
                [-71.0880762488914, 42.2763471827727], 
                [-71.0872034978637, 42.2759367986655]
              ], 
              [
                [-71.0880762488914, 42.2763471827727], 
                [-71.0876272601326, 42.2767928347581], 
                [-71.0870644314712, 42.2773821999779]
              ], 
              [
                [-71.0880825712344, 42.2763501551833], 
                [-71.0880762488914, 42.2763471827727]
              ], 
              [
                [-71.0880825712344, 42.2763501551833], 
                [-71.0876278557157, 42.2768014913771], 
                [-71.0870650261559, 42.277390856516]
              ], 
              [
                [-71.0889314621099, 42.276760933405], 
                [-71.0880819756514, 42.2763414985023]
              ], 
              [
                [-71.0889314621099, 42.276760933405], 
                [-71.0889258988434, 42.2767665485123]
              ], 
              [
                [-71.0889258988434, 42.2767665485123], 
                [-71.0880825712344, 42.2763501551833]
              ], 
              [
                [-71.0889258988434, 42.2767665485123], 
                [-71.0887958928588, 42.2768977476633], 
                [-71.0879526119623, 42.2777083739754]
              ], 
              [
                [-71.088932057693, 42.2767695893638], 
                [-71.0889258988434, 42.2767665485123]
              ], 
              [
                [-71.088932057693, 42.2767695893638], 
                [-71.0887964884418, 42.2769064042679], 
                [-71.0879532075453, 42.2777170304687]
              ], 
              [
                [-71.0830903169936, 42.2769733991957], 
                [-71.0828065751279, 42.2772869108496], 
                [-71.082205531236, 42.2779183155359]
              ], 
              [
                [-71.08309091078, 42.27698205579], 
                [-71.0828071689143, 42.2772955680655], 
                [-71.0822116110338, 42.2779212081138]
              ], 
              [
                [-71.0836452422772, 42.2773614167045], 
                [-71.0833106494783, 42.2777169467219], 
                [-71.0828454946376, 42.278222805825]
              ], 
              [
                [-71.0836458360636, 42.2773700739101], 
                [-71.0833112432647, 42.277725603214], 
                [-71.0828514208235, 42.2782256638271]
              ], 
              [
                [-71.082205531236, 42.2779183155359], 
                [-71.0816377555522, 42.2785875383494]
              ], 
              [
                [-71.0822116110338, 42.2779212081138], 
                [-71.082205531236, 42.2779183155359]
              ], 
              [
                [-71.0822116110338, 42.2779212081138], 
                [-71.082206124124, 42.277926972665]
              ], 
              [
                [-71.082206124124, 42.277926972665], 
                [-71.0816428283386, 42.2785909174187]
              ], 
              [
                [-71.0828454946376, 42.278222805825], 
                [-71.0822116110338, 42.2779212081138]
              ], 
              [
                [-71.0828454946376, 42.278222805825], 
                [-71.0828403086635, 42.2782287132487]
              ], 
              [
                [-71.0828514208235, 42.2782256638271], 
                [-71.0828454946376, 42.278222805825]
              ], 
              [
                [-71.0828514208235, 42.2782256638271], 
                [-71.082846088424, 42.2782314629123]
              ], 
              [
                [-71.0828403086635, 42.2782287132487], 
                [-71.082206124124, 42.277926972665]
              ], 
              [
                [-71.0828403086635, 42.2782287132487], 
                [-71.0825958483286, 42.278507181713], 
                [-71.0821873861655, 42.2789462869667]
              ], 
              [
                [-71.082846088424, 42.2782314629123], 
                [-71.0828403086635, 42.2782287132487]
              ], 
              [
                [-71.082846088424, 42.2782314629123], 
                [-71.082596442115, 42.2785158387612], 
                [-71.0821930159074, 42.2789495297648]
              ], 
              [
                [-71.08354605749, 42.2785607131579], 
                [-71.0828514208235, 42.2782256638271]
              ], 
              [
                [-71.08354605749, 42.2785607131579], 
                [-71.0835408274985, 42.2785665613963]
              ], 
              [
                [-71.0835408274985, 42.2785665613963], 
                [-71.082846088424, 42.2782314629123]
              ], 
              [
                [-71.0835408274985, 42.2785665613963], 
                [-71.0831829018583, 42.2789667845851], 
                [-71.0828539244283, 42.2793302107736]
              ], 
              [
                [-71.0835466512764, 42.2785693701988], 
                [-71.0835408274985, 42.2785665613963]
              ], 
              [
                [-71.0835466512764, 42.2785693701988], 
                [-71.0831834965431, 42.2789754415702], 
                [-71.0828545182146, 42.2793388677087]
              ], 
              [
                [-71.0816377555522, 42.2785875383494], 
                [-71.0815031942108, 42.278511651475]
              ], 
              [
                [-71.0816428283386, 42.2785909174187], 
                [-71.0816377555522, 42.2785875383494]
              ], 
              [
                [-71.0816428283386, 42.2785909174187], 
                [-71.0816383493386, 42.2785961960512]
              ], 
              [
                [-71.0816383493386, 42.2785961960512], 
                [-71.0815037870989, 42.2785203085226]
              ], 
              [
                [-71.0818789756639, 42.278748220741], 
                [-71.0816428283386, 42.2785909174187]
              ], 
              [
                [-71.0818789756639, 42.278748220741], 
                [-71.0818735417547, 42.2787528639586]
              ], 
              [
                [-71.0818735417547, 42.2787528639586], 
                [-71.0816383493386, 42.2785961960512]
              ], 
              [
                [-71.0818735417547, 42.2787528639586], 
                [-71.081595691939, 42.2789902697699], 
                [-71.0811016454822, 42.2793936080908]
              ], 
              [
                [-71.081879568552, 42.2787568784207], 
                [-71.0818735417547, 42.2787528639586]
              ], 
              [
                [-71.081879568552, 42.2787568784207], 
                [-71.0815962848271, 42.2789989274164], 
                [-71.0811022383703, 42.2794022650171]
              ], 
              [
                [-71.0821873861655, 42.2789462869667], 
                [-71.0818789756639, 42.278748220741]
              ], 
              [
                [-71.0821930159074, 42.2789495297648], 
                [-71.0821873861655, 42.2789462869667]
              ], 
              [
                [-71.0821930159074, 42.2789495297648], 
                [-71.0821879790536, 42.2789549439545]
              ], 
              [
                [-71.0821879790536, 42.2789549439545], 
                [-71.081879568552, 42.2787568784207]
              ], 
              [
                [-71.0828539244283, 42.2793302107736], 
                [-71.0821930159074, 42.2789495297648]
              ], 
              [
                [-71.0828539244283, 42.2793302107736], 
                [-71.0828489522531, 42.2793356621505]
              ], 
              [
                [-71.0828489522531, 42.2793356621505], 
                [-71.0821879790536, 42.2789549439545]
              ], 
              [
                [-71.0828489522531, 42.2793356621505], 
                [-71.0824114367772, 42.2798153316207], 
                [-71.0821446613923, 42.2801108980384]
              ], 
              [
                [-71.0828545182146, 42.2793388677087], 
                [-71.0828489522531, 42.2793356621505]
              ], 
              [
                [-71.0828545182146, 42.2793388677087], 
                [-71.0824120305636, 42.2798239891538], 
                [-71.0821452551787, 42.2801195555309]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 46, 
            "OBJECTID" : null, 
            "Name" : "West Selden Street and Vicinity Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 10739.21965034, 
            "Link" : "https://www.boston.gov/departments/transportation/neighborhood-slow-streets/west-selden-street-and-vicinity", 
            "GlobalID" : "a6ee7a15-bc79-47f2-8980-695fee7562e2", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 47, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0756471810783, 42.3320108746416], 
                [-71.0761594696235, 42.3316987198363], 
                [-71.0768451159506, 42.3312809231759]
              ], 
              [
                [-71.0756471810783, 42.3320108746416], 
                [-71.0749546087403, 42.3313833021325], 
                [-71.0749132305417, 42.3313227894979]
              ], 
              [
                [-71.0761253578972, 42.3327927875641], 
                [-71.0763728141136, 42.3326352314027], 
                [-71.0766120920676, 42.3324913608515], 
                [-71.0769342162504, 42.3322714048959]
              ], 
              [
                [-71.0744062672094, 42.3328489384669], 
                [-71.0746778422928, 42.3326475739449], 
                [-71.07496200457, 42.332451876032], 
                [-71.0756471810783, 42.3320108746416]
              ], 
              [
                [-71.0744062672094, 42.3328489384669], 
                [-71.0746398246917, 42.3330219245035], 
                [-71.075018276836, 42.3334610082791]
              ], 
              [
                [-71.0775674907965, 42.3332447041207], 
                [-71.07786784341, 42.3330448622574], 
                [-71.0782052928516, 42.3328203360778], 
                [-71.0792233409867, 42.3321417827357], 
                [-71.0792491549747, 42.3321281849777]
              ], 
              [
                [-71.0787381582067, 42.3332977029417], 
                [-71.0791231285268, 42.3330384253963], 
                [-71.0797415530229, 42.3326414219324], 
                [-71.0798389402812, 42.3325608261293]
              ], 
              [
                [-71.0787381582067, 42.3332977029417], 
                [-71.0784504942966, 42.3330359610206], 
                [-71.0782060941488, 42.3328210393338]
              ], 
              [
                [-71.0805752866246, 42.3334318012014], 
                [-71.0809066436919, 42.3329329166953]
              ], 
              [
                [-71.075018276836, 42.3334610082791], 
                [-71.0752861912847, 42.333322049752], 
                [-71.075753715881, 42.3330260404301], 
                [-71.0761253578972, 42.3327927875641]
              ], 
              [
                [-71.075018276836, 42.3334610082791], 
                [-71.0754953100997, 42.3340911711491], 
                [-71.0757420979695, 42.3344488160357]
              ], 
              [
                [-71.073504364054, 42.3335006339116], 
                [-71.074165147709, 42.3330197848591], 
                [-71.0744062672094, 42.3328489384669]
              ], 
              [
                [-71.0770203700761, 42.3335877616057], 
                [-71.0770204626025, 42.3335877031677], 
                [-71.0775674907965, 42.3332447041207]
              ], 
              [
                [-71.0770203700761, 42.3335877616057], 
                [-71.0763949144662, 42.333028404531], 
                [-71.0761253578972, 42.3327927875641]
              ], 
              [
                [-71.0780918329362, 42.333715189368], 
                [-71.0787381582067, 42.3332977029417]
              ], 
              [
                [-71.0780918329362, 42.333715189368], 
                [-71.0775674907965, 42.3332447041207]
              ], 
              [
                [-71.0822875824557, 42.3340570582711], 
                [-71.0824787475414, 42.3338409646791]
              ], 
              [
                [-71.0822875824557, 42.3340570582711], 
                [-71.0834591544695, 42.3346759833285], 
                [-71.0848527271394, 42.3354274198464]
              ], 
              [
                [-71.07756250335, 42.3340610545987], 
                [-71.0775625617405, 42.3340610160831], 
                [-71.0780918329362, 42.333715189368]
              ], 
              [
                [-71.07756250335, 42.3340610545987], 
                [-71.0775621808548, 42.3340607737003], 
                [-71.0770208946922, 42.3335882191481], 
                [-71.0770203700761, 42.3335877616057]
              ], 
              [
                [-71.07982971099, 42.3341142187473], 
                [-71.0803374235172, 42.333727136579], 
                [-71.0805752866246, 42.3334318012014]
              ], 
              [
                [-71.07982971099, 42.3341142187473], 
                [-71.0797323372064, 42.3340292181114], 
                [-71.079469141608, 42.3338396053386], 
                [-71.0788192599072, 42.333371407414], 
                [-71.0787381582067, 42.3332977029417]
              ], 
              [
                [-71.0820264745419, 42.3343209103088], 
                [-71.0822866634792, 42.3340579886226], 
                [-71.0822875824557, 42.3340570582711]
              ], 
              [
                [-71.0820264745419, 42.3343209103088], 
                [-71.0816760192917, 42.3341145142548], 
                [-71.0807252163439, 42.3335306730344], 
                [-71.0805752866246, 42.3334318012014]
              ], 
              [
                [-71.0819362531447, 42.3344365209951], 
                [-71.0820264745419, 42.3343209103088]
              ], 
              [
                [-71.0819362531447, 42.3344365209951], 
                [-71.082060101178, 42.3345494792243], 
                [-71.0823624228986, 42.334974541488], 
                [-71.0828158502332, 42.3356567244873]
              ], 
              [
                [-71.0757420979695, 42.3344488160357], 
                [-71.0770203700761, 42.3335877616057]
              ], 
              [
                [-71.0757420979695, 42.3344488160357], 
                [-71.0757421599532, 42.3344488645119], 
                [-71.0758254041357, 42.334515724522], 
                [-71.0762097564148, 42.3348244242169]
              ], 
              [
                [-71.0792859930879, 42.3346128216199], 
                [-71.07982971099, 42.3341142187473]
              ], 
              [
                [-71.0792859930879, 42.3346128216199], 
                [-71.078808569057, 42.3342830960847], 
                [-71.0785888447318, 42.3341286215827], 
                [-71.07813618905, 42.3337551355841], 
                [-71.078092077278, 42.3337154164785], 
                [-71.0780918329362, 42.333715189368]
              ], 
              [
                [-71.0754739266027, 42.3346586567796], 
                [-71.0757420979695, 42.3344488160357]
              ], 
              [
                [-71.0754739266027, 42.3346586567796], 
                [-71.0759237220486, 42.3350180110299]
              ], 
              [
                [-71.0762097564148, 42.3348244242169], 
                [-71.0763228623939, 42.3349174548397]
              ], 
              [
                [-71.0762097564148, 42.3348244242169], 
                [-71.0759237220486, 42.3350180110299]
              ], 
              [
                [-71.0751987537665, 42.3348897226376], 
                [-71.0754739266027, 42.3346586567796]
              ], 
              [
                [-71.0763228623939, 42.3349174548397], 
                [-71.07756250335, 42.3340610545987]
              ], 
              [
                [-71.0763228623939, 42.3349174548397], 
                [-71.0771716840991, 42.3356187629842]
              ], 
              [
                [-71.0814466308907, 42.3349307359053], 
                [-71.0819362531447, 42.3344365209951]
              ], 
              [
                [-71.0814466308907, 42.3349307359053], 
                [-71.0816088351899, 42.3351508538857], 
                [-71.082353477475, 42.3364000692767], 
                [-71.0828972843104, 42.337295248801], 
                [-71.0829257456335, 42.3373612100119], 
                [-71.0829291008411, 42.3374133600575], 
                [-71.0829137854638, 42.3374572097289], 
                [-71.0827411319612, 42.3375931032758], 
                [-71.0826503625916, 42.3376867553136]
              ], 
              [
                [-71.0759237220486, 42.3350180110299], 
                [-71.0759228902086, 42.3350184778587]
              ], 
              [
                [-71.0788043352971, 42.335054136128], 
                [-71.0792859930879, 42.3346128216199]
              ], 
              [
                [-71.0788043352971, 42.335054136128], 
                [-71.0784386347382, 42.3347818530074], 
                [-71.0781231257492, 42.3345357850346], 
                [-71.07756250335, 42.3340610545987]
              ], 
              [
                [-71.0788043352971, 42.335054136128], 
                [-71.0797213984212, 42.3356763244525], 
                [-71.0800879083622, 42.3359369822924]
              ], 
              [
                [-71.0771716840991, 42.3356187629842], 
                [-71.0773445100783, 42.3357588532809], 
                [-71.077403171863, 42.3358016017929], 
                [-71.077593824909, 42.3359484257372], 
                [-71.077647213583, 42.3359888121228]
              ], 
              [
                [-71.0771716840991, 42.3356187629842], 
                [-71.0768376284928, 42.3358338132316], 
                [-71.0765627107782, 42.3360080666828]
              ], 
              [
                [-71.0828158502332, 42.3356567244873], 
                [-71.0831452139389, 42.3353471503412], 
                [-71.0835136058504, 42.3355343978825], 
                [-71.0836232703837, 42.3355903630609], 
                [-71.0838137994622, 42.3356877825538]
              ], 
              [
                [-71.0828158502332, 42.3356567244873], 
                [-71.08321160393, 42.3362522556403]
              ], 
              [
                [-71.0838137994622, 42.3356877825538], 
                [-71.0840625240997, 42.3354183814889]
              ], 
              [
                [-71.0838137994622, 42.3356877825538], 
                [-71.0843247234665, 42.335958303368]
              ], 
              [
                [-71.0800879083622, 42.3359369822924], 
                [-71.0800882775698, 42.335936710699], 
                [-71.0801675871313, 42.3358782749241], 
                [-71.0814466308907, 42.3349307359053]
              ], 
              [
                [-71.0800879083622, 42.3359369822924], 
                [-71.0800955395505, 42.3359422561183], 
                [-71.081222580279, 42.3367211320105], 
                [-71.0816829462009, 42.3370374857898], 
                [-71.0823942852435, 42.3375262930193]
              ], 
              [
                [-71.077647213583, 42.3359888121228], 
                [-71.0788043352971, 42.335054136128]
              ], 
              [
                [-71.077647213583, 42.3359888121228], 
                [-71.0777258449165, 42.3360483846338], 
                [-71.0777575482595, 42.336082032267], 
                [-71.077841302685, 42.3361709207395], 
                [-71.0781028453833, 42.3363989556855]
              ], 
              [
                [-71.0864139371194, 42.3360003896946], 
                [-71.0868277909708, 42.3357768608361], 
                [-71.0869127096129, 42.3357374670612]
              ], 
              [
                [-71.0864139371194, 42.3360003896946], 
                [-71.0869767325432, 42.3365800458117], 
                [-71.0871355888215, 42.336723562376]
              ], 
              [
                [-71.0840867274084, 42.3362266137592], 
                [-71.0843251986753, 42.3359585550401], 
                [-71.0848521288614, 42.335428022802]
              ], 
              [
                [-71.08321160393, 42.3362522556403], 
                [-71.0834198810235, 42.336182352189], 
                [-71.0834446924917, 42.3361707792989], 
                [-71.0834669787956, 42.3361564539599], 
                [-71.0834860464358, 42.3361393721858], 
                [-71.0836357003722, 42.3359848730253], 
                [-71.0840867274084, 42.3362266137592]
              ], 
              [
                [-71.08321160393, 42.3362522556403], 
                [-71.0835482430911, 42.3367343821496], 
                [-71.0835725155701, 42.3367694570884]
              ], 
              [
                [-71.0859256246091, 42.3362627521079], 
                [-71.0864130666519, 42.3360008571801], 
                [-71.0864139371194, 42.3360003896946]
              ], 
              [
                [-71.0859256246091, 42.3362627521079], 
                [-71.0861549052123, 42.3365153481069], 
                [-71.0866593227191, 42.3370085732109]
              ], 
              [
                [-71.0781028453833, 42.3363989556855], 
                [-71.0787178598746, 42.3369020093826]
              ], 
              [
                [-71.0781028453833, 42.3363989556855], 
                [-71.0778027245351, 42.3366173818771], 
                [-71.0777997448233, 42.3366482415867], 
                [-71.0778215487319, 42.3366716474906], 
                [-71.0783570371677, 42.3371213960065]
              ], 
              [
                [-71.077114872844, 42.336456576203], 
                [-71.0771259490714, 42.3364468447385], 
                [-71.077647213583, 42.3359888121228]
              ], 
              [
                [-71.0792709229506, 42.3365370109652], 
                [-71.0797178671438, 42.3362079814714], 
                [-71.0797865406524, 42.3361576890748], 
                [-71.0798438486759, 42.3361065234243], 
                [-71.0800196444854, 42.3359869760465], 
                [-71.0800879083622, 42.3359369822924]
              ], 
              [
                [-71.0792709229506, 42.3365370109652], 
                [-71.0797136441637, 42.3368439118335], 
                [-71.0809004920288, 42.3376651937832], 
                [-71.0815344528878, 42.3381069848864], 
                [-71.0818902540123, 42.3383549286785], 
                [-71.082014790155, 42.3384046974009], 
                [-71.0820149886827, 42.3384047764188]
              ], 
              [
                [-71.0853751585625, 42.3365550720845], 
                [-71.0859256246091, 42.3362627521079]
              ], 
              [
                [-71.0853751585625, 42.3365550720845], 
                [-71.0861333582219, 42.3373295956525]
              ], 
              [
                [-71.0835725155701, 42.3367694570884], 
                [-71.0840867274084, 42.3362266137592]
              ], 
              [
                [-71.0835725155701, 42.3367694570884], 
                [-71.0839622469612, 42.3373340944412]
              ], 
              [
                [-71.0848548067393, 42.336837209084], 
                [-71.0853751585625, 42.3365550720845]
              ], 
              [
                [-71.0848548067393, 42.336837209084], 
                [-71.0849361608663, 42.3369452079952], 
                [-71.0855798181405, 42.3376019985554], 
                [-71.0856376004745, 42.3376427643651]
              ], 
              [
                [-71.0787178598746, 42.3369020093826], 
                [-71.0787640350768, 42.3368715362646], 
                [-71.0792709229506, 42.3365370109652]
              ], 
              [
                [-71.0787178598746, 42.3369020093826], 
                [-71.078806466101, 42.3369752202395], 
                [-71.0796737886095, 42.3376918231454]
              ], 
              [
                [-71.0843223788636, 42.3371268450371], 
                [-71.0844263211285, 42.3370703021915], 
                [-71.0848011827067, 42.3368663800503], 
                [-71.0848548067393, 42.336837209084]
              ], 
              [
                [-71.0843223788636, 42.3371268450371], 
                [-71.0849940752527, 42.3378077510141], 
                [-71.085157772552, 42.3379573704523]
              ], 
              [
                [-71.0781252879941, 42.337285038702], 
                [-71.0783580846033, 42.3371222771744], 
                [-71.0785417972654, 42.3370098016688], 
                [-71.0787178598746, 42.3369020093826]
              ], 
              [
                [-71.0839622469612, 42.3373340944412], 
                [-71.0843223788636, 42.3371268450371]
              ], 
              [
                [-71.0838157748575, 42.3374261777693], 
                [-71.0839614959696, 42.337334565901], 
                [-71.0839622469612, 42.3373340944412]
              ], 
              [
                [-71.0838157748575, 42.3374261777693], 
                [-71.0846406780199, 42.3382726456236]
              ], 
              [
                [-71.0823942852435, 42.3375262930193], 
                [-71.0824751318224, 42.3375818467214], 
                [-71.0826503625916, 42.3376867553136]
              ], 
              [
                [-71.0826503625916, 42.3376867553136], 
                [-71.0827965184883, 42.337798894277], 
                [-71.0828417235101, 42.3378335761847], 
                [-71.0829676583297, 42.3378941283726]
              ], 
              [
                [-71.0796737886095, 42.3376918231454], 
                [-71.0799302953523, 42.3375037513313], 
                [-71.079967525131, 42.3374848212741], 
                [-71.0800017338753, 42.3374811412405], 
                [-71.0800320906437, 42.3374872363375], 
                [-71.0800672291443, 42.337500431201], 
                [-71.0807040807819, 42.3379666455004], 
                [-71.0807151327548, 42.3379854851057], 
                [-71.0807185122169, 42.3380037217746], 
                [-71.0807213032825, 42.338025510948], 
                [-71.0807152737903, 42.3380494455635], 
                [-71.0807092730442, 42.3380690248624], 
                [-71.0806874394912, 42.3380940232211], 
                [-71.080401336853, 42.3382866856169]
              ], 
              [
                [-71.0796737886095, 42.3376918231454], 
                [-71.0797078257756, 42.3377199445579], 
                [-71.080401336853, 42.3382866856169]
              ], 
              [
                [-71.0824928564813, 42.3381489044342], 
                [-71.0829682341498, 42.3378944052697], 
                [-71.082969468435, 42.337893747224], 
                [-71.0835087549479, 42.3376061766006], 
                [-71.0836530728915, 42.3375215671474], 
                [-71.0838157748575, 42.3374261777693]
              ], 
              [
                [-71.0824928564813, 42.3381489044342], 
                [-71.0821516987942, 42.3379099334203], 
                [-71.0821306755216, 42.3378941821584], 
                [-71.0823942852435, 42.3375262930193]
              ], 
              [
                [-71.080401336853, 42.3382866856169], 
                [-71.0807020164533, 42.3385323989376], 
                [-71.0807884559432, 42.3386017513006]
              ], 
              [
                [-71.0820149886827, 42.3384047764188], 
                [-71.0824928564813, 42.3381489044342]
              ], 
              [
                [-71.0820149886827, 42.3384047764188], 
                [-71.0821687640897, 42.3385377382834], 
                [-71.0832751211088, 42.3392812900526]
              ], 
              [
                [-71.0807884559432, 42.3386017513006], 
                [-71.0814364664532, 42.338171973122]
              ], 
              [
                [-71.0807884559432, 42.3386017513006], 
                [-71.081085113786, 42.3388397615162], 
                [-71.0811315081772, 42.3388768645]
              ], 
              [
                [-71.0811315081772, 42.3388768645], 
                [-71.0820149886827, 42.3384047764188]
              ], 
              [
                [-71.0811315081772, 42.3388768645], 
                [-71.0811319582332, 42.3388772243943], 
                [-71.0811738763193, 42.3389107456797], 
                [-71.08148117291, 42.3391801005752], 
                [-71.0824536207646, 42.3399683113816]
              ], 
              [
                [-71.0804581741594, 42.339236650156], 
                [-71.0811315081772, 42.3388768645]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 47, 
            "OBJECTID" : null, 
            "Name" : "Lower Roxbury Safety Improvements", 
            "Shape_Leng" : null, 
            "Shape__Length" : 11808.11615054, 
            "Link" : "https://www.boston.gov/departments/transportation/lower-roxbury-transportation-study", 
            "GlobalID" : "cfa1b851-26f1-492e-a59e-4b7ec74fe6ac", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We want to hear your ideas about how to make it safer and more enjoyable to travel around Lower Roxbury.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 48, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0872226247927, 42.3098895023339], 
                [-71.0873908783471, 42.3099829471648], 
                [-71.0879336602047, 42.3104513656633]
              ], 
              [
                [-71.0879336602047, 42.3104513656633], 
                [-71.0877124401845, 42.3107206577549], 
                [-71.0874813027636, 42.3109977961399], 
                [-71.087157526579, 42.3113573161148]
              ], 
              [
                [-71.0915631638713, 42.3105526631399], 
                [-71.0911523526138, 42.3103638259381], 
                [-71.0909006051453, 42.310256020541], 
                [-71.0907174575235, 42.310178841194], 
                [-71.0906032663795, 42.3101052862565], 
                [-71.0901235660178, 42.3097277016067], 
                [-71.0891473075097, 42.3090022893581], 
                [-71.0883683235297, 42.3084272506659]
              ], 
              [
                [-71.0915631638713, 42.3105526631399], 
                [-71.0918176395233, 42.3102677217612]
              ], 
              [
                [-71.0915631638713, 42.3105526631399], 
                [-71.0910979200975, 42.3111626474085]
              ], 
              [
                [-71.0927344852551, 42.3107199974319], 
                [-71.09238999931, 42.3110918411856], 
                [-71.0919261155855, 42.311579729367]
              ], 
              [
                [-71.0910979200975, 42.3111626474085], 
                [-71.0904858215376, 42.3108870031115], 
                [-71.0898048913657, 42.3105897256792], 
                [-71.0896160035092, 42.3104911446308], 
                [-71.0893646450113, 42.3103236928113], 
                [-71.0888277408306, 42.309941396807], 
                [-71.0884886789131, 42.3096790953405], 
                [-71.0878070426654, 42.3091437861823]
              ], 
              [
                [-71.0910979200975, 42.3111626474085], 
                [-71.090510123661, 42.3119066755804]
              ], 
              [
                [-71.087157526579, 42.3113573161148], 
                [-71.086603249879, 42.3110818586756], 
                [-71.0863837339629, 42.3109730347985]
              ], 
              [
                [-71.0926344416786, 42.3115704238559], 
                [-71.0928659563919, 42.3117023529964], 
                [-71.0929086470291, 42.3117537072292], 
                [-71.093006585853, 42.3119082287051], 
                [-71.0930105339487, 42.3119723890613], 
                [-71.0928979741453, 42.3120873439764]
              ], 
              [
                [-71.0919261155855, 42.311579729367], 
                [-71.0913438788223, 42.3112873159102], 
                [-71.0910979200975, 42.3111626474085]
              ], 
              [
                [-71.090510123661, 42.3119066755804], 
                [-71.0902303074331, 42.3118004565109], 
                [-71.0896555653143, 42.3115513856846], 
                [-71.089253772244, 42.3113755199816], 
                [-71.0890148868537, 42.311241872932], 
                [-71.088776074227, 42.3110969689547], 
                [-71.0884815373066, 42.3108944739079], 
                [-71.0882584281294, 42.3106961699998], 
                [-71.0879336602047, 42.3104513656633]
              ], 
              [
                [-71.090510123661, 42.3119066755804], 
                [-71.0899309232034, 42.3126377924821]
              ], 
              [
                [-71.0928979741453, 42.3120873439764], 
                [-71.0919261155855, 42.311579729367]
              ], 
              [
                [-71.093294556987, 42.3122209746162], 
                [-71.0931899095446, 42.3122549325983]
              ], 
              [
                [-71.0931899095446, 42.3122549325983], 
                [-71.0928979741453, 42.3120873439764]
              ], 
              [
                [-71.0931899095446, 42.3122549325983], 
                [-71.0931044797611, 42.312335657382], 
                [-71.0928476963371, 42.3126460608811]
              ], 
              [
                [-71.0915758426933, 42.312441015292], 
                [-71.0909124269745, 42.3120932369314], 
                [-71.090510123661, 42.3119066755804]
              ], 
              [
                [-71.0843739987548, 42.3125604366974], 
                [-71.0844992813976, 42.3127038127649], 
                [-71.0853218435504, 42.3132835360963], 
                [-71.0856471872952, 42.3135283513387], 
                [-71.0856756827543, 42.3135757217312], 
                [-71.0856753476827, 42.3136269223159], 
                [-71.0855892423661, 42.3138100475814]
              ], 
              [
                [-71.0899309232034, 42.3126377924821], 
                [-71.0893888007093, 42.3124141566877], 
                [-71.0883969294816, 42.311985217936], 
                [-71.0881336000341, 42.3118509171844], 
                [-71.087157526579, 42.3113573161148]
              ], 
              [
                [-71.0899309232034, 42.3126377924821], 
                [-71.0893995760011, 42.3132655426944]
              ], 
              [
                [-71.0928476963371, 42.3126460608811], 
                [-71.0918541551413, 42.3121223290291], 
                [-71.0915758426933, 42.312441015292]
              ], 
              [
                [-71.0928476963371, 42.3126460608811], 
                [-71.0928269353726, 42.3126711603514], 
                [-71.0925960288187, 42.3129747565965]
              ], 
              [
                [-71.0925960288187, 42.3129747565965], 
                [-71.0920074526446, 42.3126631882282], 
                [-71.0915986634947, 42.3124529785007], 
                [-71.0915758426933, 42.312441015292]
              ], 
              [
                [-71.0925960288187, 42.3129747565965], 
                [-71.0921443828433, 42.313531900582], 
                [-71.0920284040519, 42.3136766621125]
              ], 
              [
                [-71.0917684540666, 42.3131443569622], 
                [-71.0915622835223, 42.3134307932344]
              ], 
              [
                [-71.0835537021531, 42.3131949872789], 
                [-71.084173413935, 42.3133778560603], 
                [-71.0855892423661, 42.3138100475814]
              ], 
              [
                [-71.0893995760011, 42.3132655426944], 
                [-71.0890477229723, 42.3131607501409], 
                [-71.0886660692322, 42.313034466489], 
                [-71.0883198827763, 42.3129038089264], 
                [-71.088078376102, 42.3127943445054], 
                [-71.0873769373922, 42.3124424023308], 
                [-71.0867626909605, 42.3121481581026], 
                [-71.0862187844122, 42.3118806152326], 
                [-71.0858623463822, 42.3116975813407]
              ], 
              [
                [-71.0893995760011, 42.3132655426944], 
                [-71.0891574557775, 42.313572727163]
              ], 
              [
                [-71.0950381420377, 42.3133907703408], 
                [-71.0947903309868, 42.3135828985974], 
                [-71.0943958717624, 42.3138847958781]
              ], 
              [
                [-71.0915622835223, 42.3134307932344], 
                [-71.0914675741419, 42.3133831955487], 
                [-71.0909218529967, 42.3131274854952], 
                [-71.0901302881111, 42.3127290935626], 
                [-71.0899309232034, 42.3126377924821]
              ], 
              [
                [-71.0891574557775, 42.313572727163], 
                [-71.0888069502216, 42.3140174216407]
              ], 
              [
                [-71.0920284040519, 42.3136766621125], 
                [-71.0915622835223, 42.3134307932344]
              ], 
              [
                [-71.0920284040519, 42.3136766621125], 
                [-71.0918548917599, 42.313896053352], 
                [-71.0915656495097, 42.314279902981]
              ], 
              [
                [-71.0855892423661, 42.3138100475814], 
                [-71.0864242623553, 42.3140521970386], 
                [-71.0870945214399, 42.3142464841515]
              ], 
              [
                [-71.0943958717624, 42.3138847958781], 
                [-71.0938466831202, 42.3136054488581], 
                [-71.0933973260521, 42.313365281889], 
                [-71.0928859106693, 42.3131085766659], 
                [-71.0925960288187, 42.3129747565965]
              ], 
              [
                [-71.0943958717624, 42.3138847958781], 
                [-71.0941742555852, 42.3140696966605], 
                [-71.0940884485092, 42.3141504217737], 
                [-71.0939381441925, 42.3143282612428], 
                [-71.0938591714993, 42.3144652808766], 
                [-71.0938218617706, 42.3145495493542]
              ], 
              [
                [-71.0888069502216, 42.3140174216407], 
                [-71.088667191228, 42.3139707802897], 
                [-71.0884279249521, 42.313893963542], 
                [-71.088035489632, 42.3137637036727], 
                [-71.0876795034546, 42.3136234395057], 
                [-71.08715067423, 42.3133672063107], 
                [-71.0864876088542, 42.3130305903896], 
                [-71.0861367709217, 42.3128588307871], 
                [-71.0856838780846, 42.312642251851], 
                [-71.0853687957954, 42.3124813111484], 
                [-71.0851844300581, 42.3123579822305]
              ], 
              [
                [-71.0888069502216, 42.3140174216407], 
                [-71.0884448977211, 42.3144606462697], 
                [-71.0883314773317, 42.314618355563]
              ], 
              [
                [-71.0911379059074, 42.3141855418554], 
                [-71.0909349486369, 42.3139456760236], 
                [-71.0907780282282, 42.3137971300656], 
                [-71.0906814287924, 42.3137287029255], 
                [-71.090559380983, 42.3136674964097], 
                [-71.0903864337312, 42.313594293631], 
                [-71.0898571203146, 42.3134100989105], 
                [-71.0893995760011, 42.3132655426944]
              ], 
              [
                [-71.0870945214399, 42.3142464841515], 
                [-71.0883314773317, 42.314618355563]
              ], 
              [
                [-71.0870945214399, 42.3142464841515], 
                [-71.0869929426426, 42.314477383197], 
                [-71.0868788036009, 42.3147729457322]
              ], 
              [
                [-71.0915656495097, 42.314279902981], 
                [-71.0914092303609, 42.3142292688872], 
                [-71.0912818950677, 42.3141950562256], 
                [-71.0911379059074, 42.3141855418554]
              ], 
              [
                [-71.0915656495097, 42.314279902981], 
                [-71.0913688888181, 42.3145183453398]
              ], 
              [
                [-71.0913688888181, 42.3145183453398], 
                [-71.0911379059074, 42.3141855418554]
              ], 
              [
                [-71.0913688888181, 42.3145183453398], 
                [-71.0911318297028, 42.3148039104848]
              ], 
              [
                [-71.0938218617706, 42.3145495493542], 
                [-71.0931048597485, 42.3141936473044], 
                [-71.0922964182136, 42.3137923990895], 
                [-71.0920284040519, 42.3136766621125]
              ], 
              [
                [-71.0938218617706, 42.3145495493542], 
                [-71.0937562308559, 42.3147940873231], 
                [-71.0936815566013, 42.3150246734843]
              ], 
              [
                [-71.0883314773317, 42.314618355563], 
                [-71.0891745911416, 42.3148734577352], 
                [-71.0898274741136, 42.3150597890925], 
                [-71.0907266481872, 42.3153235155589]
              ], 
              [
                [-71.0883314773317, 42.314618355563], 
                [-71.0879067610518, 42.3151373178349], 
                [-71.0873432523657, 42.3158369666725]
              ], 
              [
                [-71.0906223780372, 42.3146640784169], 
                [-71.090770884825, 42.3143566953439], 
                [-71.0891574557775, 42.313572727163]
              ], 
              [
                [-71.0906223780372, 42.3146640784169], 
                [-71.0903332444832, 42.3145793670258], 
                [-71.0898344046161, 42.3144296036287], 
                [-71.0896000934472, 42.3143488655882], 
                [-71.0891271924339, 42.3141457353305], 
                [-71.0888069502216, 42.3140174216407]
              ], 
              [
                [-71.0868788036009, 42.3147729457322], 
                [-71.0860180459805, 42.3145802219388], 
                [-71.0847444801476, 42.3143021620413], 
                [-71.0841106001371, 42.314168203684], 
                [-71.0837113340276, 42.314068289065]
              ], 
              [
                [-71.0868788036009, 42.3147729457322], 
                [-71.086743850594, 42.3151218903441], 
                [-71.0865934447677, 42.3154859674884]
              ], 
              [
                [-71.0911318297028, 42.3148039104848], 
                [-71.090817355573, 42.3147212027099], 
                [-71.0906223780372, 42.3146640784169]
              ], 
              [
                [-71.0911318297028, 42.3148039104848], 
                [-71.0907266481872, 42.3153235155589]
              ], 
              [
                [-71.0936815566013, 42.3150246734843], 
                [-71.0932231957191, 42.3148321530626], 
                [-71.0925288842428, 42.3146018040039], 
                [-71.0920250452511, 42.3144328977418], 
                [-71.0915656495097, 42.314279902981]
              ], 
              [
                [-71.0936815566013, 42.3150246734843], 
                [-71.0936183682059, 42.3152482515118], 
                [-71.0935597360656, 42.3155231958444], 
                [-71.0934726776365, 42.3157980393375], 
                [-71.093333312105, 42.3161604818331], 
                [-71.0932270054743, 42.3164515753725], 
                [-71.0931837156607, 42.3165521444767], 
                [-71.0930905603658, 42.3166840432474], 
                [-71.0929642141177, 42.3167601225988], 
                [-71.0927225170006, 42.3168521071845], 
                [-71.0924710444166, 42.3169035475525], 
                [-71.0922933091444, 42.3169243005095], 
                [-71.0919678881445, 42.3169501528537], 
                [-71.0917799048915, 42.316971993825], 
                [-71.0916977494672, 42.3169908549965], 
                [-71.0916197119201, 42.3170057473139]
              ], 
              [
                [-71.0907266481872, 42.3153235155589], 
                [-71.0914370035745, 42.3155353617302], 
                [-71.0918322524181, 42.3156436781979]
              ], 
              [
                [-71.0907266481872, 42.3153235155589], 
                [-71.0904318929762, 42.3159582428726]
              ], 
              [
                [-71.0865934447677, 42.3154859674884], 
                [-71.0862475053484, 42.3153744397182], 
                [-71.0860437485774, 42.3153168736208], 
                [-71.0856815999571, 42.3152204754321], 
                [-71.0851346615947, 42.3150935841271], 
                [-71.0841210340691, 42.3148884800853], 
                [-71.0835433679341, 42.3147659735958]
              ], 
              [
                [-71.0865934447677, 42.3154859674884], 
                [-71.0864899839998, 42.3157134855729], 
                [-71.0862572350013, 42.3162061245208]
              ], 
              [
                [-71.0918322524181, 42.3156436781979], 
                [-71.0919150186968, 42.3155066770719], 
                [-71.0919823600037, 42.3153510504668], 
                [-71.0919985763912, 42.3152171880028], 
                [-71.0919888593148, 42.3151068693783], 
                [-71.0919439426523, 42.3149891081498], 
                [-71.0918630385812, 42.3148672813993], 
                [-71.0917310473198, 42.3147604621798], 
                [-71.0915125869242, 42.3146308305082], 
                [-71.0913688888181, 42.3145183453398]
              ], 
              [
                [-71.0918322524181, 42.3156436781979], 
                [-71.0917908355919, 42.3157757602144], 
                [-71.0917694916207, 42.315912416671], 
                [-71.0917484234324, 42.3160338853589], 
                [-71.0917568568163, 42.3162843101227], 
                [-71.0917686463061, 42.316337242195]
              ], 
              [
                [-71.0873432523657, 42.3158369666725], 
                [-71.0869494893356, 42.3156464873399], 
                [-71.0865934447677, 42.3154859674884]
              ], 
              [
                [-71.0873432523657, 42.3158369666725], 
                [-71.0870250825668, 42.3162330831372], 
                [-71.0864468145605, 42.3169561516322]
              ], 
              [
                [-71.0904318929762, 42.3159582428726], 
                [-71.0901568917182, 42.3165830273158]
              ], 
              [
                [-71.0904318929762, 42.3159582428726], 
                [-71.0899202125903, 42.3158129923844], 
                [-71.0891654453937, 42.3156105437304], 
                [-71.0890236121901, 42.315590902307], 
                [-71.0889524898741, 42.3155979626982], 
                [-71.0888911861442, 42.3156393857702], 
                [-71.0887742569352, 42.3158685732356], 
                [-71.0887370208684, 42.3159415561581], 
                [-71.0887010415446, 42.3160241454208], 
                [-71.0887005995735, 42.3160922266468], 
                [-71.0887509034328, 42.3161678091895], 
                [-71.0888114480863, 42.3162136013283], 
                [-71.0891355404778, 42.3163053548896], 
                [-71.0901568917182, 42.3165830273158]
              ], 
              [
                [-71.0917686463061, 42.316337242195], 
                [-71.0913179947657, 42.3162073474066], 
                [-71.0908115012523, 42.3160660013047], 
                [-71.0904318929762, 42.3159582428726]
              ], 
              [
                [-71.0917686463061, 42.316337242195], 
                [-71.0917503116911, 42.316534680086], 
                [-71.0917133846447, 42.3167056079849], 
                [-71.091666239262, 42.3169035030482], 
                [-71.0916197119201, 42.3170057473139]
              ], 
              [
                [-71.0901568917182, 42.3165830273158], 
                [-71.0900429844419, 42.31684483504], 
                [-71.0895049780283, 42.3179468555797]
              ], 
              [
                [-71.0916197119201, 42.3170057473139], 
                [-71.0913285903944, 42.3169141209801], 
                [-71.0901568917182, 42.3165830273158]
              ], 
              [
                [-71.0916197119201, 42.3170057473139], 
                [-71.0913614534625, 42.3174909911557], 
                [-71.0909619187567, 42.3182167061014]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 48, 
            "OBJECTID" : null, 
            "Name" : "Roxbury Safe Routes to School Safety Project", 
            "Shape_Leng" : null, 
            "Shape__Length" : 12615.04347002, 
            "Link" : "https://www.boston.gov/departments/transportation/sugar-hill-safety-improvements", 
            "GlobalID" : "b3181d78-d285-4cb7-87df-8614e5cf4405", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're developing plans for slowing speeds and creating safer crossings around Ellis Elementary School in Roxbury. The City of Boston is working in partnership with MassDOT's Safe Routes to School program.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 49, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0550884057578, 42.3514038050659], 
              [-71.0648731046658, 42.3363053674696], 
              [-71.0628131680063, 42.3324984664961], 
              [-71.0695079614759, 42.3176493504483], 
              [-71.0777477081138, 42.3041932796159], 
              [-71.078949337757, 42.3008922944239], 
              [-71.0777870417469, 42.2922241397801], 
              [-71.0780578370926, 42.2885526244696], 
              [-71.0808927674157, 42.284541421392], 
              [-71.0841593409278, 42.2829006379957], 
              [-71.0862962416475, 42.2800577985921], 
              [-71.1188044751492, 42.2542568095895]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 49, 
            "OBJECTID" : null, 
            "Name" : "Fairmount Line Service Enhancements", 
            "Shape_Leng" : null, 
            "Shape__Length" : 17014.56832681, 
            "Link" : "https://www.boston.gov/departments/transportation/fairmount-line-service-enhancement", 
            "GlobalID" : "d6d6714a-c48b-4e7c-9455-aebc3cd1ad71", 
            "CreationDa" : 1589414400000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "New Fairmount Line Service is here with more weekday trips, service starting earlier and ending later, and more ways to pay your fare.", 
            "ProjectTyp" : "Transit Priority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 50, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0783789093482, 42.308140976973], 
                [-71.0777794473895, 42.3077747201586], 
                [-71.076885493426, 42.3072357528633], 
                [-71.0766365909221, 42.3070767196289]
              ], 
              [
                [-71.0783789093482, 42.308140976973], 
                [-71.0783734314216, 42.3081459302621]
              ], 
              [
                [-71.0783734314216, 42.3081459302621], 
                [-71.0777800411759, 42.3077833824856], 
                [-71.0768860872124, 42.3072444152645], 
                [-71.0766371847085, 42.3070853827163]
              ], 
              [
                [-71.0783734314216, 42.3081459302621], 
                [-71.0777733541169, 42.3086885003995]
              ], 
              [
                [-71.0783795031346, 42.3081496399139], 
                [-71.0783734314216, 42.3081459302621]
              ], 
              [
                [-71.0783795031346, 42.3081496399139], 
                [-71.0777792596416, 42.3086923601581]
              ], 
              [
                [-71.0812833584945, 42.3082421918041], 
                [-71.0810727242216, 42.3084552423301], 
                [-71.0808560092526, 42.3086699615974], 
                [-71.080793575442, 42.3087322299217], 
                [-71.0806261168967, 42.3088992627981], 
                [-71.0802678229473, 42.3092575112848]
              ], 
              [
                [-71.0812839531792, 42.3082508547311], 
                [-71.0810733189064, 42.3084639052278], 
                [-71.0808566039373, 42.3086786244656], 
                [-71.0807941701268, 42.3087408927813], 
                [-71.0806267124797, 42.3089079256347], 
                [-71.0802736691832, 42.3092609239182]
              ], 
              [
                [-71.0764190917238, 42.3086249977052], 
                [-71.0758887164986, 42.308271923443], 
                [-71.075527364684, 42.3080370753999]
              ], 
              [
                [-71.0764196855102, 42.3086336612439], 
                [-71.075889310285, 42.3082805863659], 
                [-71.075527957572, 42.3080457383552]
              ], 
              [
                [-71.0777733541169, 42.3086885003995], 
                [-71.0767308556364, 42.3080004398553], 
                [-71.0760761257281, 42.3075681320422]
              ], 
              [
                [-71.0777792596416, 42.3086923601581], 
                [-71.0777733541169, 42.3086885003995]
              ], 
              [
                [-71.0777792596416, 42.3086923601581], 
                [-71.0777739479033, 42.3086971632651]
              ], 
              [
                [-71.0777739479033, 42.3086971632651], 
                [-71.0767314485245, 42.3080091028156], 
                [-71.0760767195145, 42.307576795062]
              ], 
              [
                [-71.0802678229473, 42.3092575112848], 
                [-71.0799082057795, 42.309043500865], 
                [-71.079217233341, 42.308641468459], 
                [-71.0783789093482, 42.308140976973]
              ], 
              [
                [-71.0802736691832, 42.3092609239182], 
                [-71.0802678229473, 42.3092575112848]
              ], 
              [
                [-71.0802736691832, 42.3092609239182], 
                [-71.080268417632, 42.3092661747364]
              ], 
              [
                [-71.080268417632, 42.3092661747364], 
                [-71.0799088004642, 42.3090521636817], 
                [-71.0792178280258, 42.3086501313311], 
                [-71.0783795031346, 42.3081496399139]
              ], 
              [
                [-71.073189715651, 42.3096602107194], 
                [-71.0732394643515, 42.3097307282452], 
                [-71.0732505315957, 42.3098033542388], 
                [-71.0732502576096, 42.3098063263996]
              ], 
              [
                [-71.0731903076408, 42.3096688741156], 
                [-71.0732400572396, 42.3097393916317], 
                [-71.0732502576096, 42.3098063263996]
              ], 
              [
                [-71.075214887509, 42.3096694015856], 
                [-71.0743450560059, 42.3093206938014], 
                [-71.0739534749837, 42.3091554982385]
              ], 
              [
                [-71.075214887509, 42.3096694015856], 
                [-71.0752098084344, 42.3096757910138]
              ], 
              [
                [-71.0752098084344, 42.3096757910138], 
                [-71.074345648894, 42.3093293572443], 
                [-71.0739540678718, 42.3091641617042]
              ], 
              [
                [-71.0752098084344, 42.3096757910138], 
                [-71.0749620180447, 42.3099875116838], 
                [-71.0744716861216, 42.310584957925]
              ], 
              [
                [-71.0752154803971, 42.3096780649805], 
                [-71.0752098084344, 42.3096757910138]
              ], 
              [
                [-71.0752154803971, 42.3096780649805], 
                [-71.0749626118311, 42.3099961750349], 
                [-71.0744770643352, 42.3105877898793]
              ], 
              [
                [-71.0732502576096, 42.3098063263996], 
                [-71.0732511244838, 42.3098120176153], 
                [-71.0732447877678, 42.3098806449873], 
                [-71.0732100445259, 42.30994634929], 
                [-71.0727866227184, 42.3106245016424], 
                [-71.0725369171206, 42.3110602202661], 
                [-71.0721247080845, 42.311759228873], 
                [-71.0720147812432, 42.3118994938731], 
                [-71.0719326482767, 42.3119937189241], 
                [-71.0718632147935, 42.3120874270132], 
                [-71.0717774274805, 42.3122170904952], 
                [-71.0714924387532, 42.3127674621376], 
                [-71.0713706289973, 42.3129549416363], 
                [-71.071272398221, 42.3130836859552]
              ], 
              [
                [-71.0732502576096, 42.3098063263996], 
                [-71.0732441948797, 42.3098719816203], 
                [-71.0732094525361, 42.309937685932], 
                [-71.0727860307286, 42.3106158383777], 
                [-71.0725363242325, 42.3110515563971], 
                [-71.0721241160947, 42.3117505651002], 
                [-71.0720141883551, 42.3118908301196], 
                [-71.0719320553886, 42.3119850545194], 
                [-71.0718626228037, 42.3120787632856], 
                [-71.0717768345924, 42.3122084267855], 
                [-71.0714918467634, 42.3127587985035], 
                [-71.0713700370075, 42.3129462780281], 
                [-71.0712660049111, 42.3130826237654], 
                [-71.071272398221, 42.3130836859552]
              ], 
              [
                [-71.0795853988771, 42.30987960068], 
                [-71.0790166925387, 42.3095010806402], 
                [-71.0777792596416, 42.3086923601581]
              ], 
              [
                [-71.0795853988771, 42.30987960068], 
                [-71.0795801347495, 42.3098843645017]
              ], 
              [
                [-71.0795801347495, 42.3098843645017], 
                [-71.0790172872234, 42.3095097433939], 
                [-71.0777739479033, 42.3086971632651]
              ], 
              [
                [-71.0795801347495, 42.3098843645017], 
                [-71.0793754724767, 42.3100695826218], 
                [-71.0791863771093, 42.3102613290715], 
                [-71.0789792570459, 42.3104563838731]
              ], 
              [
                [-71.0795859935618, 42.309888264046], 
                [-71.0795801347495, 42.3098843645017]
              ], 
              [
                [-71.0795859935618, 42.309888264046], 
                [-71.0793760662631, 42.3100782459616], 
                [-71.0791869717941, 42.3102699923849], 
                [-71.078986366313, 42.3104589122429]
              ], 
              [
                [-71.0761052032955, 42.3100181778555], 
                [-71.0758306215509, 42.3098995614295], 
                [-71.075214887509, 42.3096694015856]
              ], 
              [
                [-71.0761052032955, 42.3100181778555], 
                [-71.0760992573467, 42.3100240158659]
              ], 
              [
                [-71.0760992573467, 42.3100240158659], 
                [-71.0758312144389, 42.3099082247928], 
                [-71.0752154803971, 42.3096780649805]
              ], 
              [
                [-71.0760992573467, 42.3100240158659], 
                [-71.0759493375089, 42.3101712155273], 
                [-71.0756225178321, 42.3104946814236], 
                [-71.0752855813286, 42.310799537066], 
                [-71.0751090542905, 42.3109524971072]
              ], 
              [
                [-71.0761057970819, 42.3100268412024], 
                [-71.0760992573467, 42.3100240158659]
              ], 
              [
                [-71.0761057970819, 42.3100268412024], 
                [-71.075949930397, 42.3101798788532], 
                [-71.0756231116185, 42.3105033447049], 
                [-71.0752861742167, 42.3108082009697], 
                [-71.075115395498, 42.3109561800214]
              ], 
              [
                [-71.0820116514414, 42.3102564476948], 
                [-71.081660127196, 42.3100486619897], 
                [-71.0812027697321, 42.3097960387635], 
                [-71.0808928285012, 42.3096193457272], 
                [-71.080674295342, 42.3094947602837], 
                [-71.0802736691832, 42.3092609239182]
              ], 
              [
                [-71.0820122461262, 42.3102651110089], 
                [-71.0816607227791, 42.3100573246681], 
                [-71.0812033644168, 42.3098047014767], 
                [-71.0808934231859, 42.309628009129], 
                [-71.0806748900267, 42.3095034230383], 
                [-71.080268417632, 42.3092661747364]
              ], 
              [
                [-71.0789792570459, 42.3104563838731], 
                [-71.0787931108476, 42.3106605218379], 
                [-71.0785257551511, 42.3109645157363]
              ], 
              [
                [-71.078986366313, 42.3104589122429], 
                [-71.0789792570459, 42.3104563838731]
              ], 
              [
                [-71.078986366313, 42.3104589122429], 
                [-71.0789798517306, 42.3104650471597]
              ], 
              [
                [-71.0789798517306, 42.3104650471597], 
                [-71.0787937055324, 42.3106691850964], 
                [-71.0785318592034, 42.310966914546]
              ], 
              [
                [-71.0744716861216, 42.310584957925], 
                [-71.0743070500829, 42.3108009826001], 
                [-71.0740511173635, 42.3111494603061]
              ], 
              [
                [-71.0744770643352, 42.3105877898793], 
                [-71.0744716861216, 42.310584957925]
              ], 
              [
                [-71.0744770643352, 42.3105877898793], 
                [-71.0744722790097, 42.3105936211939]
              ], 
              [
                [-71.0744722790097, 42.3105936211939], 
                [-71.074307642971, 42.3108096465036], 
                [-71.0740560059953, 42.3111522749631]
              ], 
              [
                [-71.0777319651385, 42.3106605676752], 
                [-71.0769159184664, 42.3103402102868], 
                [-71.0768906308911, 42.3103298563067], 
                [-71.0767563956382, 42.3102749136194], 
                [-71.0761052032955, 42.3100181778555]
              ], 
              [
                [-71.0777319651385, 42.3106605676752], 
                [-71.0777276083093, 42.310667287829]
              ], 
              [
                [-71.0777276083093, 42.310667287829], 
                [-71.0769165122528, 42.3103488735894], 
                [-71.0768912246776, 42.3103385196107], 
                [-71.0767569894247, 42.310283576931], 
                [-71.0761057970819, 42.3100268412024]
              ], 
              [
                [-71.0777276083093, 42.310667287829], 
                [-71.0776406190505, 42.310801463559], 
                [-71.0774246586663, 42.3110983301152], 
                [-71.0772355731805, 42.3113165219761], 
                [-71.0769289368515, 42.3116254318422], 
                [-71.0766864438271, 42.3118648043086]
              ], 
              [
                [-71.0777325589249, 42.3106692309338], 
                [-71.0777276083093, 42.310667287829]
              ], 
              [
                [-71.0777325589249, 42.3106692309338], 
                [-71.0776412128369, 42.3108101274624], 
                [-71.0774252524527, 42.3111069939778], 
                [-71.0772361669669, 42.3113251851444], 
                [-71.0769295306379, 42.3116340956323], 
                [-71.0766923825894, 42.3118681922217]
              ], 
              [
                [-71.0815743731207, 42.3108361138511], 
                [-71.0804684266317, 42.3103594248673], 
                [-71.0801796811499, 42.3102312017768], 
                [-71.0800118974144, 42.3101546242685], 
                [-71.0798139985573, 42.3100171680949], 
                [-71.0795853988771, 42.30987960068]
              ], 
              [
                [-71.0815749687037, 42.3108447770855], 
                [-71.0804690213164, 42.3103680881672], 
                [-71.0801802758346, 42.3102398650944], 
                [-71.0800124920991, 42.3101632875966], 
                [-71.079814593242, 42.3100258314419], 
                [-71.0795859935618, 42.309888264046]
              ], 
              [
                [-71.0751090542905, 42.3109524971072], 
                [-71.0746998240678, 42.3107050876837], 
                [-71.0744770643352, 42.3105877898793]
              ], 
              [
                [-71.075115395498, 42.3109561800214], 
                [-71.0751090542905, 42.3109524971072]
              ], 
              [
                [-71.075115395498, 42.3109561800214], 
                [-71.0751096471785, 42.3109611609898]
              ], 
              [
                [-71.0751096471785, 42.3109611609898], 
                [-71.0747004178542, 42.3107137509361], 
                [-71.0744722790097, 42.3105936211939]
              ], 
              [
                [-71.0785257551511, 42.3109645157363], 
                [-71.0777319651385, 42.3106605676752]
              ], 
              [
                [-71.0785257551511, 42.3109645157363], 
                [-71.0785201119345, 42.3109707901081]
              ], 
              [
                [-71.0785318592034, 42.310966914546], 
                [-71.0785257551511, 42.3109645157363]
              ], 
              [
                [-71.0785318592034, 42.310966914546], 
                [-71.0785263498358, 42.3109731789529]
              ], 
              [
                [-71.0785201119345, 42.3109707901081], 
                [-71.0777325589249, 42.3106692309338]
              ], 
              [
                [-71.0785201119345, 42.3109707901081], 
                [-71.0782639726026, 42.3112555934505], 
                [-71.0779265950263, 42.3116285374411]
              ], 
              [
                [-71.0785263498358, 42.3109731789529], 
                [-71.0785201119345, 42.3109707901081]
              ], 
              [
                [-71.0785263498358, 42.3109731789529], 
                [-71.0782645672873, 42.3112642566271], 
                [-71.0779327197399, 42.31163108835]
              ], 
              [
                [-71.0740511173635, 42.3111494603061], 
                [-71.0737852968877, 42.3114467012154], 
                [-71.0736302845007, 42.3116402530207], 
                [-71.0731711169314, 42.3122220540923], 
                [-71.0729430230027, 42.3125166181627], 
                [-71.0726103382254, 42.312945832957], 
                [-71.0722311746153, 42.3134092054534]
              ], 
              [
                [-71.0740560059953, 42.3111522749631], 
                [-71.0740511173635, 42.3111494603061]
              ], 
              [
                [-71.0740560059953, 42.3111522749631], 
                [-71.0740517102516, 42.3111581234973]
              ], 
              [
                [-71.0740517102516, 42.3111581234973], 
                [-71.0737858897758, 42.31145536503], 
                [-71.0736308773887, 42.3116489168087], 
                [-71.0731717098195, 42.3122307178002], 
                [-71.0729436158907, 42.31252528183], 
                [-71.0726109302152, 42.3129544972295], 
                [-71.0722371636833, 42.3134112746868]
              ], 
              [
                [-71.0811480515515, 42.3113634854877], 
                [-71.0803729707513, 42.3110365484102], 
                [-71.0800525102484, 42.3108890797352], 
                [-71.0797017648424, 42.3107358724171], 
                [-71.0793661111331, 42.310593970621], 
                [-71.078986366313, 42.3104589122429]
              ], 
              [
                [-71.0758217435009, 42.3113664569105], 
                [-71.075115395498, 42.3109561800214]
              ], 
              [
                [-71.0758217435009, 42.3113664569105], 
                [-71.0758162808456, 42.3113716025933]
              ], 
              [
                [-71.0758162808456, 42.3113716025933], 
                [-71.0751096471785, 42.3109611609898]
              ], 
              [
                [-71.0758162808456, 42.3113716025933], 
                [-71.0755283968482, 42.3116427753643], 
                [-71.0753089366277, 42.3118383440366]
              ], 
              [
                [-71.0811486471345, 42.3113721486495], 
                [-71.080373565436, 42.311045211617], 
                [-71.0800531049331, 42.3108977436266], 
                [-71.0797023595271, 42.3107445356652], 
                [-71.0793667058178, 42.3106026338887], 
                [-71.0789798517306, 42.3104650471597]
              ], 
              [
                [-71.0758223372873, 42.3113751207361], 
                [-71.0758162808456, 42.3113716025933]
              ], 
              [
                [-71.0758223372873, 42.3113751207361], 
                [-71.0755289906346, 42.3116514391519], 
                [-71.0753095295158, 42.3118470077973]
              ], 
              [
                [-71.0779265950263, 42.3116285374411], 
                [-71.0777529722414, 42.3118012091598], 
                [-71.0774874625828, 42.3120534443618], 
                [-71.0773138595608, 42.3122227369854]
              ], 
              [
                [-71.0779327197399, 42.31163108835], 
                [-71.0779265950263, 42.3116285374411]
              ], 
              [
                [-71.0779327197399, 42.31163108835], 
                [-71.077927189711, 42.3116372012307]
              ], 
              [
                [-71.077927189711, 42.3116372012307], 
                [-71.0777535660278, 42.3118098729256], 
                [-71.0774880563692, 42.3120621080929], 
                [-71.0773197929333, 42.3122261939657]
              ], 
              [
                [-71.0753089366277, 42.3118383440366], 
                [-71.0750366473836, 42.311715798395], 
                [-71.0747535406269, 42.3115673242329], 
                [-71.0743088269505, 42.3112978411229], 
                [-71.0740560059953, 42.3111522749631]
              ], 
              [
                [-71.0753089366277, 42.3118383440366], 
                [-71.0753030553575, 42.311844094191]
              ], 
              [
                [-71.0753030553575, 42.311844094191], 
                [-71.0750372402717, 42.3117244621726], 
                [-71.074754133515, 42.3115759880309], 
                [-71.0743094198386, 42.3113065042937], 
                [-71.0740517102516, 42.3111581234973]
              ], 
              [
                [-71.0753030553575, 42.311844094191], 
                [-71.0752017173086, 42.3119431693495], 
                [-71.0751248682327, 42.3120413548611]
              ], 
              [
                [-71.0753095295158, 42.3118470077973], 
                [-71.0753030553575, 42.311844094191]
              ], 
              [
                [-71.0753095295158, 42.3118470077973], 
                [-71.0752023101967, 42.3119518330957], 
                [-71.0751301386485, 42.312044042598]
              ], 
              [
                [-71.0766864438271, 42.3118648043086], 
                [-71.0759935229428, 42.3114694960399], 
                [-71.0758217435009, 42.3113664569105]
              ], 
              [
                [-71.0766923825894, 42.3118681922217], 
                [-71.0766864438271, 42.3118648043086]
              ], 
              [
                [-71.0766923825894, 42.3118681922217], 
                [-71.0766870376135, 42.3118734680656]
              ], 
              [
                [-71.0766870376135, 42.3118734680656], 
                [-71.0759941167292, 42.3114781598514], 
                [-71.0758223372873, 42.3113751207361]
              ], 
              [
                [-71.0807433326682, 42.3118909350784], 
                [-71.080349113294, 42.3117190029699], 
                [-71.0798080633882, 42.3114823808185], 
                [-71.0791111872218, 42.3111945532629], 
                [-71.0785318592034, 42.310966914546]
              ], 
              [
                [-71.0807439282512, 42.3118995981676], 
                [-71.0803497079787, 42.3117276660827], 
                [-71.0798086580729, 42.3114910446282], 
                [-71.0791117819065, 42.3112032164479], 
                [-71.0785263498358, 42.3109731789529]
              ], 
              [
                [-71.0751248682327, 42.3120413548611], 
                [-71.074997608398, 42.3122237573393], 
                [-71.0748115798791, 42.3125313547665], 
                [-71.0747257242941, 42.3126608366476], 
                [-71.0746793900901, 42.3127455778569], 
                [-71.0746494806827, 42.312840580185]
              ], 
              [
                [-71.0751301386485, 42.312044042598], 
                [-71.0751248682327, 42.3120413548611]
              ], 
              [
                [-71.0751301386485, 42.312044042598], 
                [-71.0751254611208, 42.3120500185939]
              ], 
              [
                [-71.0751254611208, 42.3120500185939], 
                [-71.0749982012861, 42.312232421047], 
                [-71.0748121727671, 42.3125400190961], 
                [-71.0747263180805, 42.3126695009594], 
                [-71.0746799829781, 42.312754242157], 
                [-71.0746500735707, 42.312849244472]
              ], 
              [
                [-71.0773138595608, 42.3122227369854], 
                [-71.0766923825894, 42.3118681922217]
              ], 
              [
                [-71.0773197929333, 42.3122261939657], 
                [-71.0773138595608, 42.3122227369854]
              ], 
              [
                [-71.0773197929333, 42.3122261939657], 
                [-71.0773144533473, 42.3122314006932]
              ], 
              [
                [-71.0773144533473, 42.3122314006932], 
                [-71.0766870376135, 42.3118734680656]
              ], 
              [
                [-71.075878329279, 42.3124256402836], 
                [-71.0751301386485, 42.312044042598]
              ], 
              [
                [-71.075878329279, 42.3124256402836], 
                [-71.0758736544462, 42.3124316169076]
              ], 
              [
                [-71.0758736544462, 42.3124316169076], 
                [-71.0751254611208, 42.3120500185939]
              ], 
              [
                [-71.0758736544462, 42.3124316169076], 
                [-71.0757431741512, 42.3125984506448], 
                [-71.0755486215185, 42.3128661312922], 
                [-71.0753575390778, 42.3131253890168]
              ], 
              [
                [-71.0758789230653, 42.3124343039634], 
                [-71.0758736544462, 42.3124316169076]
              ], 
              [
                [-71.0758789230653, 42.3124343039634], 
                [-71.0757437670393, 42.3126071149652], 
                [-71.0755492144066, 42.3128747949115], 
                [-71.0753581328642, 42.3131340532646]
              ], 
              [
                [-71.080087748462, 42.3126914928812], 
                [-71.0796714655661, 42.3124733370084], 
                [-71.0794466621663, 42.3123428018393], 
                [-71.0791809575732, 42.3121885119401], 
                [-71.0789180727919, 42.3120474391373], 
                [-71.0785287115067, 42.3118873325988], 
                [-71.0781188093442, 42.3117085821224], 
                [-71.0779327197399, 42.31163108835]
              ], 
              [
                [-71.0800883431468, 42.3127001565245], 
                [-71.0796720602509, 42.3124820006817], 
                [-71.079447256851, 42.3123514655305], 
                [-71.079181552258, 42.3121971756526], 
                [-71.0789186665783, 42.3120561028692], 
                [-71.0785293052931, 42.3118959963528], 
                [-71.0781194031306, 42.311717245901], 
                [-71.077927189711, 42.3116372012307]
              ], 
              [
                [-71.0766265917746, 42.3127947105275], 
                [-71.075878329279, 42.3124256402836]
              ], 
              [
                [-71.0766265917746, 42.3127947105275], 
                [-71.076621960061, 42.3128007967237]
              ], 
              [
                [-71.076621960061, 42.3128007967237], 
                [-71.0758789230653, 42.3124343039634]
              ], 
              [
                [-71.076621960061, 42.3128007967237], 
                [-71.0763942667809, 42.3130999536001], 
                [-71.0761851335929, 42.3134232881964]
              ], 
              [
                [-71.076627185561, 42.3128033741565], 
                [-71.076621960061, 42.3128007967237]
              ], 
              [
                [-71.076627185561, 42.3128033741565], 
                [-71.0763948605673, 42.3131086178515], 
                [-71.0761857273793, 42.3134319524032]
              ], 
              [
                [-71.071272398221, 42.3130836859552], 
                [-71.0713457097313, 42.3130958642697], 
                [-71.0714430008698, 42.3131147963527], 
                [-71.0717279770207, 42.313210951318], 
                [-71.0722311746153, 42.3134092054534]
              ], 
              [
                [-71.071272398221, 42.3130836859552], 
                [-71.0712665977992, 42.3130912880191], 
                [-71.0713463017211, 42.3131045285216], 
                [-71.0714435928596, 42.3131234599377], 
                [-71.0717285690105, 42.313219615554], 
                [-71.0722317675034, 42.3134178689979]
              ], 
              [
                [-71.0756680812816, 42.3132255675241], 
                [-71.0755036159228, 42.3133881371325], 
                [-71.0753494416639, 42.313569878736], 
                [-71.0752776734592, 42.3136731487482], 
                [-71.0752710259261, 42.3136965818012]
              ], 
              [
                [-71.075668675068, 42.3132342310939], 
                [-71.0755042088109, 42.3133968013441], 
                [-71.0753500345519, 42.3135785429226], 
                [-71.0752782663473, 42.3136818129207], 
                [-71.0752716197125, 42.3137052459704]
              ], 
              [
                [-71.0722371636833, 42.3134112746868], 
                [-71.0722311746153, 42.3134092054534]
              ], 
              [
                [-71.0722371636833, 42.3134112746868], 
                [-71.0722317675034, 42.3134178689979]
              ], 
              [
                [-71.0794968294816, 42.3135125434858], 
                [-71.0789962450862, 42.3132029227992], 
                [-71.0781876176001, 42.3127317998702], 
                [-71.0773197929333, 42.3122261939657]
              ], 
              [
                [-71.0794974250647, 42.3135212076803], 
                [-71.0789968397709, 42.3132115870363], 
                [-71.0781882122848, 42.3127404635079], 
                [-71.0773144533473, 42.3122314006932]
              ], 
              [
                [-71.0729546696603, 42.3136747802141], 
                [-71.0725017911963, 42.3135111531492], 
                [-71.0722317675034, 42.3134178689979]
              ], 
              [
                [-71.0729546696603, 42.3136747802141], 
                [-71.0721381477794, 42.3136570034786]
              ], 
              [
                [-71.0729795565869, 42.3136753222646], 
                [-71.0725011992066, 42.3135024889532], 
                [-71.0722371636833, 42.3134112746868]
              ], 
              [
                [-71.0729795565869, 42.3136753222646], 
                [-71.0729546696603, 42.3136747802141]
              ], 
              [
                [-71.072980149475, 42.3136839864367], 
                [-71.0729546696603, 42.3136747802141]
              ], 
              [
                [-71.072980149475, 42.3136839864367], 
                [-71.0721387397692, 42.3136656676532]
              ], 
              [
                [-71.0752710259261, 42.3136965818012], 
                [-71.0746090573932, 42.3136926220437], 
                [-71.0736502720157, 42.3136817531357], 
                [-71.0732118699026, 42.3136829382068], 
                [-71.0729795565869, 42.3136753222646]
              ], 
              [
                [-71.0752710259261, 42.3136965818012], 
                [-71.0752703845289, 42.3137052386634]
              ], 
              [
                [-71.0752703845289, 42.3137052386634], 
                [-71.0746096502813, 42.3137012855491], 
                [-71.0736508649038, 42.3136904173069], 
                [-71.0732124618923, 42.3136916023778], 
                [-71.072980149475, 42.3136839864367]
              ], 
              [
                [-71.0752703845289, 42.3137052386634], 
                [-71.0752591978087, 42.3138562260515]
              ], 
              [
                [-71.0752716197125, 42.3137052459704], 
                [-71.0752703845289, 42.3137052386634]
              ], 
              [
                [-71.0752716197125, 42.3137052459704], 
                [-71.0752604177209, 42.3138564339697]
              ], 
              [
                [-71.0752591978087, 42.3138562260515], 
                [-71.0752348022605, 42.3140747471312], 
                [-71.0752155441775, 42.3143734661767]
              ], 
              [
                [-71.0752604177209, 42.3138564339697], 
                [-71.0752591978087, 42.3138562260515]
              ], 
              [
                [-71.0752604177209, 42.3138564339697], 
                [-71.0752597915951, 42.3138648895344]
              ], 
              [
                [-71.0752597915951, 42.3138648895344], 
                [-71.0752353951486, 42.3140834112483], 
                [-71.0752161720999, 42.3143816028222]
              ], 
              [
                [-71.0791680317146, 42.314048141648], 
                [-71.0789923535844, 42.3139585948375], 
                [-71.0785676750338, 42.3137494071087], 
                [-71.0779467289667, 42.3134415897792], 
                [-71.0772739833454, 42.3131144449468], 
                [-71.0766265917746, 42.3127947105275]
              ], 
              [
                [-71.0791686263993, 42.3140568057689], 
                [-71.0789929482691, 42.3139672589706], 
                [-71.0785682688202, 42.3137580712706], 
                [-71.0779473227531, 42.3134502533192], 
                [-71.0772745780301, 42.3131231091961], 
                [-71.076627185561, 42.3128033741565]
              ], 
              [
                [-71.0777282236553, 42.3140619944095], 
                [-71.0776560125812, 42.3141753911109], 
                [-71.0775422427471, 42.3144101737388]
              ], 
              [
                [-71.07772881834, 42.3140706585284], 
                [-71.0776566063676, 42.3141840552141], 
                [-71.0775428374318, 42.3144188378098]
              ], 
              [
                [-71.0763910831515, 42.314170735226], 
                [-71.0760958841728, 42.3140711740046], 
                [-71.07564294642, 42.313921517675], 
                [-71.0752604177209, 42.3138564339697]
              ], 
              [
                [-71.0763910831515, 42.314170735226], 
                [-71.0763883567647, 42.3141782793669]
              ], 
              [
                [-71.0763883567647, 42.3141782793669], 
                [-71.0760964779592, 42.3140798381222], 
                [-71.0756435402064, 42.3139301818133], 
                [-71.0752597915951, 42.3138648895344]
              ], 
              [
                [-71.0763883567647, 42.3141782793669], 
                [-71.0762923996243, 42.3144438362683], 
                [-71.0760270148315, 42.3151569055946]
              ], 
              [
                [-71.0763916769379, 42.31417939933], 
                [-71.0763883567647, 42.3141782793669]
              ], 
              [
                [-71.0763916769379, 42.31417939933], 
                [-71.0762929934107, 42.3144525003347], 
                [-71.0760304868201, 42.3151578362256]
              ], 
              [
                [-71.0752155441775, 42.3143734661767], 
                [-71.0745043865946, 42.3143196277158], 
                [-71.0739709256564, 42.3142793881708], 
                [-71.0731449669735, 42.3142166802719]
              ], 
              [
                [-71.0752155441775, 42.3143734661767], 
                [-71.0752161720999, 42.3143816028222]
              ], 
              [
                [-71.0752161720999, 42.3143816028222], 
                [-71.0752161379639, 42.3143821302527]
              ], 
              [
                [-71.0752161720999, 42.3143816028222], 
                [-71.0752261829254, 42.3145113632111], 
                [-71.0752370112178, 42.3145924285272], 
                [-71.0752820347799, 42.3147467703245], 
                [-71.0753662590243, 42.3149901643292]
              ], 
              [
                [-71.0752161379639, 42.3143821302527], 
                [-71.074504980381, 42.3143282917992], 
                [-71.0739715185445, 42.3142880522598], 
                [-71.0731455598615, 42.3142253443695]
              ], 
              [
                [-71.0752161379639, 42.3143821302527], 
                [-71.0752267767118, 42.3145200272681], 
                [-71.0752376050042, 42.3146010925731], 
                [-71.0752826285663, 42.3147554343491], 
                [-71.0753668528107, 42.3149988289845]
              ], 
              [
                [-71.0775422427471, 42.3144101737388], 
                [-71.0772366017515, 42.3143409674116], 
                [-71.0768801179074, 42.314278883989], 
                [-71.0766048696128, 42.3142289154946], 
                [-71.0763910831515, 42.314170735226]
              ], 
              [
                [-71.0775422427471, 42.3144101737388], 
                [-71.0775392639336, 42.3144180287292]
              ], 
              [
                [-71.0775392639336, 42.3144180287292], 
                [-71.0772371964362, 42.314349631492], 
                [-71.0768807125921, 42.314287548078], 
                [-71.0766054633991, 42.3142375795905], 
                [-71.0763916769379, 42.31417939933]
              ], 
              [
                [-71.0775392639336, 42.3144180287292], 
                [-71.0773466067462, 42.3149260017352], 
                [-71.0772064372225, 42.3152822284525]
              ], 
              [
                [-71.0775428374318, 42.3144188378098], 
                [-71.0775392639336, 42.3144180287292]
              ], 
              [
                [-71.0775428374318, 42.3144188378098], 
                [-71.0773472014309, 42.3149346657351], 
                [-71.0772101014506, 42.3152830906628]
              ], 
              [
                [-71.0753662590243, 42.3149901643292], 
                [-71.0753688668335, 42.3149992116004]
              ], 
              [
                [-71.0753668528107, 42.3149988289845], 
                [-71.0754063104112, 42.3151357063348], 
                [-71.0754447044065, 42.3152695629937]
              ], 
              [
                [-71.0753688668335, 42.3149992116004], 
                [-71.0753668528107, 42.3149988289845]
              ], 
              [
                [-71.0753688668335, 42.3149992116004], 
                [-71.0754057175231, 42.3151270423625], 
                [-71.0754449774943, 42.3152639200982], 
                [-71.0754447044065, 42.3152695629937]
              ], 
              [
                [-71.0760270148315, 42.3151569055946], 
                [-71.0754900621418, 42.3150136918815], 
                [-71.0753662590243, 42.3149901643292]
              ], 
              [
                [-71.0760304868201, 42.3151578362256], 
                [-71.0760270148315, 42.3151569055946]
              ], 
              [
                [-71.0760304868201, 42.3151578362256], 
                [-71.0760276086179, 42.315165570227]
              ], 
              [
                [-71.0760276086179, 42.315165570227], 
                [-71.0754906559282, 42.3150223565336], 
                [-71.0753688668335, 42.3149992116004]
              ], 
              [
                [-71.0762462980839, 42.3152156701657], 
                [-71.0760304868201, 42.3151578362256]
              ], 
              [
                [-71.0762468918704, 42.31522433479], 
                [-71.0760276086179, 42.315165570227]
              ], 
              [
                [-71.0754447044065, 42.3152695629937], 
                [-71.0754381547897, 42.3154051265144], 
                [-71.0754079013276, 42.3156486594596]
              ], 
              [
                [-71.0754447044065, 42.3152695629937], 
                [-71.0754455712807, 42.3152725840516], 
                [-71.0754387485761, 42.3154137904484], 
                [-71.0754095299732, 42.3156489955735]
              ], 
              [
                [-71.0772064372225, 42.3152822284525], 
                [-71.077082004386, 42.3156081291555], 
                [-71.0769466543238, 42.3159795687277]
              ], 
              [
                [-71.0772101014506, 42.3152830906628], 
                [-71.0772064372225, 42.3152822284525]
              ], 
              [
                [-71.0772101014506, 42.3152830906628], 
                [-71.077207031009, 42.3152908924034]
              ], 
              [
                [-71.077207031009, 42.3152908924034], 
                [-71.0770825990707, 42.3156167937258], 
                [-71.0769501200242, 42.315980351218]
              ], 
              [
                [-71.0783314845894, 42.3155468872691], 
                [-71.077785506526, 42.3154184528839], 
                [-71.0772101014506, 42.3152830906628]
              ], 
              [
                [-71.0783320792741, 42.3155555511835], 
                [-71.0777861003125, 42.315427116816], 
                [-71.077207031009, 42.3152908924034]
              ], 
              [
                [-71.0754079013276, 42.3156486594596], 
                [-71.0753951191994, 42.3158303619869], 
                [-71.0753714432018, 42.3159411197435], 
                [-71.0753250622853, 42.3160180382802]
              ], 
              [
                [-71.0754095299732, 42.3156489955735], 
                [-71.0754079013276, 42.3156486594596]
              ], 
              [
                [-71.0754095299732, 42.3156489955735], 
                [-71.075408495114, 42.3156573240243]
              ], 
              [
                [-71.075408495114, 42.3156573240243], 
                [-71.0753957120875, 42.3158390265266], 
                [-71.0753720369882, 42.3159497842679], 
                [-71.07533030665, 42.3160189894903]
              ], 
              [
                [-71.0769466543238, 42.3159795687277], 
                [-71.0763860453994, 42.3158582141867], 
                [-71.0757434939514, 42.3157179819222], 
                [-71.0754095299732, 42.3156489955735]
              ], 
              [
                [-71.0769466543238, 42.3159795687277], 
                [-71.076944537893, 42.3159876467112]
              ], 
              [
                [-71.0769501200242, 42.315980351218], 
                [-71.0769466543238, 42.3159795687277]
              ], 
              [
                [-71.0769501200242, 42.315980351218], 
                [-71.0769472481102, 42.3159882332468]
              ], 
              [
                [-71.076944537893, 42.3159876467112], 
                [-71.0763866391858, 42.3158668787225], 
                [-71.0757440877378, 42.3157266464774], 
                [-71.075408495114, 42.3156573240243]
              ], 
              [
                [-71.076944537893, 42.3159876467112], 
                [-71.0768472575343, 42.316359013633]
              ], 
              [
                [-71.0769472481102, 42.3159882332468], 
                [-71.076944537893, 42.3159876467112]
              ], 
              [
                [-71.0769472481102, 42.3159882332468], 
                [-71.076847852219, 42.3163676787641]
              ], 
              [
                [-71.0753250622853, 42.3160180382802], 
                [-71.0752615415133, 42.3160774503574], 
                [-71.0752038813502, 42.3161115597009], 
                [-71.075105990137, 42.3161533989204], 
                [-71.0749854002933, 42.3161872750706], 
                [-71.0748702012395, 42.316238055717], 
                [-71.0748483856529, 42.3162513706179], 
                [-71.0747721824656, 42.3162978980205], 
                [-71.074697209072, 42.3163702068965], 
                [-71.0746450034793, 42.3164381004301], 
                [-71.074651538723, 42.3164390383489]
              ], 
              [
                [-71.07533030665, 42.3160189894903], 
                [-71.0753250622853, 42.3160180382802]
              ], 
              [
                [-71.07533030665, 42.3160189894903], 
                [-71.0753256560718, 42.316026702794]
              ], 
              [
                [-71.0753256560718, 42.316026702794], 
                [-71.0752621352997, 42.3160861148631], 
                [-71.0752044751365, 42.3161202242019], 
                [-71.0751065839234, 42.3161620634156], 
                [-71.0749859940797, 42.3161959395611], 
                [-71.0748707950259, 42.3162467202006], 
                [-71.0748489794393, 42.3162600350996], 
                [-71.074772776252, 42.3163065624958], 
                [-71.0746978028584, 42.3163788713618], 
                [-71.074651538723, 42.3164390383489]
              ], 
              [
                [-71.0781506869604, 42.316225386465], 
                [-71.0778216493432, 42.3161679101558], 
                [-71.0772886384609, 42.3160567874595], 
                [-71.0769501200242, 42.315980351218]
              ], 
              [
                [-71.0781512807468, 42.3162340509504], 
                [-71.0778222431296, 42.3161765739847], 
                [-71.0772892331457, 42.316065451968], 
                [-71.0769472481102, 42.3159882332468]
              ], 
              [
                [-71.0768472575343, 42.316359013633], 
                [-71.0765959996476, 42.3163203875259], 
                [-71.0763294524348, 42.3162710144921], 
                [-71.0761447642023, 42.3162258839888], 
                [-71.07599880324, 42.3161707637792], 
                [-71.075835556895, 42.3161223332013], 
                [-71.0755562113844, 42.3160599672359], 
                [-71.07533030665, 42.3160189894903]
              ], 
              [
                [-71.0768472575343, 42.316359013633], 
                [-71.0768460924194, 42.3163674084147]
              ], 
              [
                [-71.0768460924194, 42.3163674084147], 
                [-71.076596593434, 42.3163290519982], 
                [-71.0763300471196, 42.3162796789711], 
                [-71.0761453579887, 42.3162345484741], 
                [-71.0759993970264, 42.316179428272], 
                [-71.0758361497831, 42.3161309977008], 
                [-71.0755568042725, 42.316068631744], 
                [-71.0753256560718, 42.316026702794]
              ], 
              [
                [-71.0768460924194, 42.3163674084147], 
                [-71.076825953089, 42.3165125473582], 
                [-71.0767656042682, 42.3167222068164]
              ], 
              [
                [-71.076847852219, 42.3163676787641], 
                [-71.0768460924194, 42.3163674084147]
              ], 
              [
                [-71.076847852219, 42.3163676787641], 
                [-71.0768265468754, 42.3165212118039], 
                [-71.0767685821834, 42.316722587429]
              ], 
              [
                [-71.074651538723, 42.3164390383489], 
                [-71.0750797781953, 42.3165004766487], 
                [-71.0755958522412, 42.316564278944], 
                [-71.0758732681706, 42.3166035684838], 
                [-71.0764558184459, 42.3166760530336], 
                [-71.0767656042682, 42.3167222068164]
              ], 
              [
                [-71.074651538723, 42.3164390383489], 
                [-71.0746455972657, 42.3164467655504], 
                [-71.0750803719817, 42.3165091410961], 
                [-71.0755964460276, 42.3165729433826], 
                [-71.075873861957, 42.316612232917], 
                [-71.0764564122323, 42.3166847181211], 
                [-71.0767661980546, 42.3167308712333]
              ], 
              [
                [-71.0767685821834, 42.316722587429], 
                [-71.0767656042682, 42.3167222068164]
              ], 
              [
                [-71.0767685821834, 42.316722587429], 
                [-71.0767661980546, 42.3167308712333]
              ], 
              [
                [-71.0780541072876, 42.316895187383], 
                [-71.077595502962, 42.3168242952792], 
                [-71.0773326765711, 42.3167932013288], 
                [-71.0771782687502, 42.3167749326044], 
                [-71.0767685821834, 42.316722587429]
              ], 
              [
                [-71.0780547019723, 42.3169038524403], 
                [-71.0775960976467, 42.3168329596821], 
                [-71.0773332703575, 42.3168018664002], 
                [-71.0771788625366, 42.3167835976783], 
                [-71.0767661980546, 42.3167308712333]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 50, 
            "OBJECTID" : null, 
            "Name" : "Grove Hall Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 21320.40831345, 
            "Link" : "https://www.boston.gov/grove-hall-quincy-corridor", 
            "GlobalID" : "75b16bfe-3cec-4095-adae-458f35bd3841", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 51, 
          "geometry" : 
          {
            "type" : "MultiLineString", 
            "coordinates" : 
            [
              [
                [-71.0939097915655, 42.3212455961896], 
                [-71.0933181997469, 42.3209188346525], 
                [-71.0931457160259, 42.3208000348602]
              ], 
              [
                [-71.093903515935, 42.32125046343], 
                [-71.0939097915655, 42.3212455961896]
              ], 
              [
                [-71.093903515935, 42.32125046343], 
                [-71.0933187998216, 42.3209274991558], 
                [-71.0931463161005, 42.320808700044]
              ], 
              [
                [-71.0939103916401, 42.321254261312], 
                [-71.093903515935, 42.32125046343]
              ], 
              [
                [-71.0935188312791, 42.3215488116677], 
                [-71.093903515935, 42.32125046343]
              ], 
              [
                [-71.0935208587767, 42.3215563702006], 
                [-71.0939103916401, 42.321254261312]
              ], 
              [
                [-71.0935208587767, 42.3215563702006], 
                [-71.0935188312791, 42.3215488116677]
              ], 
              [
                [-71.0935194313537, 42.3215574767485], 
                [-71.0935208587767, 42.3215563702006]
              ], 
              [
                [-71.0919408344814, 42.3216915860892], 
                [-71.0921114595881, 42.321805853082], 
                [-71.0926288918867, 42.3221987564933]
              ], 
              [
                [-71.0919414336577, 42.3217002511502], 
                [-71.0921120596628, 42.3218145181273], 
                [-71.0926233016707, 42.3222027210292]
              ], 
              [
                [-71.0953983341273, 42.3220543586161], 
                [-71.0951080085089, 42.3219233577963], 
                [-71.0942990261882, 42.3214709202033], 
                [-71.0939097915655, 42.3212455961896]
              ], 
              [
                [-71.0953983341273, 42.3220543586161], 
                [-71.0953921025142, 42.3220599411257]
              ], 
              [
                [-71.0953921025142, 42.3220599411257], 
                [-71.0951086094819, 42.3219320228254], 
                [-71.0942996262629, 42.3214795852948], 
                [-71.0939103916401, 42.321254261312]
              ], 
              [
                [-71.0953921025142, 42.3220599411257], 
                [-71.0953338934804, 42.3221120919034], 
                [-71.0952976680182, 42.3222335027953], 
                [-71.0953103603149, 42.3224721268931]
              ], 
              [
                [-71.0953989342019, 42.3220630236272], 
                [-71.0953921025142, 42.3220599411257]
              ], 
              [
                [-71.0953989342019, 42.3220630236272], 
                [-71.095334493555, 42.3221207569065], 
                [-71.0952982680928, 42.3222421677818], 
                [-71.0953109612878, 42.3224807918466]
              ], 
              [
                [-71.0926288918867, 42.3221987564933], 
                [-71.0930974863766, 42.3218491052356], 
                [-71.0932387671163, 42.3217465088471], 
                [-71.0935188312791, 42.3215488116677]
              ], 
              [
                [-71.0926288918867, 42.3221987564933], 
                [-71.0926233016707, 42.3222027210292]
              ], 
              [
                [-71.0926233016707, 42.3222027210292], 
                [-71.0926294919613, 42.3222074214845]
              ], 
              [
                [-71.0926233016707, 42.3222027210292], 
                [-71.0919334350584, 42.3226920135025], 
                [-71.0915057363718, 42.3230224765987]
              ], 
              [
                [-71.0926350085155, 42.32220330485], 
                [-71.0930980855529, 42.321857770275], 
                [-71.0932393662926, 42.3217551739006], 
                [-71.0935194313537, 42.3215574767485]
              ], 
              [
                [-71.0926350085155, 42.32220330485], 
                [-71.0926288918867, 42.3221987564933]
              ], 
              [
                [-71.0926294919613, 42.3222074214845], 
                [-71.0926350085155, 42.32220330485]
              ], 
              [
                [-71.0926294919613, 42.3222074214845], 
                [-71.0919340342347, 42.32270067909], 
                [-71.091512560873, 42.3230263321573]
              ], 
              [
                [-71.0953103603149, 42.3224721268931], 
                [-71.0950216992748, 42.3224069643583], 
                [-71.0946165590816, 42.3223187352322], 
                [-71.0945620861411, 42.3223068715343], 
                [-71.0943898314904, 42.3222685652311], 
                [-71.0943038483447, 42.3222266204865], 
                [-71.0939151419313, 42.3219191494849], 
                [-71.0935778532883, 42.3216471748097], 
                [-71.0935326195204, 42.3216002242855], 
                [-71.0935208587767, 42.3215563702006]
              ], 
              [
                [-71.0953103603149, 42.3224721268931], 
                [-71.0953107690484, 42.3224807486747]
              ], 
              [
                [-71.0953107690484, 42.3224807486747], 
                [-71.0950222993494, 42.3224156293209], 
                [-71.0946171591562, 42.3223274002069], 
                [-71.094562687114, 42.3223155365106], 
                [-71.094390431565, 42.3222772308769], 
                [-71.0943044484193, 42.3222352854739], 
                [-71.093915742006, 42.3219278145146], 
                [-71.0935784533629, 42.3216558398768], 
                [-71.0935332195951, 42.3216088886949], 
                [-71.0935194313537, 42.3215574767485]
              ], 
              [
                [-71.0953107690484, 42.3224807486747], 
                [-71.0953354170231, 42.323000576623], 
                [-71.0953356622632, 42.3230017515559]
              ], 
              [
                [-71.0953109612878, 42.3224807918466], 
                [-71.0953107690484, 42.3224807486747]
              ], 
              [
                [-71.0953109612878, 42.3224807918466], 
                [-71.0953356622632, 42.3230017515559]
              ], 
              [
                [-71.0983922446961, 42.3225600217197], 
                [-71.0982230577921, 42.3224862826609], 
                [-71.0978645940612, 42.322367428044], 
                [-71.0969756347307, 42.3220278269106], 
                [-71.0967132583958, 42.3219425064065], 
                [-71.0965643168233, 42.3219048448107], 
                [-71.0963938183791, 42.3218884911044], 
                [-71.096194873883, 42.3219035476462], 
                [-71.0957823423517, 42.3219713096779], 
                [-71.095483804335, 42.322028214133], 
                [-71.0953983341273, 42.3220543586161]
              ], 
              [
                [-71.098392845669, 42.3225686866612], 
                [-71.0982236596633, 42.3224949476126], 
                [-71.0978651950341, 42.322376093012], 
                [-71.0969762366019, 42.3220364919253], 
                [-71.0967138593687, 42.321951171433], 
                [-71.0965649177963, 42.3219135098424], 
                [-71.0963944184537, 42.3218971561383], 
                [-71.0961954748559, 42.3219122126781], 
                [-71.0957829424263, 42.3219799740363], 
                [-71.0954844053079, 42.3220368791477], 
                [-71.0953989342019, 42.3220630236272]
              ], 
              [
                [-71.0933851781345, 42.3227382346045], 
                [-71.0932570415441, 42.3226781340809], 
                [-71.0931063841895, 42.3225538122649], 
                [-71.0926350085155, 42.32220330485]
              ], 
              [
                [-71.0933851781345, 42.3227382346045], 
                [-71.093370736818, 42.3227398452457]
              ], 
              [
                [-71.093370736818, 42.3227398452457], 
                [-71.0932576416187, 42.3226867990061], 
                [-71.0931069842641, 42.3225624772072], 
                [-71.0926294919613, 42.3222074214845]
              ], 
              [
                [-71.093370736818, 42.3227398452457], 
                [-71.0932531518389, 42.3227529601804], 
                [-71.093080628592, 42.3227562864026], 
                [-71.0929739994661, 42.3227711016389], 
                [-71.0928773416398, 42.322797204634], 
                [-71.092739781722, 42.3228760555257], 
                [-71.0922864064897, 42.3231614173648], 
                [-71.0921437531243, 42.3232363099714], 
                [-71.0920625274563, 42.3232512147584]
              ], 
              [
                [-71.0933857782091, 42.3227469001855], 
                [-71.093370736818, 42.3227398452457]
              ], 
              [
                [-71.0933857782091, 42.3227469001855], 
                [-71.0932537510152, 42.3227616250953], 
                [-71.0930812286666, 42.3227649513171], 
                [-71.0929745986424, 42.3227797665513], 
                [-71.0928779408161, 42.3228058695428], 
                [-71.0927403817966, 42.3228847210879], 
                [-71.0922870065643, 42.3231700828876], 
                [-71.0921443523006, 42.3232449754838], 
                [-71.0920665231627, 42.3232592566071]
              ], 
              [
                [-71.0947789071113, 42.322933869089], 
                [-71.0947785792262, 42.3229260284452], 
                [-71.0947486437677, 42.3228353279656], 
                [-71.0946881548097, 42.322778283434], 
                [-71.0946173127681, 42.3227403327552], 
                [-71.0945516611922, 42.3227215344117], 
                [-71.0944195621331, 42.3227171308842], 
                [-71.0941809300677, 42.3227427344369], 
                [-71.093754632753, 42.3227676724693], 
                [-71.0935616611553, 42.3227669903547], 
                [-71.0933851781345, 42.3227382346045]
              ], 
              [
                [-71.0947789071113, 42.322933869089], 
                [-71.0947492447406, 42.3228439928691], 
                [-71.0946887548844, 42.3227869483454], 
                [-71.0946179128428, 42.3227489976718], 
                [-71.0945522612668, 42.3227301993309], 
                [-71.0944201622077, 42.3227257964681], 
                [-71.0941815301424, 42.3227513993532], 
                [-71.0937552328276, 42.3227763380463], 
                [-71.0935622612299, 42.3227756559319], 
                [-71.0933857782091, 42.3227469001855]
              ], 
              [
                [-71.0953356622632, 42.3230017515559], 
                [-71.0953360170977, 42.3230092415037], 
                [-71.0953636025635, 42.3231415670897], 
                [-71.0953956400797, 42.3232492069527]
              ], 
              [
                [-71.0953356622632, 42.3230017515559], 
                [-71.0953630024889, 42.3231329015629], 
                [-71.0953977071032, 42.3232495025113]
              ], 
              [
                [-71.0915057363718, 42.3230224765987], 
                [-71.091056417033, 42.3233539906773], 
                [-71.090962449661, 42.3234335575156], 
                [-71.0908652573372, 42.3235429310359], 
                [-71.0906758313899, 42.3238140334305]
              ], 
              [
                [-71.091512560873, 42.3230263321573], 
                [-71.0915057363718, 42.3230224765987]
              ], 
              [
                [-71.091512560873, 42.3230263321573], 
                [-71.0915063355481, 42.3230311421407]
              ], 
              [
                [-71.0915063355481, 42.3230311421407], 
                [-71.0910570162093, 42.3233626555094], 
                [-71.0909630488374, 42.3234422223368], 
                [-71.0908658565135, 42.3235515965062], 
                [-71.0906764305662, 42.3238226988634]
              ], 
              [
                [-71.0947872928845, 42.3231342525005], 
                [-71.0947789071113, 42.322933869089]
              ], 
              [
                [-71.0947872928845, 42.3231342525005], 
                [-71.0947216413086, 42.3231148870668], 
                [-71.0945493399455, 42.3230838931947], 
                [-71.0943918374285, 42.3230799632517], 
                [-71.0942192683674, 42.3230906060443], 
                [-71.0938333655961, 42.3231421369541]
              ], 
              [
                [-71.0947875327347, 42.3231343096198], 
                [-71.0947791793009, 42.3229346933362], 
                [-71.0947789071113, 42.322933869089]
              ], 
              [
                [-71.0947875327347, 42.3231343096198], 
                [-71.0947872928845, 42.3231342525005]
              ], 
              [
                [-71.0938333655961, 42.3231421369541], 
                [-71.0936249178226, 42.323190354242], 
                [-71.093533207917, 42.3232429238423], 
                [-71.0934720712737, 42.3232877185534], 
                [-71.0933799238884, 42.3234083700175], 
                [-71.0932803779786, 42.3235599431721], 
                [-71.0932647526825, 42.3236319109529], 
                [-71.0932541929863, 42.3237112124352], 
                [-71.0932613786103, 42.3238620383332]
              ], 
              [
                [-71.0947878929591, 42.3231429173629], 
                [-71.0947875327347, 42.3231343096198]
              ], 
              [
                [-71.0947878929591, 42.3231429173629], 
                [-71.0947222422815, 42.3231235519318], 
                [-71.0945499400201, 42.3230925587282], 
                [-71.0943924375031, 42.3230886287857], 
                [-71.094219868442, 42.3230992715768], 
                [-71.093836852856, 42.3231504172566]
              ], 
              [
                [-71.093836852856, 42.3231504172566], 
                [-71.0938333655961, 42.3231421369541]
              ], 
              [
                [-71.093836852856, 42.3231504172566], 
                [-71.0938339656707, 42.3231508024796]
              ], 
              [
                [-71.0938339656707, 42.3231508024796], 
                [-71.0936255178972, 42.3231990190966], 
                [-71.0935338079916, 42.3232515893539], 
                [-71.0934726713483, 42.3232963840589], 
                [-71.0933805230648, 42.3234170355062], 
                [-71.0932809780532, 42.3235686079759], 
                [-71.0932653527571, 42.3236405764109], 
                [-71.0932547930609, 42.3237198778823], 
                [-71.0932619786849, 42.3238707037595]
              ], 
              [
                [-71.0953956400797, 42.3232492069527], 
                [-71.0952079362028, 42.3232223841774], 
                [-71.0950763204373, 42.3232027909581], 
                [-71.0947875327347, 42.3231343096198]
              ], 
              [
                [-71.0953956400797, 42.3232492069527], 
                [-71.0953983071778, 42.3232581673578]
              ], 
              [
                [-71.0953977071032, 42.3232495025113], 
                [-71.0953956400797, 42.3232492069527]
              ], 
              [
                [-71.0953977071032, 42.3232495025113], 
                [-71.095516735675, 42.3235194438663]
              ], 
              [
                [-71.0920625274563, 42.3232512147584], 
                [-71.0920014878311, 42.3232509975726], 
                [-71.0919204508093, 42.3232355176086], 
                [-71.0918292789945, 42.3232053746067], 
                [-71.0917282319997, 42.3231481849557], 
                [-71.091512560873, 42.3230263321573]
              ], 
              [
                [-71.0920625274563, 42.3232512147584], 
                [-71.0920665231627, 42.3232592566071]
              ], 
              [
                [-71.0953983071778, 42.3232581673578], 
                [-71.0952085371758, 42.3232310496918], 
                [-71.0950769205119, 42.3232114564752], 
                [-71.0947878929591, 42.3231429173629]
              ], 
              [
                [-71.0953983071778, 42.3232581673578], 
                [-71.0955173357496, 42.3235281086756]
              ], 
              [
                [-71.0920665231627, 42.3232592566071], 
                [-71.0920631266326, 42.3232598796046]
              ], 
              [
                [-71.0920665231627, 42.3232592566071], 
                [-71.0921076237819, 42.3233419710933], 
                [-71.0922130833013, 42.3235088947947], 
                [-71.092484493993, 42.3239284984762]
              ], 
              [
                [-71.0920631266326, 42.3232598796046], 
                [-71.0920020870073, 42.3232596630831], 
                [-71.0919210508839, 42.3232441831212], 
                [-71.0918298781708, 42.3232140394593], 
                [-71.091728831176, 42.3231568504803], 
                [-71.0915063355481, 42.3230311421407]
              ], 
              [
                [-71.0920631266326, 42.3232598796046], 
                [-71.0921082229582, 42.3233506365913], 
                [-71.0922136824776, 42.3235175602696], 
                [-71.0924809043251, 42.3239306875783]
              ], 
              [
                [-71.095516735675, 42.3235194438663], 
                [-71.0955242402009, 42.3235289535044]
              ], 
              [
                [-71.0955173357496, 42.3235281086756], 
                [-71.0955596428062, 42.323581715432], 
                [-71.0957003594039, 42.3238095323463], 
                [-71.0957496643366, 42.3238888375898]
              ], 
              [
                [-71.0955242402009, 42.3235289535044], 
                [-71.0955173357496, 42.3235281086756]
              ], 
              [
                [-71.0955242402009, 42.3235289535044], 
                [-71.0955590418333, 42.3235730499659], 
                [-71.0956997593293, 42.3238008669116], 
                [-71.0957535333805, 42.3238873604762]
              ], 
              [
                [-71.0906758313899, 42.3238140334305], 
                [-71.0903897009039, 42.3237023816081], 
                [-71.0901825071785, 42.3236215259508], 
                [-71.0895995894924, 42.3233941785916]
              ], 
              [
                [-71.0906758313899, 42.3238140334305], 
                [-71.0906713649663, 42.323820722292]
              ], 
              [
                [-71.0906713649663, 42.323820722292], 
                [-71.0903903000802, 42.3237110470565], 
                [-71.0901831054565, 42.3236301914102], 
                [-71.0896001886686, 42.3234028434182]
              ], 
              [
                [-71.0906713649663, 42.323820722292], 
                [-71.0905322689294, 42.3240290317207], 
                [-71.0902587319253, 42.3244089959488], 
                [-71.0901206420016, 42.3245975632007], 
                [-71.0900544631146, 42.3246884849622]
              ], 
              [
                [-71.0906764305662, 42.3238226988634], 
                [-71.0906713649663, 42.323820722292]
              ], 
              [
                [-71.0906764305662, 42.3238226988634], 
                [-71.0905328681057, 42.324037697124], 
                [-71.0902593311016, 42.324417661964], 
                [-71.0901212411779, 42.3246062285258], 
                [-71.0900599311597, 42.3246904608422]
              ], 
              [
                [-71.0932613786103, 42.3238620383332], 
                [-71.0932617576993, 42.3238707196995]
              ], 
              [
                [-71.0932613786103, 42.3238620383332], 
                [-71.0929514867867, 42.3238840123961], 
                [-71.092718019136, 42.3239017517058], 
                [-71.0925758014534, 42.3239091253168], 
                [-71.092484493993, 42.3239284984762]
              ], 
              [
                [-71.0932619786849, 42.3238707037595], 
                [-71.0932617576993, 42.3238707196995]
              ], 
              [
                [-71.0932619786849, 42.3238707037595], 
                [-71.09327217636, 42.3241040069796]
              ], 
              [
                [-71.0932617576993, 42.3238707196995], 
                [-71.0929520868613, 42.3238926778194], 
                [-71.0927186192106, 42.3239104171267], 
                [-71.0925764006297, 42.3239177907367], 
                [-71.0924850931693, 42.3239371638933]
              ], 
              [
                [-71.0932617576993, 42.3238707196995], 
                [-71.0932719562728, 42.3241040288971]
              ], 
              [
                [-71.0957535333805, 42.3238873604762], 
                [-71.0957496643366, 42.3238888375898]
              ], 
              [
                [-71.0957535333805, 42.3238873604762], 
                [-71.0958543746611, 42.3240495545181], 
                [-71.0959531794608, 42.3241613139835], 
                [-71.0961296849394, 42.3243363668844], 
                [-71.0962780309288, 42.3244691220497], 
                [-71.0963908530403, 42.3246124397705], 
                [-71.0965389250435, 42.3247885135589], 
                [-71.0965468194383, 42.3247992264634], 
                [-71.0966373193132, 42.3249357225224], 
                [-71.0966795859457, 42.3250258986102], 
                [-71.0967001789252, 42.3251261312306], 
                [-71.0967202571702, 42.3253073833249], 
                [-71.0967200918801, 42.3253091300521]
              ], 
              [
                [-71.0957496643366, 42.3238888375898], 
                [-71.0957541334551, 42.323896025899]
              ], 
              [
                [-71.0957496643366, 42.3238888375898], 
                [-71.0955507252304, 42.3239647873517]
              ], 
              [
                [-71.0957541334551, 42.323896025899], 
                [-71.0955513262033, 42.3239734527638]
              ], 
              [
                [-71.0957541334551, 42.323896025899], 
                [-71.095854975634, 42.3240582199186], 
                [-71.0959537804338, 42.3241699793686], 
                [-71.0961302859124, 42.3243450329095], 
                [-71.0962786319018, 42.3244777873924], 
                [-71.0963914540132, 42.3246211057576], 
                [-71.0965395260165, 42.3247971795218], 
                [-71.0965474204112, 42.3248078917607], 
                [-71.0966379202862, 42.3249443878009], 
                [-71.0966801869186, 42.3250345638762], 
                [-71.0967007798982, 42.325134797147], 
                [-71.0967200918801, 42.3253091300521]
              ], 
              [
                [-71.092484493993, 42.3239284984762], 
                [-71.0924809043251, 42.3239306875783]
              ], 
              [
                [-71.0924809043251, 42.3239306875783], 
                [-71.0924850931693, 42.3239371638933]
              ], 
              [
                [-71.0924809043251, 42.3239306875783], 
                [-71.0923010337575, 42.3240403850128], 
                [-71.0918883162749, 42.3242803113281], 
                [-71.0913125644498, 42.3246383839312], 
                [-71.0910169100252, 42.3248337096504], 
                [-71.0908423646705, 42.3249731963397]
              ], 
              [
                [-71.0924850931693, 42.3239371638933], 
                [-71.0923016329338, 42.3240490504145], 
                [-71.0918889154512, 42.3242889766968], 
                [-71.0913131645244, 42.3246470492506], 
                [-71.0910175092014, 42.324842375607], 
                [-71.0908498161958, 42.3249763862921]
              ], 
              [
                [-71.0950260749685, 42.3240337014879], 
                [-71.094776914648, 42.3239557327353], 
                [-71.0945322836332, 42.3238524603358], 
                [-71.0940560067511, 42.3236003853331], 
                [-71.0940134508611, 42.3235557861116], 
                [-71.0939453918002, 42.3234081196235], 
                [-71.093836852856, 42.3231504172566]
              ], 
              [
                [-71.0950266759414, 42.3240423668906], 
                [-71.0947775156209, 42.3239643981487], 
                [-71.0945328837078, 42.3238611257635], 
                [-71.0940566068257, 42.3236090507954], 
                [-71.0940140509357, 42.3235644509159], 
                [-71.0939459918748, 42.3234167844482], 
                [-71.0938339656707, 42.3231508024796]
              ], 
              [
                [-71.09327217636, 42.3241040069796], 
                [-71.0932725563474, 42.3241126949543]
              ], 
              [
                [-71.09327217636, 42.3241040069796], 
                [-71.0937055766537, 42.3240611130343], 
                [-71.0939238349284, 42.3240506284779], 
                [-71.0939949222101, 42.3240508795334], 
                [-71.0941166897451, 42.3240698807151], 
                [-71.0943847380428, 42.324187863386], 
                [-71.0952093447612, 42.3246026573255], 
                [-71.0955350451371, 42.324777674462], 
                [-71.0956407427101, 42.3248489408255], 
                [-71.0956749595393, 42.3248940777634], 
                [-71.0957342779924, 42.3250445242483], 
                [-71.0957975014221, 42.3252371854429], 
                [-71.0957980592759, 42.3252457198412]
              ], 
              [
                [-71.0932719562728, 42.3241040288971], 
                [-71.09327217636, 42.3241040069796]
              ], 
              [
                [-71.0932719562728, 42.3241040288971], 
                [-71.0932745281494, 42.3244703467674], 
                [-71.0932552359304, 42.3251128633703]
              ], 
              [
                [-71.0932725563474, 42.3241126949543], 
                [-71.0932751273257, 42.32447901211], 
                [-71.0932560884316, 42.3251131111008]
              ], 
              [
                [-71.0932725563474, 42.3241126949543], 
                [-71.0937061767283, 42.3240697790974], 
                [-71.093924435003, 42.3240592938782], 
                [-71.0939955222847, 42.3240595449337], 
                [-71.0941172898197, 42.3240785461128], 
                [-71.0943853381174, 42.3241965287674], 
                [-71.0952099457341, 42.3246113226497], 
                [-71.0955356452117, 42.3247863397622], 
                [-71.095641343683, 42.3248576067801], 
                [-71.0956755605122, 42.3249027437117], 
                [-71.0957348789653, 42.3250531895118], 
                [-71.0957980592759, 42.3252457198412]
              ], 
              [
                [-71.0893944942315, 42.324439109815], 
                [-71.0887878026313, 42.3242180583863]
              ], 
              [
                [-71.0893944942315, 42.324439109815], 
                [-71.0893894322249, 42.3244457129329]
              ], 
              [
                [-71.0893894322249, 42.3244457129329], 
                [-71.0887884009093, 42.3242267237636]
              ], 
              [
                [-71.0893894322249, 42.3244457129329], 
                [-71.0891140258268, 42.3248049787545], 
                [-71.0890390784843, 42.3249059834797], 
                [-71.0887504740381, 42.3252949005339], 
                [-71.0887094668436, 42.325362279017], 
                [-71.0886940077359, 42.325407797475], 
                [-71.0886945925392, 42.3254114689169], 
                [-71.0886951405115, 42.3254148906367]
              ], 
              [
                [-71.0893950934078, 42.3244477751618], 
                [-71.0893894322249, 42.3244457129329]
              ], 
              [
                [-71.0893950934078, 42.3244477751618], 
                [-71.0891146250031, 42.3248136447151], 
                [-71.0890396767623, 42.3249146487622], 
                [-71.088751072316, 42.3253035664271], 
                [-71.0887100651216, 42.3253709442367], 
                [-71.0886951405115, 42.3254148906367]
              ], 
              [
                [-71.0900544631146, 42.3246884849622], 
                [-71.0893944942315, 42.324439109815]
              ], 
              [
                [-71.0900544631146, 42.3246884849622], 
                [-71.090049797265, 42.3246951611118]
              ], 
              [
                [-71.0900599311597, 42.3246904608422], 
                [-71.0900544631146, 42.3246884849622]
              ], 
              [
                [-71.0900599311597, 42.3246904608422], 
                [-71.0900550622909, 42.3246971502747]
              ], 
              [
                [-71.090049797265, 42.3246951611118], 
                [-71.0893950934078, 42.3244477751618]
              ], 
              [
                [-71.090049797265, 42.3246951611118], 
                [-71.0898594891721, 42.3249674433998], 
                [-71.0897154308415, 42.3251641561842], 
                [-71.0895880677005, 42.3253406627855], 
                [-71.0895468718599, 42.3254085971161], 
                [-71.0895466023653, 42.3254502335647], 
                [-71.0895472491523, 42.3254514967842]
              ], 
              [
                [-71.0900550622909, 42.3246971502747], 
                [-71.090049797265, 42.3246951611118]
              ], 
              [
                [-71.0900550622909, 42.3246971502747], 
                [-71.08986008745, 42.3249761093381], 
                [-71.0897160291195, 42.3251728220953], 
                [-71.0895886668768, 42.3253493286722], 
                [-71.0895474710362, 42.3254172629936], 
                [-71.0895472491523, 42.3254514967842]
              ], 
              [
                [-71.0977804291055, 42.3248468427451], 
                [-71.0975637949849, 42.3246122724017], 
                [-71.09722452376, 42.3243359331846], 
                [-71.0969417484816, 42.3241183045121], 
                [-71.0966728081569, 42.3239322377496], 
                [-71.0963611969578, 42.3237775319333], 
                [-71.0959501763929, 42.3236067208774], 
                [-71.0958226803012, 42.3235640723371], 
                [-71.09573049878, 42.3235429270509], 
                [-71.0955883682341, 42.3235367987223], 
                [-71.0955242402009, 42.3235289535044]
              ], 
              [
                [-71.0977804291055, 42.3248468427451], 
                [-71.0977108977059, 42.3248370756122], 
                [-71.0976255604489, 42.3248418429509], 
                [-71.0975331085348, 42.3248628974749], 
                [-71.0973975006561, 42.3249631449665], 
                [-71.0970540190275, 42.3253479425821], 
                [-71.0969428075953, 42.3254964440063], 
                [-71.0967677987099, 42.3257301270691], 
                [-71.096651268353, 42.3259634838313], 
                [-71.096628389161, 42.3260092920868], 
                [-71.0965227050628, 42.3262024836355]
              ], 
              [
                [-71.0977889343547, 42.3248480375684], 
                [-71.097563194012, 42.3246036070775], 
                [-71.0972239218887, 42.3243272678224], 
                [-71.0969411466103, 42.3241096391199], 
                [-71.0966722071839, 42.3239235729959], 
                [-71.0963605968832, 42.3237688671583], 
                [-71.0959495754199, 42.3235980554147], 
                [-71.0958220802266, 42.3235554068686], 
                [-71.0957298987054, 42.3235342615795], 
                [-71.0955877681595, 42.3235281339142], 
                [-71.095516735675, 42.3235194438663]
              ], 
              [
                [-71.0977889343547, 42.3248480375684], 
                [-71.0977804291055, 42.3248468427451]
              ], 
              [
                [-71.0977895353276, 42.3248567028589], 
                [-71.0977804291055, 42.3248468427451]
              ], 
              [
                [-71.0977895353276, 42.3248567028589], 
                [-71.0977114995772, 42.3248457409042], 
                [-71.0976261623201, 42.3248505082423], 
                [-71.0975337095077, 42.3248715627634], 
                [-71.0973981016291, 42.3249718102412], 
                [-71.0970546200004, 42.3253566084679], 
                [-71.0969434094665, 42.3255051092075], 
                [-71.0967683996829, 42.3257387929022], 
                [-71.0966518693259, 42.3259721489682], 
                [-71.0966289901339, 42.3260179578815], 
                [-71.0965276278305, 42.3262032493951]
              ], 
              [
                [-71.0982715686141, 42.3249076857193], 
                [-71.0979734671786, 42.3248644383249], 
                [-71.0977889343547, 42.3248480375684]
              ], 
              [
                [-71.0982721704853, 42.3249163510016], 
                [-71.0979740681516, 42.3248731036132], 
                [-71.0977895353276, 42.3248567028589]
              ], 
              [
                [-71.0908423646705, 42.3249731963397], 
                [-71.0900599311597, 42.3246904608422]
              ], 
              [
                [-71.0908423646705, 42.3249731963397], 
                [-71.0908498161958, 42.3249763862921]
              ], 
              [
                [-71.0908498161958, 42.3249763862921], 
                [-71.0908429638468, 42.3249818622771]
              ], 
              [
                [-71.0908498161958, 42.3249763862921], 
                [-71.0909563581851, 42.325021992034], 
                [-71.0910422658723, 42.3250751917174], 
                [-71.0911534539483, 42.3251476107196], 
                [-71.0912594308973, 42.3252346410629], 
                [-71.0913400708638, 42.3253108893981], 
                [-71.0917975397188, 42.3259809854539]
              ], 
              [
                [-71.0908429638468, 42.3249818622771], 
                [-71.0900550622909, 42.3246971502747]
              ], 
              [
                [-71.0908429638468, 42.3249818622771], 
                [-71.0909569573614, 42.3250306579647], 
                [-71.0910428650486, 42.3250838576408], 
                [-71.0911540540229, 42.325156276633], 
                [-71.0912600300736, 42.3252433069643], 
                [-71.0913406709384, 42.325319555289], 
                [-71.0917940883915, 42.3259837170934]
              ], 
              [
                [-71.0932552359304, 42.3251128633703], 
                [-71.0932329657962, 42.3254222620779], 
                [-71.0932001620169, 42.3257771993716], 
                [-71.0931473123321, 42.3261247526784], 
                [-71.0931207473526, 42.3263058451575], 
                [-71.0930998767936, 42.3263963613152], 
                [-71.0930481041888, 42.3265475420689], 
                [-71.0929053061946, 42.3268784557877]
              ], 
              [
                [-71.0932560884316, 42.3251131111008], 
                [-71.0932552359304, 42.3251128633703]
              ], 
              [
                [-71.0932560884316, 42.3251131111008], 
                [-71.093255836005, 42.3251215292885]
              ], 
              [
                [-71.093255836005, 42.3251215292885], 
                [-71.0932335658708, 42.3254309279535], 
                [-71.0932007620915, 42.3257858651983], 
                [-71.0931479124067, 42.3261334184572], 
                [-71.0931213474272, 42.3263145109114], 
                [-71.0931004768682, 42.3264050277207], 
                [-71.0930487042634, 42.3265562084536], 
                [-71.0929091689503, 42.3268795615779]
              ], 
              [
                [-71.0957980592759, 42.3252457198412], 
                [-71.0958014737723, 42.325297965609], 
                [-71.0957921169203, 42.3253975296571], 
                [-71.0957526512349, 42.3255223087683], 
                [-71.0956959504725, 42.3256436499851], 
                [-71.0956524297919, 42.3257205805712], 
                [-71.0956133674501, 42.3257812148215], 
                [-71.0954713491936, 42.3259343270682], 
                [-71.0953083696482, 42.3261042458334]
              ], 
              [
                [-71.0957980592759, 42.3252457198412], 
                [-71.095798102395, 42.3252458513439], 
                [-71.0958020738469, 42.3253066315016], 
                [-71.0957927178932, 42.3254061955361], 
                [-71.0957532522078, 42.3255309746301], 
                [-71.0956965514454, 42.3256523158301], 
                [-71.0956530307649, 42.3257292457415], 
                [-71.095613968423, 42.3257898806476], 
                [-71.0954719492682, 42.3259429928732], 
                [-71.0953143416482, 42.3261073115331]
              ], 
              [
                [-71.0967200918801, 42.3253091300521], 
                [-71.0967208581431, 42.3253160492163], 
                [-71.0967056137327, 42.3254769225596], 
                [-71.0966620229836, 42.3256247581996], 
                [-71.0965679576952, 42.3258973293539], 
                [-71.0965099687487, 42.3261030702942], 
                [-71.096348763376, 42.3265756877246]
              ], 
              [
                [-71.0967200918801, 42.3253091300521], 
                [-71.0967050127598, 42.3254682566903], 
                [-71.0966614220106, 42.3256160923507], 
                [-71.096567355824, 42.3258886635426], 
                [-71.0965093677758, 42.3260944045112], 
                [-71.0963354997508, 42.3266041448498]
              ], 
              [
                [-71.0886951405115, 42.3254148906367], 
                [-71.0886946060139, 42.3254164633526], 
                [-71.0886951917155, 42.3254201347939], 
                [-71.0886952752588, 42.3254206568187]
              ], 
              [
                [-71.0886951405115, 42.3254148906367], 
                [-71.088696079251, 42.3254207571058]
              ], 
              [
                [-71.0880296119551, 42.325415259242], 
                [-71.0882524687058, 42.3254170398379], 
                [-71.0883926175682, 42.3254146933831], 
                [-71.0885501398482, 42.3253967359933], 
                [-71.08868999047, 42.3254199973141], 
                [-71.0886952752588, 42.3254206568187]
              ], 
              [
                [-71.0886952752588, 42.3254206568187], 
                [-71.088696079251, 42.3254207571058]
              ], 
              [
                [-71.0886952752588, 42.3254206568187], 
                [-71.0886966775289, 42.3254294229816]
              ], 
              [
                [-71.088696079251, 42.3254207571058], 
                [-71.0887036619303, 42.3254680415047], 
                [-71.0888487191874, 42.3258123607832], 
                [-71.0889036376923, 42.3259380369999], 
                [-71.0889390537724, 42.3259724863553], 
                [-71.0893129209155, 42.3262005828514]
              ], 
              [
                [-71.0880302102331, 42.3254239251185], 
                [-71.0882530669838, 42.3254257057142], 
                [-71.0883932158462, 42.3254233592596], 
                [-71.0885507390245, 42.3254054018724], 
                [-71.088690588748, 42.32542866319], 
                [-71.0886966775289, 42.3254294229816]
              ], 
              [
                [-71.0886966775289, 42.3254294229816], 
                [-71.0887042602083, 42.325476707374], 
                [-71.0888493174654, 42.3258210272693], 
                [-71.0889042359703, 42.3259467028044], 
                [-71.0889396529487, 42.3259811528192], 
                [-71.0893071258836, 42.3262053480944]
              ], 
              [
                [-71.0895472491523, 42.3254514967842], 
                [-71.0895716905146, 42.3254992759539], 
                [-71.08964723883, 42.3256008308103], 
                [-71.0896875058126, 42.3256465529902], 
                [-71.0897175625437, 42.3257186837575]
              ], 
              [
                [-71.0895472491523, 42.3254514967842], 
                [-71.0895472006433, 42.3254588994364], 
                [-71.0895722896909, 42.3255079418188], 
                [-71.089647837108, 42.3256094966613], 
                [-71.0896881049889, 42.3256552188348], 
                [-71.0897169283331, 42.3257243908022]
              ], 
              [
                [-71.0897175625437, 42.3257186837575], 
                [-71.0897169283331, 42.3257243908022]
              ], 
              [
                [-71.0897169283331, 42.3257243908022], 
                [-71.08971816172, 42.3257273495922]
              ], 
              [
                [-71.0897169283331, 42.3257243908022], 
                [-71.0897121277362, 42.325767617681], 
                [-71.0896853256014, 42.3258372962706], 
                [-71.0896350172505, 42.3259068857872], 
                [-71.0895534636975, 42.3259707403107], 
                [-71.0893129209155, 42.3262005828514]
              ], 
              [
                [-71.08971816172, 42.3257273495922], 
                [-71.0897127269125, 42.3257762835089], 
                [-71.0896859238794, 42.325845962089], 
                [-71.0896356155285, 42.325915551596], 
                [-71.0895540628738, 42.3259794067748], 
                [-71.0893186647435, 42.3262043332803]
              ], 
              [
                [-71.0946104065202, 42.325742797064], 
                [-71.0940073701649, 42.3254498735936], 
                [-71.0934003641544, 42.3251550193849], 
                [-71.0932560884316, 42.3251131111008]
              ], 
              [
                [-71.0946104065202, 42.325742797064], 
                [-71.0946047812699, 42.3257484390198]
              ], 
              [
                [-71.0946047812699, 42.3257484390198], 
                [-71.0940079702395, 42.3254585388012], 
                [-71.093400964229, 42.3251636852973], 
                [-71.093255836005, 42.3251215292885]
              ], 
              [
                [-71.0946047812699, 42.3257484390198], 
                [-71.0942319642573, 42.3261223730425], 
                [-71.0942381635311, 42.326125423466]
              ], 
              [
                [-71.0946110074932, 42.3257514628954], 
                [-71.0946047812699, 42.3257484390198]
              ], 
              [
                [-71.0946110074932, 42.3257514628954], 
                [-71.0942381635311, 42.326125423466]
              ], 
              [
                [-71.0917975397188, 42.3259809854539], 
                [-71.0917940883915, 42.3259837170934]
              ], 
              [
                [-71.0917975397188, 42.3259809854539], 
                [-71.0919002710547, 42.3261304603504], 
                [-71.0921310958619, 42.3265240327759], 
                [-71.0922557272261, 42.3266589570569], 
                [-71.0923380542287, 42.3267098893104], 
                [-71.0924087794893, 42.3267365890612], 
                [-71.0925658301538, 42.3267827201896], 
                [-71.0929053061946, 42.3268784557877]
              ], 
              [
                [-71.0917940883915, 42.3259837170934], 
                [-71.0917981397934, 42.3259896512526]
              ], 
              [
                [-71.0917940883915, 42.3259837170934], 
                [-71.0914875248261, 42.3262263370758], 
                [-71.0909875620648, 42.3266173127744]
              ], 
              [
                [-71.0917981397934, 42.3259896512526], 
                [-71.0914881249007, 42.3262350028406], 
                [-71.0909881612411, 42.3266259791495]
              ], 
              [
                [-71.0917981397934, 42.3259896512526], 
                [-71.091900870231, 42.3261391261284], 
                [-71.0921316959365, 42.3265326984997], 
                [-71.0922563273007, 42.3266676234262], 
                [-71.0923386543033, 42.3267185550086], 
                [-71.0924093795639, 42.3267452547558], 
                [-71.0925664302284, 42.3267913865419], 
                [-71.0929019051729, 42.3268859937561]
              ], 
              [
                [-71.0953083696482, 42.3261042458334], 
                [-71.0946104065202, 42.325742797064]
              ], 
              [
                [-71.0953083696482, 42.3261042458334], 
                [-71.0953143416482, 42.3261073115331]
              ], 
              [
                [-71.0953143416482, 42.3261073115331], 
                [-71.0953089697228, 42.326112911615]
              ], 
              [
                [-71.0953143416482, 42.3261073115331], 
                [-71.095864645998, 42.3263897982506], 
                [-71.0959709607136, 42.3264543184191], 
                [-71.0960163822293, 42.3264961135697], 
                [-71.0960262699856, 42.3265140122011], 
                [-71.0960287439459, 42.3265184871902], 
                [-71.0960413068852, 42.3265412194394], 
                [-71.0960614138762, 42.3265981204254], 
                [-71.0960614408256, 42.3266051616499]
              ], 
              [
                [-71.0953089697228, 42.326112911615], 
                [-71.0946110074932, 42.3257514628954]
              ], 
              [
                [-71.0953089697228, 42.326112911615], 
                [-71.0958652469709, 42.3263984639928], 
                [-71.0959715616865, 42.3264629841524], 
                [-71.0960169832022, 42.3265047792973], 
                [-71.0960268709585, 42.3265226779263], 
                [-71.0960293449188, 42.3265271529148], 
                [-71.0960419078581, 42.326549885825], 
                [-71.0960614408256, 42.3266051616499]
              ], 
              [
                [-71.0942381635311, 42.326125423466], 
                [-71.0949760531802, 42.3264885177741], 
                [-71.095901529027, 42.326996502926]
              ], 
              [
                [-71.0942381635311, 42.326125423466], 
                [-71.0942325643319, 42.3261310388217], 
                [-71.0949766541531, 42.3264971835029], 
                [-71.0958980723097, 42.3270029417337]
              ], 
              [
                [-71.0893129209155, 42.3262005828514], 
                [-71.0893071258836, 42.3262053480944]
              ], 
              [
                [-71.0965227050628, 42.3262024836355], 
                [-71.096348763376, 42.3265756877246]
              ], 
              [
                [-71.0965276278305, 42.3262032493951], 
                [-71.0965227050628, 42.3262024836355]
              ], 
              [
                [-71.0965276278305, 42.3262032493951], 
                [-71.0965233060357, 42.3262111494036]
              ], 
              [
                [-71.0893186647435, 42.3262043332803], 
                [-71.0893129209155, 42.3262005828514]
              ], 
              [
                [-71.0893186647435, 42.3262043332803], 
                [-71.0893135200918, 42.326209249284]
              ], 
              [
                [-71.0893071258836, 42.3262053480944], 
                [-71.0893135200918, 42.326209249284]
              ], 
              [
                [-71.0893071258836, 42.3262053480944], 
                [-71.089002265524, 42.3264560571446], 
                [-71.0888436535875, 42.3265922221873]
              ], 
              [
                [-71.0893135200918, 42.326209249284], 
                [-71.0890028647003, 42.3264647228778], 
                [-71.0888500127614, 42.3265959420423]
              ], 
              [
                [-71.0965233060357, 42.3262111494036], 
                [-71.0963361007237, 42.3266128105626]
              ], 
              [
                [-71.0978154634016, 42.3262812877542], 
                [-71.0972328682106, 42.3262578686853], 
                [-71.096718906104, 42.3262329957943], 
                [-71.0965276278305, 42.3262032493951]
              ], 
              [
                [-71.0978160643745, 42.3262899535114], 
                [-71.0972334700819, 42.3262665344458], 
                [-71.0967195070769, 42.3262416608941], 
                [-71.0965233060357, 42.3262111494036]
              ], 
              [
                [-71.096348763376, 42.3265756877246], 
                [-71.0963354997508, 42.3266041448498]
              ], 
              [
                [-71.096348763376, 42.3265756877246], 
                [-71.0963361007237, 42.3266128105626]
              ], 
              [
                [-71.0888436535875, 42.3265922221873], 
                [-71.0886312235824, 42.3264631707765], 
                [-71.0884239804497, 42.3263527071598], 
                [-71.0882567958905, 42.3262918994545], 
                [-71.0881048171141, 42.3262536533583], 
                [-71.0879730297704, 42.3262301107482], 
                [-71.0876950407158, 42.3261835395503]
              ], 
              [
                [-71.0888500127614, 42.3265959420423], 
                [-71.0888436535875, 42.3265922221873]
              ], 
              [
                [-71.0888500127614, 42.3265959420423], 
                [-71.0888442518655, 42.3266008879016]
              ], 
              [
                [-71.0888442518655, 42.3266008879016], 
                [-71.0886318227587, 42.3264718365087], 
                [-71.0884245787277, 42.3263613729073], 
                [-71.0882573950668, 42.3263005652103], 
                [-71.0881054153921, 42.3262623191194], 
                [-71.0879736280483, 42.3262387771766], 
                [-71.0876956380955, 42.326192205321]
              ], 
              [
                [-71.0963354997508, 42.3266041448498], 
                [-71.0961702133318, 42.3268984111458], 
                [-71.0959691362352, 42.3272150600644], 
                [-71.0958397734444, 42.3274346133061], 
                [-71.0956678448822, 42.3276697748279]
              ], 
              [
                [-71.0960614408256, 42.3266051616499], 
                [-71.0960617004387, 42.326672957138], 
                [-71.0960349863388, 42.3267589546266], 
                [-71.095901529027, 42.326996502926]
              ], 
              [
                [-71.0960614408256, 42.3266051616499], 
                [-71.0960620148491, 42.326606786139], 
                [-71.0960623014117, 42.3266816228413], 
                [-71.0960355873117, 42.326767620318], 
                [-71.0959021299999, 42.3270051685847]
              ], 
              [
                [-71.0963361007237, 42.3266128105626], 
                [-71.0961708143047, 42.3269070768181], 
                [-71.0959697372082, 42.327223725693], 
                [-71.0958403744173, 42.3274432789045], 
                [-71.0956733219105, 42.3276717718664]
              ], 
              [
                [-71.0909875620648, 42.3266173127744], 
                [-71.0906377374319, 42.3263628625815], 
                [-71.0905842571298, 42.3263075294274], 
                [-71.0905320138078, 42.3262375677686], 
                [-71.090471815904, 42.3261355058683], 
                [-71.0903861525585, 42.3260446101074], 
                [-71.0902400891882, 42.3259416798524], 
                [-71.0900426763197, 42.3258351922458], 
                [-71.0898854846198, 42.3257823046913], 
                [-71.0897175625437, 42.3257186837575]
              ], 
              [
                [-71.0909875620648, 42.3266173127744], 
                [-71.090982046409, 42.3266215313978]
              ], 
              [
                [-71.090982046409, 42.3266215313978], 
                [-71.0906383366082, 42.3263715283275], 
                [-71.0905848563061, 42.3263161958451], 
                [-71.0905326129841, 42.326246234196], 
                [-71.0904724150803, 42.3261441716456], 
                [-71.0903867517348, 42.3260532758972], 
                [-71.0902406874662, 42.3259503456565], 
                [-71.0900432745977, 42.3258438580645], 
                [-71.089886083796, 42.3257909705173], 
                [-71.08971816172, 42.3257273495922]
              ], 
              [
                [-71.090982046409, 42.3266215313978], 
                [-71.090629124385, 42.326891436368]
              ], 
              [
                [-71.0909881612411, 42.3266259791495], 
                [-71.090982046409, 42.3266215313978]
              ], 
              [
                [-71.0909881612411, 42.3266259791495], 
                [-71.0906410135878, 42.3268914675825]
              ], 
              [
                [-71.0929053061946, 42.3268784557877], 
                [-71.0929019051729, 42.3268859937561]
              ], 
              [
                [-71.0929091689503, 42.3268795615779], 
                [-71.0929053061946, 42.3268784557877]
              ], 
              [
                [-71.0929091689503, 42.3268795615779], 
                [-71.0929059062692, 42.3268871221268]
              ], 
              [
                [-71.0929019051729, 42.3268859937561], 
                [-71.0929059062692, 42.3268871221268]
              ], 
              [
                [-71.0929019051729, 42.3268859937561], 
                [-71.0927339534525, 42.3272582241544], 
                [-71.09255921496, 42.3276627350509]
              ], 
              [
                [-71.0929059062692, 42.3268871221268], 
                [-71.0927345535271, 42.3272668904412], 
                [-71.0925598150346, 42.327671401282]
              ], 
              [
                [-71.090629124385, 42.326891436368], 
                [-71.0905698822886, 42.3268894784889], 
                [-71.0905021052988, 42.3268681038643], 
                [-71.0903496477203, 42.3267641535103], 
                [-71.0902537130379, 42.3267069803771], 
                [-71.090162595122, 42.3266678306381], 
                [-71.089934626059, 42.3265955561762], 
                [-71.0898586420607, 42.3265609623792], 
                [-71.089585889286, 42.3263788033559], 
                [-71.0893186647435, 42.3262043332803]
              ], 
              [
                [-71.090629124385, 42.326891436368], 
                [-71.0906188521497, 42.3268997427426]
              ], 
              [
                [-71.0906410135878, 42.3268914675825], 
                [-71.090629124385, 42.326891436368]
              ], 
              [
                [-71.0906410135878, 42.3268914675825], 
                [-71.0906297235613, 42.3269001020412]
              ], 
              [
                [-71.0906188521497, 42.3268997427426], 
                [-71.0905704814649, 42.3268981448265], 
                [-71.0905027044751, 42.3268767695408], 
                [-71.0903502468966, 42.3267728198652], 
                [-71.0902543122141, 42.3267156467398], 
                [-71.0901631942983, 42.3266764963421], 
                [-71.089935224337, 42.3266042225543], 
                [-71.089859241237, 42.3265696287621], 
                [-71.0895864884623, 42.3263874697638], 
                [-71.0893135200918, 42.326209249284]
              ], 
              [
                [-71.0906188521497, 42.3268997427426], 
                [-71.0903959441951, 42.3270799868814], 
                [-71.0902225792267, 42.3272115985944], 
                [-71.0901024331507, 42.3273220195266]
              ], 
              [
                [-71.0906297235613, 42.3269001020412], 
                [-71.0906188521497, 42.3268997427426]
              ], 
              [
                [-71.0906297235613, 42.3269001020412], 
                [-71.0903965433714, 42.3270886531928], 
                [-71.090223178403, 42.3272202642235], 
                [-71.0901090016321, 42.3273252000621]
              ], 
              [
                [-71.095901529027, 42.326996502926], 
                [-71.0958980723097, 42.3270029417337]
              ], 
              [
                [-71.0958980723097, 42.3270029417337], 
                [-71.0959021299999, 42.3270051685847]
              ], 
              [
                [-71.0958980723097, 42.3270029417337], 
                [-71.0957833457698, 42.3272166566441], 
                [-71.0956855030657, 42.3274278843168], 
                [-71.0956325410915, 42.3275738704165], 
                [-71.0956344275536, 42.3275789941861]
              ], 
              [
                [-71.0959021299999, 42.3270051685847], 
                [-71.0957839467428, 42.3272253229366], 
                [-71.0956861040387, 42.3274365505802], 
                [-71.0956344275536, 42.3275789941861]
              ], 
              [
                [-71.0901024331507, 42.3273220195266], 
                [-71.0897385193409, 42.3271057732884], 
                [-71.0891620659315, 42.3267784829811], 
                [-71.0888500127614, 42.3265959420423]
              ], 
              [
                [-71.0901024331507, 42.3273220195266], 
                [-71.0900971896844, 42.3273272137148]
              ], 
              [
                [-71.0901090016321, 42.3273252000621], 
                [-71.0901024331507, 42.3273220195266]
              ], 
              [
                [-71.0901090016321, 42.3273252000621], 
                [-71.0901030323271, 42.3273306858046]
              ], 
              [
                [-71.0900971896844, 42.3273272137148], 
                [-71.0897391185172, 42.3271144395962], 
                [-71.0891626651079, 42.3267871486699], 
                [-71.0888442518655, 42.3266008879016]
              ], 
              [
                [-71.0900971896844, 42.3273272137148], 
                [-71.0899671567504, 42.3274560209448], 
                [-71.0899159914068, 42.3275407986822], 
                [-71.0898263575077, 42.3277402323266]
              ], 
              [
                [-71.0901030323271, 42.3273306858046], 
                [-71.0900971896844, 42.3273272137148]
              ], 
              [
                [-71.0901030323271, 42.3273306858046], 
                [-71.0899677550284, 42.3274646865402], 
                [-71.0899165905831, 42.32754946493], 
                [-71.0898300612617, 42.327741988284]
              ], 
              [
                [-71.0956344275536, 42.3275789941861], 
                [-71.0956331420644, 42.3275825359957], 
                [-71.0956648463058, 42.3276686637386]
              ], 
              [
                [-71.0956344275536, 42.3275789941861], 
                [-71.0956678448822, 42.3276697748279]
              ], 
              [
                [-71.09255921496, 42.3276627350509], 
                [-71.0918249832508, 42.3273990476802], 
                [-71.0913796461436, 42.3271977122002], 
                [-71.0909750233801, 42.3270032744663], 
                [-71.0907560949622, 42.3268917684371], 
                [-71.0906410135878, 42.3268914675825]
              ], 
              [
                [-71.09255921496, 42.3276627350509], 
                [-71.092556596371, 42.3276702450319]
              ], 
              [
                [-71.0956648463058, 42.3276686637386], 
                [-71.0952969655357, 42.3275322991301], 
                [-71.0946026307031, 42.3273370707833], 
                [-71.0944255350314, 42.3272872760348], 
                [-71.0936383593142, 42.3270808934271], 
                [-71.0933312612512, 42.3270003761727], 
                [-71.0929091689503, 42.3268795615779]
              ], 
              [
                [-71.0956648463058, 42.3276686637386], 
                [-71.0956662656439, 42.3276725176842]
              ], 
              [
                [-71.0956678448822, 42.3276697748279], 
                [-71.0956648463058, 42.3276686637386]
              ], 
              [
                [-71.0956678448822, 42.3276697748279], 
                [-71.0956662656439, 42.3276725176842]
              ], 
              [
                [-71.092556596371, 42.3276702450319], 
                [-71.0918255824271, 42.3274077139476], 
                [-71.0913802453199, 42.3272063784953], 
                [-71.0909756225564, 42.3270119401241], 
                [-71.0907566941385, 42.3269004347744], 
                [-71.0906297235613, 42.3269001020412]
              ], 
              [
                [-71.092556596371, 42.3276702450319], 
                [-71.0925062996982, 42.3278144726215]
              ], 
              [
                [-71.0925598150346, 42.327671401282], 
                [-71.092556596371, 42.3276702450319]
              ], 
              [
                [-71.0925598150346, 42.327671401282], 
                [-71.0925096674822, 42.3278152018344]
              ], 
              [
                [-71.0956733219105, 42.3276717718664], 
                [-71.0956678448822, 42.3276697748279]
              ], 
              [
                [-71.0956733219105, 42.3276717718664], 
                [-71.0956684458551, 42.327678441058]
              ], 
              [
                [-71.0956662656439, 42.3276725176842], 
                [-71.095663838396, 42.3276767329162]
              ], 
              [
                [-71.0956662656439, 42.3276725176842], 
                [-71.0956684458551, 42.327678441058]
              ], 
              [
                [-71.095663838396, 42.3276767329162], 
                [-71.0952975665086, 42.3275409653791], 
                [-71.0946032307777, 42.3273457363951], 
                [-71.0944261360043, 42.3272959423176], 
                [-71.0936389593888, 42.3270895597384], 
                [-71.0933318613258, 42.3270090424951], 
                [-71.0929059062692, 42.3268871221268]
              ], 
              [
                [-71.095663838396, 42.3276767329162], 
                [-71.0953302490153, 42.3282560274276], 
                [-71.0952010434296, 42.3284502653735], 
                [-71.0950507642658, 42.3286185416158], 
                [-71.0949821446562, 42.3286866437495]
              ], 
              [
                [-71.0956684458551, 42.327678441058], 
                [-71.095663838396, 42.3276767329162]
              ], 
              [
                [-71.0956684458551, 42.327678441058], 
                [-71.0953308499882, 42.3282646935769], 
                [-71.0952016444026, 42.3284589321602], 
                [-71.0950513652387, 42.3286272077152], 
                [-71.0949827456291, 42.3286953098395]
              ], 
              [
                [-71.0898263575077, 42.3277402323266], 
                [-71.0897555073813, 42.3280241375904], 
                [-71.0897240115491, 42.3281748256366]
              ], 
              [
                [-71.0898300612617, 42.327741988284], 
                [-71.0898263575077, 42.3277402323266]
              ], 
              [
                [-71.0898300612617, 42.327741988284], 
                [-71.0898269557857, 42.327748898547]
              ], 
              [
                [-71.0898269557857, 42.327748898547], 
                [-71.0897561065576, 42.3280328037717], 
                [-71.0897262025401, 42.3281758756175]
              ], 
              [
                [-71.0925062996982, 42.3278144726215], 
                [-71.0923733966469, 42.3280801546122], 
                [-71.092276272595, 42.3282660576868]
              ], 
              [
                [-71.0925096674822, 42.3278152018344], 
                [-71.0925062996982, 42.3278144726215]
              ], 
              [
                [-71.0925096674822, 42.3278152018344], 
                [-71.0925068997728, 42.3278231388317]
              ], 
              [
                [-71.0925068997728, 42.3278231388317], 
                [-71.0923739967215, 42.3280888207858], 
                [-71.0922806869163, 42.3282674237889]
              ], 
              [
                [-71.0927546775861, 42.3278682470705], 
                [-71.0925096674822, 42.3278152018344]
              ], 
              [
                [-71.0927546775861, 42.3278682470705], 
                [-71.0927514184982, 42.3278760778007]
              ], 
              [
                [-71.0927514184982, 42.3278760778007], 
                [-71.0925068997728, 42.3278231388317]
              ], 
              [
                [-71.0927514184982, 42.3278760778007], 
                [-71.0926412616882, 42.3281407474049], 
                [-71.0925592239432, 42.3282800036162], 
                [-71.092513077487, 42.3283518643867]
              ], 
              [
                [-71.0927552776607, 42.3278769132733], 
                [-71.0927514184982, 42.3278760778007]
              ], 
              [
                [-71.0927552776607, 42.3278769132733], 
                [-71.0926418617628, 42.3281494135701], 
                [-71.0925598240178, 42.3282886697622], 
                [-71.0925159305364, 42.3283570226273]
              ], 
              [
                [-71.0969952054275, 42.3281538439466], 
                [-71.0956733219105, 42.3276717718664]
              ], 
              [
                [-71.0969958064004, 42.32816251011], 
                [-71.0956684458551, 42.327678441058]
              ], 
              [
                [-71.0897240115491, 42.3281748256366], 
                [-71.0897084257789, 42.3282389156144], 
                [-71.0896571095183, 42.328318073152], 
                [-71.0895242307215, 42.3284610812575], 
                [-71.0892270042451, 42.3287486764309]
              ], 
              [
                [-71.0897262025401, 42.3281758756175], 
                [-71.0897240115491, 42.3281748256366]
              ], 
              [
                [-71.0897262025401, 42.3281758756175], 
                [-71.0897246107254, 42.3281834917971]
              ], 
              [
                [-71.0897246107254, 42.3281834917971], 
                [-71.0897090249552, 42.3282475824303], 
                [-71.0896577086946, 42.3283267392928], 
                [-71.0895248298978, 42.3284697473786], 
                [-71.0892327732259, 42.3287523403725]
              ], 
              [
                [-71.092276272595, 42.3282660576868], 
                [-71.0918147155071, 42.3281096822909], 
                [-71.0913542965846, 42.3279229193736], 
                [-71.0909291194691, 42.3277402256853], 
                [-71.0903857186722, 42.3274591981529], 
                [-71.0901090016321, 42.3273252000621]
              ], 
              [
                [-71.092276272595, 42.3282660576868], 
                [-71.0922716534578, 42.328272955938]
              ], 
              [
                [-71.0922806869163, 42.3282674237889], 
                [-71.092276272595, 42.3282660576868]
              ], 
              [
                [-71.0922806869163, 42.3282674237889], 
                [-71.0922768726696, 42.3282747238347]
              ], 
              [
                [-71.0922716534578, 42.328272955938], 
                [-71.0918153155817, 42.3281183484604], 
                [-71.0913548957609, 42.3279315855689], 
                [-71.0909297186454, 42.3277488919057], 
                [-71.0903863178485, 42.327467864412], 
                [-71.0901030323271, 42.3273306858046]
              ], 
              [
                [-71.0922716534578, 42.328272955938], 
                [-71.0921516636887, 42.328452157456]
              ], 
              [
                [-71.0922768726696, 42.3282747238347], 
                [-71.0922716534578, 42.328272955938]
              ], 
              [
                [-71.0922768726696, 42.3282747238347], 
                [-71.0921586148524, 42.3284513385941]
              ], 
              [
                [-71.0946344598103, 42.3283509200043], 
                [-71.0944013919098, 42.3282746999263], 
                [-71.0938847537219, 42.3281327692719], 
                [-71.0932208843539, 42.3279796225283], 
                [-71.0927546775861, 42.3278682470705]
              ], 
              [
                [-71.0946344598103, 42.3283509200043], 
                [-71.0946284428945, 42.328357421765]
              ], 
              [
                [-71.0946344598103, 42.3283509200043], 
                [-71.0947484425451, 42.3284095633379], 
                [-71.0948114602606, 42.3284500156638], 
                [-71.0948619536644, 42.3284991493555], 
                [-71.0948779140321, 42.328532968386], 
                [-71.0949821446562, 42.3286866437495]
              ], 
              [
                [-71.092513077487, 42.3283518643867], 
                [-71.0924675589533, 42.3283252529857], 
                [-71.0922806869163, 42.3282674237889]
              ], 
              [
                [-71.092513077487, 42.3283518643867], 
                [-71.0925044258125, 42.3283551219083]
              ], 
              [
                [-71.092513077487, 42.3283518643867], 
                [-71.0925159305364, 42.3283570226273]
              ], 
              [
                [-71.0925044258125, 42.3283551219083], 
                [-71.0924681590279, 42.3283339197896], 
                [-71.0922768726696, 42.3282747238347]
              ], 
              [
                [-71.0925044258125, 42.3283551219083], 
                [-71.0924450956813, 42.3283774590051], 
                [-71.0923503728261, 42.3284248175557], 
                [-71.0921700036935, 42.3284499970684], 
                [-71.0921586148524, 42.3284513385941]
              ], 
              [
                [-71.0925159305364, 42.3283570226273], 
                [-71.0925136775617, 42.3283605305229]
              ], 
              [
                [-71.0925159305364, 42.3283570226273], 
                [-71.0931595662509, 42.3295208435781], 
                [-71.0932392504099, 42.3296649228131]
              ], 
              [
                [-71.0946284428945, 42.328357421765], 
                [-71.0944019919844, 42.328283366073], 
                [-71.0938853537965, 42.3281414354383], 
                [-71.0932214844285, 42.3279882887158], 
                [-71.0927552776607, 42.3278769132733]
              ], 
              [
                [-71.0946284428945, 42.328357421765], 
                [-71.0945680267001, 42.3284227102968], 
                [-71.0945322611753, 42.3284715405064], 
                [-71.0945218083787, 42.32850526259], 
                [-71.0945233229383, 42.3285109813362]
              ], 
              [
                [-71.0946350607832, 42.3283595861405], 
                [-71.0946284428945, 42.328357421765]
              ], 
              [
                [-71.0946350607832, 42.3283595861405], 
                [-71.094568627673, 42.3284313764232], 
                [-71.0945328621483, 42.328480206626], 
                [-71.0945233229383, 42.3285109813362]
              ], 
              [
                [-71.0946350607832, 42.3283595861405], 
                [-71.094749043518, 42.3284182294661], 
                [-71.0948120603352, 42.3284586817864], 
                [-71.0948625546373, 42.3285078154713], 
                [-71.094878515005, 42.3285416344971], 
                [-71.0949752509847, 42.3286842602258]
              ], 
              [
                [-71.0925136775617, 42.3283605305229], 
                [-71.0925044258125, 42.3283551219083]
              ], 
              [
                [-71.0925136775617, 42.3283605305229], 
                [-71.0924456957559, 42.3283861251377], 
                [-71.0923509729008, 42.3284334836817], 
                [-71.0921706037681, 42.328458663191], 
                [-71.0921522637633, 42.3284608235783]
              ], 
              [
                [-71.0925136775617, 42.3283605305229], 
                [-71.0931601672239, 42.3295295102173], 
                [-71.0932355493509, 42.3296658120548]
              ], 
              [
                [-71.0921586148524, 42.3284513385941], 
                [-71.0921516636887, 42.328452157456]
              ], 
              [
                [-71.0921586148524, 42.3284513385941], 
                [-71.0921522637633, 42.3284608235783]
              ], 
              [
                [-71.0921516636887, 42.328452157456], 
                [-71.0919807250699, 42.3287074525909]
              ], 
              [
                [-71.0921522637633, 42.3284608235783], 
                [-71.0919813242462, 42.3287161186781]
              ], 
              [
                [-71.0903796819935, 42.3284793213523], 
                [-71.0901367631676, 42.3283726720107], 
                [-71.0897262025401, 42.3281758756175]
              ], 
              [
                [-71.0903796819935, 42.3284793213523], 
                [-71.0903734306175, 42.3284849803299]
              ], 
              [
                [-71.0903734306175, 42.3284849803299], 
                [-71.0901373623439, 42.3283813381439], 
                [-71.0897246107254, 42.3281834917971]
              ], 
              [
                [-71.0903734306175, 42.3284849803299], 
                [-71.0900682756104, 42.3287612442078], 
                [-71.0897414262892, 42.3290847447213]
              ], 
              [
                [-71.0903802811698, 42.328487988135], 
                [-71.0903734306175, 42.3284849803299]
              ], 
              [
                [-71.0903802811698, 42.328487988135], 
                [-71.0900688747867, 42.3287699109517], 
                [-71.0897460067988, 42.3290894698988]
              ], 
              [
                [-71.0945233229383, 42.3285109813362], 
                [-71.0945318030346, 42.3285429999292], 
                [-71.0945670358583, 42.3285774465298], 
                [-71.0946276469872, 42.3286153611457], 
                [-71.0947287460842, 42.3286370971218], 
                [-71.0947643849464, 42.3286372226404], 
                [-71.0948002079634, 42.3286384731777], 
                [-71.0948761533341, 42.3286499976448], 
                [-71.0949752509847, 42.3286842602258]
              ], 
              [
                [-71.0945233229383, 42.3285109813362], 
                [-71.0945224093516, 42.3285139287051], 
                [-71.0945324040075, 42.328551666039], 
                [-71.0945676359329, 42.328586113299], 
                [-71.0946282479601, 42.3286240272455], 
                [-71.0947293470571, 42.3286457632186], 
                [-71.0947649859194, 42.3286458887372], 
                [-71.0948008089363, 42.3286471399385], 
                [-71.0948767534087, 42.3286586637399], 
                [-71.09497589867, 42.3286929422551]
              ], 
              [
                [-71.0949752509847, 42.3286842602258], 
                [-71.0949821446562, 42.3286866437495]
              ], 
              [
                [-71.0949752509847, 42.3286842602258], 
                [-71.0949790113325, 42.3286898036283]
              ], 
              [
                [-71.0949821446562, 42.3286866437495], 
                [-71.0949790113325, 42.3286898036283]
              ], 
              [
                [-71.0949790113325, 42.3286898036283], 
                [-71.09497589867, 42.3286929422551]
              ], 
              [
                [-71.0949790113325, 42.3286898036283], 
                [-71.0949827456291, 42.3286953098395]
              ], 
              [
                [-71.09497589867, 42.3286929422551], 
                [-71.0949827456291, 42.3286953098395]
              ], 
              [
                [-71.09497589867, 42.3286929422551], 
                [-71.0948506178238, 42.3288192748423], 
                [-71.0946077232525, 42.3290035413436], 
                [-71.0945505427897, 42.3290506052197], 
                [-71.0943152506606, 42.3292028249097], 
                [-71.0943134163008, 42.3292039930857], 
                [-71.0940512205272, 42.3293712598538], 
                [-71.0938944977478, 42.3294500447284]
              ], 
              [
                [-71.0949827456291, 42.3286953098395], 
                [-71.0948512187968, 42.3288279409141], 
                [-71.0946083242254, 42.32901220739], 
                [-71.0945511437626, 42.3290592712597], 
                [-71.0943158516335, 42.3292114915927], 
                [-71.0943140163754, 42.3292126597685], 
                [-71.0940518206018, 42.3293799265137], 
                [-71.0938998022996, 42.3294563464781]
              ], 
              [
                [-71.0919807250699, 42.3287074525909], 
                [-71.0912127158076, 42.3283877595427], 
                [-71.0909444213716, 42.3282770808089], 
                [-71.0908279844394, 42.3282237722603], 
                [-71.0905092019895, 42.3280639592447], 
                [-71.0898300612617, 42.327741988284]
              ], 
              [
                [-71.0919807250699, 42.3287074525909], 
                [-71.0919763933936, 42.3287140658867]
              ], 
              [
                [-71.0919763933936, 42.3287140658867], 
                [-71.0912133149839, 42.328396426338], 
                [-71.0909450205479, 42.3282857476195], 
                [-71.090828584514, 42.3282324390782], 
                [-71.0905098011658, 42.3280726254205], 
                [-71.0898269557857, 42.327748898547]
              ], 
              [
                [-71.0919763933936, 42.3287140658867], 
                [-71.0918128029938, 42.3289638265427]
              ], 
              [
                [-71.0919813242462, 42.3287161186781], 
                [-71.0919763933936, 42.3287140658867]
              ], 
              [
                [-71.0919813242462, 42.3287161186781], 
                [-71.0918134030684, 42.3289724932586]
              ], 
              [
                [-71.0892270042451, 42.3287486764309], 
                [-71.088853054457, 42.3285014458863], 
                [-71.0882769019832, 42.3281257600965], 
                [-71.0881758495986, 42.328068568277], 
                [-71.0880644872494, 42.3280225888482], 
                [-71.0876743004125, 42.3279120316714], 
                [-71.0869955154175, 42.3277824284207]
              ], 
              [
                [-71.0892270042451, 42.3287486764309], 
                [-71.0892218227626, 42.3287535218392]
              ], 
              [
                [-71.0892327732259, 42.3287523403725], 
                [-71.0892270042451, 42.3287486764309]
              ], 
              [
                [-71.0892327732259, 42.3287523403725], 
                [-71.0892276025231, 42.3287573431765]
              ], 
              [
                [-71.0892218227626, 42.3287535218392], 
                [-71.0888536536333, 42.3285101120018], 
                [-71.0882775002612, 42.3281344262637], 
                [-71.0881764478765, 42.3280772344522], 
                [-71.0880650855274, 42.3280312550298], 
                [-71.0876748986905, 42.3279206978681], 
                [-71.0869961136955, 42.3277910946353]
              ], 
              [
                [-71.0892218227626, 42.3287535218392], 
                [-71.0885365258801, 42.3293944194242]
              ], 
              [
                [-71.0892276025231, 42.3287573431765], 
                [-71.0892218227626, 42.3287535218392]
              ], 
              [
                [-71.0892276025231, 42.3287573431765], 
                [-71.0885454542357, 42.3293952960516]
              ], 
              [
                [-71.0918128029938, 42.3289638265427], 
                [-71.0916101367775, 42.328906276198], 
                [-71.0907492623761, 42.3286123088506], 
                [-71.0903796819935, 42.3284793213523]
              ], 
              [
                [-71.0918128029938, 42.3289638265427], 
                [-71.0918083662146, 42.3289710627525]
              ], 
              [
                [-71.0918083662146, 42.3289710627525], 
                [-71.0916107359538, 42.3289149429219], 
                [-71.0907498624507, 42.3286209749509], 
                [-71.0903802811698, 42.328487988135]
              ], 
              [
                [-71.0918083662146, 42.3289710627525], 
                [-71.0912185000597, 42.3299331783683]
              ], 
              [
                [-71.0918134030684, 42.3289724932586], 
                [-71.0918083662146, 42.3289710627525]
              ], 
              [
                [-71.0918134030684, 42.3289724932586], 
                [-71.0912230877559, 42.329935338705]
              ], 
              [
                [-71.0897414262892, 42.3290847447213], 
                [-71.0895504237985, 42.3289540846213], 
                [-71.0892327732259, 42.3287523403725]
              ], 
              [
                [-71.0897414262892, 42.3290847447213], 
                [-71.0897460067988, 42.3290894698988]
              ], 
              [
                [-71.0897460067988, 42.3290894698988], 
                [-71.0897420254655, 42.3290934107564]
              ], 
              [
                [-71.0897460067988, 42.3290894698988], 
                [-71.0899642156662, 42.3293145539689], 
                [-71.0900953032223, 42.3294472494848], 
                [-71.0902207116293, 42.3296051257635]
              ], 
              [
                [-71.0897420254655, 42.3290934107564], 
                [-71.0895510220765, 42.3289627506744], 
                [-71.0892276025231, 42.3287573431765]
              ], 
              [
                [-71.0897420254655, 42.3290934107564], 
                [-71.0899648148425, 42.3293232199724], 
                [-71.0900959023986, 42.3294559161342], 
                [-71.0902133104097, 42.3296037205079]
              ], 
              [
                [-71.0867376279641, 42.329126878815], 
                [-71.0860672844378, 42.3290091185878]
              ], 
              [
                [-71.0867411673263, 42.3291274306942], 
                [-71.0867376279641, 42.329126878815]
              ], 
              [
                [-71.0867411673263, 42.3291274306942], 
                [-71.086738226242, 42.3291355455085]
              ], 
              [
                [-71.086738226242, 42.3291355455085], 
                [-71.0860678818175, 42.3290177852975]
              ], 
              [
                [-71.0885304317092, 42.3293935534225], 
                [-71.0884349425911, 42.329257543869], 
                [-71.0883064556577, 42.3291332948247], 
                [-71.0880943526394, 42.3289817350978], 
                [-71.0876950191562, 42.3287310347851], 
                [-71.0876140324401, 42.3287082355871], 
                [-71.0875226800639, 42.3287039726077], 
                [-71.0873551128224, 42.3287298154632], 
                [-71.0871667262258, 42.3288084782794], 
                [-71.0868356602127, 42.3289924120902], 
                [-71.0867642917583, 42.3290636159011], 
                [-71.0867411673263, 42.3291274306942]
              ], 
              [
                [-71.0885304317092, 42.3293935534225], 
                [-71.0878539329266, 42.329297455726], 
                [-71.087472838837, 42.3292414935814], 
                [-71.0867411673263, 42.3291274306942]
              ], 
              [
                [-71.0885365258801, 42.3293944194242], 
                [-71.0884343434148, 42.3292488771924], 
                [-71.0883058573798, 42.3291246287951], 
                [-71.0880937534631, 42.3289730683832], 
                [-71.0876944208782, 42.3287223687], 
                [-71.0876134341621, 42.3286995688348], 
                [-71.0875220817859, 42.3286953058548], 
                [-71.0873545145444, 42.3287211487138], 
                [-71.0871661279478, 42.3287998115409], 
                [-71.086835062833, 42.328983745377], 
                [-71.0867636943787, 42.3290549491977], 
                [-71.0867376279641, 42.329126878815]
              ], 
              [
                [-71.0885365258801, 42.3293944194242], 
                [-71.0885304317092, 42.3293935534225]
              ], 
              [
                [-71.0885454542357, 42.3293952960516], 
                [-71.0885365258801, 42.3293944194242]
              ], 
              [
                [-71.0885454542357, 42.3293952960516], 
                [-71.0885371241581, 42.3294030860808]
              ], 
              [
                [-71.0885371241581, 42.3294030860808], 
                [-71.0885304317092, 42.3293935534225]
              ], 
              [
                [-71.0885371241581, 42.3294030860808], 
                [-71.0878545312046, 42.3293061223959], 
                [-71.087473437115, 42.329250160259], 
                [-71.086738226242, 42.3291355455085]
              ], 
              [
                [-71.0889946442171, 42.3294393830883], 
                [-71.0885454542357, 42.3293952960516]
              ], 
              [
                [-71.0889946442171, 42.3294393830883], 
                [-71.08899375219, 42.3294479036342]
              ], 
              [
                [-71.08899375219, 42.3294479036342], 
                [-71.0885371241581, 42.3294030860808]
              ], 
              [
                [-71.08899375219, 42.3294479036342], 
                [-71.0889507875666, 42.3298584238988], 
                [-71.0888792035166, 42.3303707735403]
              ], 
              [
                [-71.0889952433934, 42.3294480497387], 
                [-71.08899375219, 42.3294479036342]
              ], 
              [
                [-71.0889952433934, 42.3294480497387], 
                [-71.0889513867429, 42.3298670911556], 
                [-71.0888810279949, 42.3303706692763]
              ], 
              [
                [-71.0938944977478, 42.3294500447284], 
                [-71.0938998022996, 42.3294563464781]
              ], 
              [
                [-71.0938944977478, 42.3294500447284], 
                [-71.093609487461, 42.3295497595993], 
                [-71.0932392504099, 42.3296649228131]
              ], 
              [
                [-71.0938998022996, 42.3294563464781], 
                [-71.0938950978224, 42.3294587113774]
              ], 
              [
                [-71.0938998022996, 42.3294563464781], 
                [-71.0941533877211, 42.3297576210445], 
                [-71.0945411095809, 42.3302575295469], 
                [-71.0945609093481, 42.3303037404419]
              ], 
              [
                [-71.0938950978224, 42.3294587113774], 
                [-71.0936100875356, 42.3295584262345], 
                [-71.0932398504845, 42.3296735894325]
              ], 
              [
                [-71.0938950978224, 42.3294587113774], 
                [-71.094153988694, 42.3297662876511], 
                [-71.0945417105538, 42.3302661967488], 
                [-71.094557609836, 42.330303304791]
              ], 
              [
                [-71.0902133104097, 42.3296037205079], 
                [-71.0901851347508, 42.3295983697778], 
                [-71.0899063461956, 42.3295557379175], 
                [-71.0892776018535, 42.3294820322944], 
                [-71.0889946442171, 42.3294393830883]
              ], 
              [
                [-71.0902133104097, 42.3296037205079], 
                [-71.0902213108056, 42.3296137923911]
              ], 
              [
                [-71.0902207116293, 42.3296051257635], 
                [-71.0902133104097, 42.3296037205079]
              ], 
              [
                [-71.091911953645, 42.3296077629421], 
                [-71.091937534071, 42.3299480403942]
              ], 
              [
                [-71.0902213108056, 42.3296137923911], 
                [-71.090185733927, 42.3296070364063], 
                [-71.0899069453719, 42.3295644045518], 
                [-71.0892782010298, 42.329490698939], 
                [-71.0889952433934, 42.3294480497387]
              ], 
              [
                [-71.0919125537196, 42.3296164295693], 
                [-71.0919374837654, 42.3299480496916]
              ], 
              [
                [-71.0932392504099, 42.3296649228131], 
                [-71.0932355493509, 42.3296658120548]
              ], 
              [
                [-71.0932355493509, 42.3296658120548], 
                [-71.0932398504845, 42.3296735894325]
              ], 
              [
                [-71.0932355493509, 42.3296658120548], 
                [-71.0928051952444, 42.3297691738633], 
                [-71.0924921045201, 42.3298417760683], 
                [-71.091937534071, 42.3299480403942]
              ], 
              [
                [-71.0932398504845, 42.3296735894325], 
                [-71.092805795319, 42.3297778404682], 
                [-71.0924927045947, 42.3298504426632], 
                [-71.0919381341457, 42.3299567069745]
              ], 
              [
                [-71.0909405559209, 42.3298430179482], 
                [-71.090694670858, 42.3297533900134], 
                [-71.0904385863233, 42.3296600449337], 
                [-71.0903271431258, 42.3296253259771], 
                [-71.0902207116293, 42.3296051257635]
              ], 
              [
                [-71.0909405559209, 42.3298430179482], 
                [-71.0909360239203, 42.329849813754]
              ], 
              [
                [-71.0909360239203, 42.329849813754], 
                [-71.0906952709326, 42.3297620566206], 
                [-71.0904391854996, 42.3296687115537], 
                [-71.0903277432004, 42.3296339926019], 
                [-71.0902213108056, 42.3296137923911]
              ], 
              [
                [-71.0909360239203, 42.329849813754], 
                [-71.0908567044774, 42.3299687571718], 
                [-71.090831573209, 42.3300440706864], 
                [-71.0908237785273, 42.3301638943381]
              ], 
              [
                [-71.0909411559956, 42.329851684543], 
                [-71.0909360239203, 42.329849813754]
              ], 
              [
                [-71.0909411559956, 42.329851684543], 
                [-71.0908573036537, 42.3299774244134], 
                [-71.0908321732836, 42.3300527372535], 
                [-71.0908249553203, 42.330163675848]
              ], 
              [
                [-71.094995589741, 42.3298793598611], 
                [-71.0950026064817, 42.3298837774977], 
                [-71.0950925709608, 42.3300267348922], 
                [-71.0950928224891, 42.3300348456058]
              ], 
              [
                [-71.0949961907139, 42.3298880264509], 
                [-71.0950032074546, 42.3298924434228], 
                [-71.0950928224891, 42.3300348456058]
              ], 
              [
                [-71.0912185000597, 42.3299331783683], 
                [-71.0910359022069, 42.3298737388631], 
                [-71.0909405559209, 42.3298430179482]
              ], 
              [
                [-71.0912230877559, 42.329935338705], 
                [-71.0912185000597, 42.3299331783683]
              ], 
              [
                [-71.0912230877559, 42.329935338705], 
                [-71.091219099236, 42.3299418449507]
              ], 
              [
                [-71.091219099236, 42.3299418449507], 
                [-71.0910365022815, 42.3298824054536], 
                [-71.0909411559956, 42.329851684543]
              ], 
              [
                [-71.091937534071, 42.3299480403942], 
                [-71.0919374837654, 42.3299480496916]
              ], 
              [
                [-71.0919374837654, 42.3299480496916], 
                [-71.0919381341457, 42.3299567069745]
              ], 
              [
                [-71.0919374837654, 42.3299480496916], 
                [-71.0915460868978, 42.3300184754178], 
                [-71.0914411286383, 42.3300372363834]
              ], 
              [
                [-71.0919381341457, 42.3299567069745], 
                [-71.0915466869724, 42.3300271419885], 
                [-71.0914550749831, 42.330043517487]
              ], 
              [
                [-71.0950928224891, 42.3300348456058], 
                [-71.0950954644343, 42.3301201113046], 
                [-71.0950601175245, 42.3301822282418], 
                [-71.0950038641231, 42.3302338994456], 
                [-71.0949369746687, 42.3303088739507], 
                [-71.0948737988497, 42.3303501465488], 
                [-71.094779390405, 42.3303550037875], 
                [-71.0945609093481, 42.3303037404419]
              ], 
              [
                [-71.0950928224891, 42.3300348456058], 
                [-71.0950931719337, 42.3300354014617], 
                [-71.0950960654072, 42.3301287778613], 
                [-71.0950607175991, 42.3301908947899], 
                [-71.095004465096, 42.3302425666506], 
                [-71.0949375756417, 42.3303175404813], 
                [-71.0948743998227, 42.3303588130737], 
                [-71.0947799913779, 42.3303636703118], 
                [-71.0945615094227, 42.3303124069732]
              ], 
              [
                [-71.0914411286383, 42.3300372363834], 
                [-71.0913347070232, 42.3299879006769], 
                [-71.0912230877559, 42.329935338705]
              ], 
              [
                [-71.0914288316004, 42.3300399246799], 
                [-71.0914411286383, 42.3300372363834]
              ], 
              [
                [-71.0914288316004, 42.3300399246799], 
                [-71.0913353070978, 42.3299965679158], 
                [-71.091219099236, 42.3299418449507]
              ], 
              [
                [-71.0914550749831, 42.330043517487], 
                [-71.0914411286383, 42.3300372363834]
              ], 
              [
                [-71.0914550749831, 42.330043517487], 
                [-71.0914417278146, 42.3300459029515]
              ], 
              [
                [-71.0914417278146, 42.3300459029515], 
                [-71.0914288316004, 42.3300399246799]
              ], 
              [
                [-71.0908249553203, 42.330163675848], 
                [-71.0910764189211, 42.3301169654439], 
                [-71.0914288316004, 42.3300399246799]
              ], 
              [
                [-71.0908249553203, 42.330163675848], 
                [-71.0908243777036, 42.3301725608886]
              ], 
              [
                [-71.0908237785273, 42.3301638943381], 
                [-71.0908249553203, 42.330163675848]
              ], 
              [
                [-71.0908243777036, 42.3301725608886], 
                [-71.0910770189957, 42.330125632001], 
                [-71.0914417278146, 42.3300459029515]
              ], 
              [
                [-71.0925438825148, 42.3301919467294], 
                [-71.0919329023574, 42.3301847173011], 
                [-71.0917907915744, 42.3301729566943], 
                [-71.09167927741, 42.3301494939153], 
                [-71.091623734576, 42.3301194737648], 
                [-71.0914550749831, 42.330043517487]
              ], 
              [
                [-71.0925438825148, 42.3301919467294], 
                [-71.0925450009173, 42.3302005966736]
              ], 
              [
                [-71.0925450009173, 42.3302005966736], 
                [-71.0925444825894, 42.3302006139403]
              ], 
              [
                [-71.0925450009173, 42.3302005966736], 
                [-71.0925536355238, 42.3302673841639], 
                [-71.0925534369961, 42.3302698705634]
              ], 
              [
                [-71.0925444825894, 42.3302006139403], 
                [-71.0919335015337, 42.3301933838489], 
                [-71.091791391649, 42.3301816232437], 
                [-71.0916798774846, 42.3301581604678], 
                [-71.0916243337523, 42.3301281403215], 
                [-71.0914417278146, 42.3300459029515]
              ], 
              [
                [-71.0925444825894, 42.3302006139403], 
                [-71.0925534369961, 42.3302698705634]
              ], 
              [
                [-71.0925534369961, 42.3302698705634], 
                [-71.0925542355984, 42.3302760507003], 
                [-71.092532309519, 42.3305500308432]
              ], 
              [
                [-71.0925534369961, 42.3302698705634], 
                [-71.092531577392, 42.3305430166243], 
                [-71.092532309519, 42.3305500308432]
              ], 
              [
                [-71.094557609836, 42.330303304791], 
                [-71.0941451187289, 42.3302488178491], 
                [-71.0937748987458, 42.3302137498992], 
                [-71.0930848839115, 42.3301736075157], 
                [-71.0925438825148, 42.3301919467294]
              ], 
              [
                [-71.094557609836, 42.330303304791], 
                [-71.0945596966224, 42.3303081766435]
              ], 
              [
                [-71.0945609093481, 42.3303037404419], 
                [-71.094557609836, 42.330303304791]
              ], 
              [
                [-71.0945609093481, 42.3303037404419], 
                [-71.0945596966224, 42.3303081766435]
              ], 
              [
                [-71.0945596966224, 42.3303081766435], 
                [-71.0945586437969, 42.3303120284351]
              ], 
              [
                [-71.0945596966224, 42.3303081766435], 
                [-71.0945615094227, 42.3303124069732]
              ], 
              [
                [-71.0945586437969, 42.3303120284351], 
                [-71.0941457197018, 42.330257484388], 
                [-71.0937754997187, 42.330222416443], 
                [-71.0930854839861, 42.3301822740649], 
                [-71.0925450009173, 42.3302005966736]
              ], 
              [
                [-71.0945586437969, 42.3303120284351], 
                [-71.0945506164516, 42.3303414016586], 
                [-71.0945095122391, 42.3304245365066], 
                [-71.0941767627831, 42.3308729457218], 
                [-71.0939160680944, 42.3311702455482], 
                [-71.0938058322326, 42.3313313463138]
              ], 
              [
                [-71.0945615094227, 42.3303124069732], 
                [-71.0945586437969, 42.3303120284351]
              ], 
              [
                [-71.0945615094227, 42.3303124069732], 
                [-71.0945512174245, 42.3303500681848], 
                [-71.094510113212, 42.3304332030213], 
                [-71.0941773628577, 42.3308816121747], 
                [-71.0939166690673, 42.3311789126242], 
                [-71.0938064332056, 42.3313400133676]
              ], 
              [
                [-71.0888810279949, 42.3303706692763], 
                [-71.0889715647008, 42.330365479324], 
                [-71.0895510247715, 42.3303230963577], 
                [-71.090340187562, 42.330246572518], 
                [-71.0905226156333, 42.3302153849209], 
                [-71.0908237785273, 42.3301638943381]
              ], 
              [
                [-71.0888810279949, 42.3303706692763], 
                [-71.0888798026929, 42.3303794400624]
              ], 
              [
                [-71.0888792035166, 42.3303707735403], 
                [-71.0888810279949, 42.3303706692763]
              ], 
              [
                [-71.0888798026929, 42.3303794400624], 
                [-71.0889721638771, 42.330374146511], 
                [-71.0895516239478, 42.3303317628863], 
                [-71.0903407867383, 42.3302552397213], 
                [-71.0905232148096, 42.3302240514644], 
                [-71.0908243777036, 42.3301725608886]
              ], 
              [
                [-71.092532309519, 42.3305500308432], 
                [-71.0925410393469, 42.3306336468869], 
                [-71.0925610286586, 42.3306792910299], 
                [-71.092626590403, 42.3307436693307], 
                [-71.0928280573684, 42.3309897156148], 
                [-71.0928833037583, 42.3310658752909], 
                [-71.0928931286326, 42.3311300559603], 
                [-71.0928930989882, 42.3311346056636]
              ], 
              [
                [-71.092532309519, 42.3305500308432], 
                [-71.0925321774666, 42.3305516831227], 
                [-71.0925416394215, 42.3306423133728], 
                [-71.0925616287332, 42.3306879581735], 
                [-71.0926271904776, 42.3307523364655], 
                [-71.092828657443, 42.3309983820516], 
                [-71.092883903833, 42.3310745417172], 
                [-71.0928930989882, 42.3311346056636]
              ], 
              [
                [-71.088188501471, 42.3306113836422], 
                [-71.0883382335609, 42.3305010700913], 
                [-71.0884670879052, 42.3304227540601], 
                [-71.088614389154, 42.330395150704], 
                [-71.0888792035166, 42.3303707735403]
              ], 
              [
                [-71.088189099749, 42.3306200501311], 
                [-71.0883388318389, 42.3305097365954], 
                [-71.0884676861832, 42.330431420575], 
                [-71.0886149883303, 42.3304038172227], 
                [-71.0888798026929, 42.3303794400624]
              ], 
              [
                [-71.0928930989882, 42.3311346056636], 
                [-71.0928937296055, 42.3311387223778], 
                [-71.0928934538227, 42.3311814979375]
              ], 
              [
                [-71.0928930989882, 42.3311346056636], 
                [-71.0928928393751, 42.3311750668625], 
                [-71.0928934538227, 42.3311814979375]
              ], 
              [
                [-71.0928934538227, 42.3311814979375], 
                [-71.0929022510243, 42.3312735690235]
              ], 
              [
                [-71.0928934538227, 42.3311814979375], 
                [-71.0928934394497, 42.3311837339379], 
                [-71.0929028510989, 42.3312822360853]
              ]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 51, 
            "OBJECTID" : null, 
            "Name" : "Highland Park Neighborhood Slow Streets", 
            "Shape_Leng" : null, 
            "Shape__Length" : 32455.59691095, 
            "Link" : "https://www.boston.gov/highland-park", 
            "GlobalID" : "b103c262-d29b-4bb3-b0ea-91ed0dd56288", 
            "CreationDa" : 1588809600000, 
            "Creator" : "153868_boston", 
            "EditDate" : 1605225600000, 
            "Editor" : "153868_boston", 
            "Symbol" : "Walking, Biking, Safety", 
            "Descriptio" : "We're implementing targeted interventions that slow speeds and improve safety", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 52, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.1327184426564, 42.3633629321033], 
              [-71.145421384551, 42.3616505923859]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 52, 
            "OBJECTID" : null, 
            "Name" : "Western Avenue Corridor Study and Rezoning", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "http://www.bostonplans.org/planning/planning-initiatives/western-avenue-corridor-study-and-rezoning", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Multimodal", 
            "Descriptio" : "We are  working with the Boston Planning and Development Agency to plan for multimodal transportation improvements and enhancements on Western Avenue in coordination with the Allston-Brighton mobility plan..", 
            "ProjectTyp" : "Multimodal"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 53, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0871607034434, 42.298248818312], 
              [-71.0915380685557, 42.2970425953392], 
              [-71.0947996347178, 42.2926619070745], 
              [-71.1054426400889, 42.2883444089263], 
              [-71.1141973703135, 42.2829471200777], 
              [-71.1157423227061, 42.2815500994009], 
              [-71.1166006295909, 42.2792004947713]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 53, 
            "OBJECTID" : null, 
            "Name" : "American Legion", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/departments/transportation/safer-slower-american-legion", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Bike Network", 
            "Descriptio" : "American Legion should be more comfortable for walking, waiting for the bus, crossing the street, and riding bikes with your family. We can make design changes in the coming year to improve safety for everyone..", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 55, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.120551763979, 42.2978187334186], 
              [-71.1204230179463, 42.2973267208463], 
              [-71.1202942719136, 42.2968347044298], 
              [-71.1203157295857, 42.2964379141971], 
              [-71.1207448830281, 42.2960411214643], 
              [-71.1221825470601, 42.2954062478916], 
              [-71.1228069150274, 42.2946735933541], 
              [-71.1233862721746, 42.2941498117451], 
              [-71.1234077298467, 42.2939752169074], 
              [-71.1232360684698, 42.2937847492598], 
              [-71.1248453938787, 42.2920070234381], 
              [-71.1261372127956, 42.290337197671], 
              [-71.1266307392543, 42.2897181399542], 
              [-71.1278109112209, 42.2887498579918], 
              [-71.1290983715481, 42.287956173152], 
              [-71.1301068821377, 42.2875434530833]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 55, 
            "OBJECTID" : null, 
            "Name" : "Arboretrum Link/Roslindale Gateway Path", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/departments/transportation/arboretum-link-roslindale-gateway-path", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Bike Network", 
            "Descriptio" : "The project also includes a new gateway from Washington Street to Bussey Brook Meadow through the tunnel at the end of Arboretum Road.", 
            "ProjectTyp" : "Green Links"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 57, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0921986991854, 42.3411824033446], 
              [-71.0932501251193, 42.3407858926572], 
              [-71.0932930404635, 42.3406907297201], 
              [-71.0923703605624, 42.3391522422522], 
              [-71.0922845298739, 42.3390412159271], 
              [-71.092477648923, 42.3389777722248], 
              [-71.0924991065951, 42.3388350236605], 
              [-71.0936578208895, 42.3369475399519], 
              [-71.0905250007601, 42.3357261967749], 
              [-71.0895594055147, 42.334568278093]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 57, 
            "OBJECTID" : null, 
            "Name" : "Roxbury to Fenway Connector", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/transportation/boston-green-links", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Bike Network", 
            "Descriptio" : "The Roxbury to Fenway Connector is a proposed Green Link that would include a path between the existing double row of trees on Ruggle Street between Ruggles Station and Parker Street.", 
            "ProjectTyp" : "Green Links"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 58, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0945698414699, 42.3454054315138], 
              [-71.1025950108427, 42.3432643879099], 
              [-71.1033889447111, 42.3425824105621]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 58, 
            "OBJECTID" : null, 
            "Name" : "Boylston Street", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/departments/transportation/boylston-street", 
            "GlobalID" : null, 
            "CreationDa" : null, 
            "Creator" : null, 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Bike Network", 
            "Descriptio" : "We’re making safety improvements to Boylston Street in the Fenway.", 
            "ProjectTyp" : "Walking, Biking, Safety"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 59, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0953188501507, 42.3315604020849], 
              [-71.0937871359921, 42.3313370437538], 
              [-71.0928342559448, 42.3312915404651], 
              [-71.0913844086265, 42.3312564717838], 
              [-71.0902024311094, 42.3311586206211], 
              [-71.088996841359, 42.3308969824571], 
              [-71.0877973780548, 42.3304817867741], 
              [-71.0868756762077, 42.3300118969752], 
              [-71.0859133358203, 42.3294534202434]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 59, 
            "OBJECTID" : null, 
            "Name" : "Malcolm X Blvd Multimodal Corridor", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/departments/transportation/roxbury-transportation-corridors", 
            "GlobalID" : null, 
            "CreationDa" : 1624909980000, 
            "Creator" : "163175_boston", 
            "EditDate" : null, 
            "Editor" : "163175_boston", 
            "Symbol" : "Multimodal", 
            "Descriptio" : "We want to make it safer, more convenient, and more enjoyable for you to get around Malcolm X Blvd, no matter how you travel.", 
            "ProjectTyp" : "Multimodal"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 60, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0984581241397, 42.3224298300112], 
              [-71.0986201310061, 42.324152906267], 
              [-71.0979096088448, 42.3262865881358], 
              [-71.0974572946559, 42.3274052315244], 
              [-71.0970801875063, 42.328195490237], 
              [-71.0959599673528, 42.3299656526923], 
              [-71.0945109289484, 42.3314529689843], 
              [-71.0937509076159, 42.3321359389929], 
              [-71.0923475087734, 42.332939150089], 
              [-71.0894874091714, 42.3344714130848]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 60, 
            "OBJECTID" : null, 
            "Name" : null, 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/departments/transportation/roxbury-transportation-corridors", 
            "GlobalID" : null, 
            "CreationDa" : 1624910094000, 
            "Creator" : "163175_boston", 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Bus Lane", 
            "Descriptio" : null, 
            "ProjectTyp" : "TransitPriority"
          }
        }, 
        {
          "type" : "Feature", 
          "id" : 61, 
          "geometry" : 
          {
            "type" : "LineString", 
            "coordinates" : 
            [
              [-71.0984975276333, 42.3227410468344], 
              [-71.0985692125003, 42.3240912421335], 
              [-71.0983516367994, 42.3249368493224], 
              [-71.0978817043167, 42.326297135242], 
              [-71.0970717423757, 42.3281826199801], 
              [-71.0958997326238, 42.3300350782329], 
              [-71.0945356463374, 42.3314000931472], 
              [-71.0936417296966, 42.3321866551694], 
              [-71.0923483950307, 42.3329261637092], 
              [-71.0895013775699, 42.3344833731249]
            ]
          }, 
          "properties" : {
            "OBJECTID_1" : 61, 
            "OBJECTID" : null, 
            "Name" : "Columbus/Tremont Multimodal Corridor (Jackson Square to Ruggles Station)", 
            "Shape_Leng" : null, 
            "Shape__Length" : null, 
            "Link" : "https://www.boston.gov/departments/transportation/roxbury-transportation-corridors", 
            "GlobalID" : null, 
            "CreationDa" : 1624910324000, 
            "Creator" : "163175_boston", 
            "EditDate" : null, 
            "Editor" : null, 
            "Symbol" : "Bus Lane", 
            "Descriptio" : "We are planning transit, bike, and pedestrian improvements along Columbus Avenue, between Jackson Square and Ruggles Station.", 
            "ProjectTyp" : "Multimodal"
          }
        }
      ]
    }
  )
}
